// AUTO GENERATED FROM ../Resources/_SourceFiles/SystemAdmin.en-US.txt
/* eslint 'no-template-curly-in-string': 'off','no-dupe-keys': 'off','no-useless-escape': 'off' */
export let resourceData = {
"ActionsAndSettings.UAText.Text":"Click links below to access frequently used actions and settings.",
"ActionsAndSettings.Alarms.GroupHeader.Text":"Alarms",
"ActionsAndSettings.Alarms.EmailRoutingLink.Text":"Alarm Actions",
"ActionsAndSettings.Alarms.EmailTemplateLink.Text":"Set Up E-mail Format",
"ActionsAndSettings.Alarms.PanelCommAlarms.Text":"Panel Communication Alarms",
"ActionsAndSettings.Alarms.EmailRoutingRule.Text":"Set Up E-mail Routing Rule",
"ActionsAndSettings.Alarms.EmailAddresses.Text":"E-mail Addresses",
"ActionsAndSettings.Alarms.PanelAlarmSubs.Text":"Panel Alarm Subscriptions",
"ActionsAndSettings.Alarms.PriorityMappings.Text":"Priority Mappings",
"ActionsAndSettings.Alarms.AlarmMessageTemp.Text":"Alarm Message Templates",
"ActionsAndSettings.Alarms.Notification.Text":"Manage Alarm Categories",
"ActionsAndSettings.Alarms.IgnoredAlarm.Text":"Ignored Alarm Rules",
"ActionsAndSettings.Dashboards.ManageDashboards.Text":"Dashboards",
"ActionsAndSettings.Graphics.GroupHeader.Text":"Appearance and Graphics",
"ActionsAndSettings.Graphics.ImportGraphicsLink.Text":"Import Graphics",
"ActionsAndSettings.Graphics.CustomizeHomePageLink.Text":"Customize Home Page",
"ActionsAndSettings.Graphics.CustomizeBuildingGroupLink.Text":"Customize Building Groups",
"ActionsAndSettings.Graphics.CustomGraphicsLink.Text":"Custom Graphics",
"ActionsAndSettings.Graphics.DefineHomePageCustomLink.Text":"Define Home Page Custom Links",
"ActionsAndSettings.Graphics.AddRemoveDataLink.Text":"Add/Remove Data Shown on Equipment or Subsystem Pages",
"ActionsAndSettings.Graphics.AssignGraphicLink.Text":"Assign Equipment Graphics",
"ActionsAndSettings.Buildings.GroupHeader.Text":"Buildings",
"ActionsAndSettings.Buildings.ChangeMultipleBuildings.Text":"Change Multiple Buildings",
"ActionsAndSettings.Buildings.GlobalChangeLink.Text":"Global Changes",
"ActionsAndSettings.Buildings.ManageBuildingsLink.Text":"Schedules",
"ActionsAndSettings.Buildings.BuildingInstallationLink.Text":"Installation",
"ActionsAndSettings.Buildings.GlobalPointControlLink.Text":"Global Point Control",
"ActionsAndSettings.Buildings.BuildingAttributes.Text":"Building Attributes",
"ActionsAndSettings.Buildings.VirtualBuildings.Text":"Virtual Buildings",
"ActionsAndSettings.Buildings.ChangeSetpoints.Text":"Change Setpoints",
"ActionsAndSettings.Buildings.ManagePivotAccounts.Text":"Manage Pivot Accounts",
"ActionsAndSettings.System.GroupHeader.Text":"System",
"ActionsAndSettings.System.ManageDBSizeLink.Text":"Database Size",
"ActionsAndSettings.System.SystemParamLink.Text":"System Parameters",
"ActionsAndSettings.System.ConfigureActiveDirectoryLink.Text":"Configure Network Authentication Service",
"ActionsAndSettings.System.SystemStatusLink.Text":"System Status",
"ActionsAndSettings.System.TracerEnsembleLicensingLink.Text":"Tracer Ensemble Licensing",
"ActionsAndSettings.System.TracerEnsembleCriticalControlLink.Text":"Critical Control",
"ActionsAndSettings.Buildings.GlobalOverridesLink.Text":"Global Overrides",
"ActionsAndSettings.System.IDPConfiguration.Text":"SAML 2.0 Configuration",
"ActionsAndSettings.LogsReports.GroupHeader.Text":"Logs and Reports",
"ActionsAndSettings.LogsReports.StandardReportsLink.Text":"Run Standard Report",
"ActionsAndSettings.LogsReports.DatalogAttrLink.Text":"Data Log Attributes",
"ActionsAndSettings.LogsReports.UserChangeLogLink.Text":"User Change Log",
"ActionsAndSettings.LogsReports.GlobalPointControlLink.Text":"Global Point Control Log",
"ActionsAndSettings.LogsReports.SystemTasksLink.Text":"System Tasks",
"ActionsAndSettings.LogsReports.InvalidLoginLogLink.Text":"Attempted Logins",
"ActionsAndSettings.UserRole.GroupHeader.Text":"Users and Roles",
"ActionsAndSettings.UserRole.NewUserLink.Text":"Add a New User",
"ActionsAndSettings.UserRole.UserProfileLink.Text":"User Profiles",
"ActionsAndSettings.UserRole.UserProfile.Text":"User Profile",
"ActionsAndSettings.UserRole.Text":"User Role",
"ActionsAndSettings.UserRole.UserRoleLink.Text":"User Roles",
"ActionsAndSettings.Schedules.GroupHeader.Text":"Schedules",
"ActionsAndSettings.Schedules.CreateExcepScheduleLink.Text":"Create Exception Schedule",
"ActionsAndSettings.Schedules.ExcepScheduleLink.Text":"Exception Schedules",
"ActionsAndSettings.Schedules.ScheduleAttribLink.Text":"Schedule Attributes",
"ActionsAndSettings.Schedules.ViewEmerScheduleLink.Text":"View Emergency Schedule",
"ActionsAndSettings.Schedules.EmerScheduleLink.Text":"Emergency Schedules",
"ActionsAndSettings.Schedules.ExcepTempLink.Text":"Exception Templates",
"ActionsAndSettings.Schedules.AllBuildingSchedules.Text":"Global Schedules",
"ActionsAndSettings.TroubleshootingManuals.GroupHeader.Text":"Documents",
"ActionsAndSettings.TroubleshootingManuals.UploadManuals.Text":"Import Support Files",
"ActionsAndSettings.TroubleshootingManuals.OpenLibrary.Text":"Support Files Library",
"ActionsAndSettings.ToastNotification.ErrorMessage.Text":"There was an error processing the request. Please try again.",
"ActionsAndSettings.ToastNotification.SuccessMessage.Text":"SAML setup has been successfully saved.",
"ActionsAndSettings.ToastNotification.SuccessMessageCount.Text":"SAML setup has been successfully saved and converted, users to Single Sign on.",
"ActionsAndSettings.ToastNotification.WarningMessage.Text":"Unable to convert users",
"ActionsAndSettings.ToastNotification.WarningMessageSAML.Text":"The following email addresses are already associated to an existing SAML User or to a Non SAML User:",
"Troubleshooting.UploadManualTHN.Text":"Support Files Library",
"UploadManual.TitleHeading.Text":"Troubleshooting Upload Manuals",
"UploadManual.UserAssistance.Text":"Upload the troubleshooting manuals.Click selection button to select single or multiples and save the selected uploaded files using Upload button.",
"UploadManual.Heading.Text":"Upload Documents",
"UploadManual.Upload.Text":"Upload",
"UploadManual.UploadClose.Text":"Close",
"UploadManual.FileMaxSizeError.Text":"Error: Import file exceeds the 2 Gb limit.",
"ManageTroubleshootingManuals.lblUserAsstMessage.Text":"View the troubleshooting manuals created. Click links under Name or Status for details or select a row and click an action button on the right.",
"ManageTroubleshootingManuals.DocumentNameFilter.Text":"Document Name Filter",
"ManageTroubleshootingManuals.lblShowOnly.Text":"Show Only",
"ManageTroubleshootingManuals.btnApplyFilter.Text":"Apply Filter",
"ManageDashboards.HeaderTitle.Text":"Manage Dashboards",
"ManageTroubleshootingManuals.DocumentName.Text":"Document",
"ManageTroubleshootingManuals.FileType.Text":"Type",
"ManageTroubleshootingManuals.DocumentPath.Text":"Path",
"ManageTroubleshootingManuals.Association.Text":"Association",
"ManageTroubleshootingManuals.CreatedBy.Text":"Created By",
"ManageTroubleshootingManuals.CreatedOn.Text":"Created On",
"ManageTroubleshootingManuals.lblManageTSManualActions.Text":"Actions",
"ManageTroubleshootingManuals.btnUploadManual.Text":"Upload",
"ManageTroubleshootingManuals.btnConnectEquipment.Text":"Connect",
"ManageTroubleshootingManuals.btnDeleteManual.Text":"Delete",
"ManageTroubleshootingManuals.BackButton.Text":"< Back",
"ManageTroubleshootingManuals.TitleHeader.Text":"Support Files Library",
"ManageTroubleshootingManuals.lblSelectEquipmentType.Text":"Select Equipments and Equipment Types",
"ManageTroubleshootingManuals.lblEquipments.Text":"Equipment",
"ManageTroubleshootingManuals.lblEquipmentTypes.Text":"EquipmentType",
"ManageTroubleshootingManuals.btnCancelConnectTSManuals.Text":"Cancel",
"ManageTroubleshootingManuals.btnConnectTSManuals.Text":"Connect",
"ManageTroushootingManuals.DeleteHeader.Text":"Delete Support Files",
"ManageTroubleshootingManuals.DeleteUserMessage.Text":"The support file(s) you selected will be removed from the library and all associated equipment pages. Are you sure?",
"ManageTroubleshootingManuals.Yes.Text":"Delete Files",
"ManageTroubleshootingManuals.No.Text":"Cancel",
"ManageTroubleshootingManuals.Close.Text":"Close",
"VideoLibrary.TitleHeader.Text":"Ensemble Video Library",
"VideoLibrary.BackButton.Text":"< Back",
"VideoLibrary.Category.General.Text":"A Glance at Ensemble",
"VideoLibrary.Category.Alarms.Text":"Alarms",
"VideoLibrary.Category.CriticalControl.Text":"Critical Controls",
"VideoLibrary.Category.Dashboards.Text":"Dashboards",
"VideoLibrary.Category.DataLogs.Text":"Data Logs",
"VideoLibrary.Category.Overrides.Text":"Overrides",
"VideoLibrary.Category.Setpoints.Text":"Global Setpoints",
"VideoLibrary.Category.Personalization.Text":"Preferences",
"VideoLibrary.Category.Reports.Text":"Reports",
"VideoLibrary.Category.Schedules.Text":"Schedules",
"VideoLibrary.Category.Status.Text":"Status",
"VideoLibrary.Category.Tenant.Text":"Tenant Services",
"VideoLibrary.Category.Users.Text":"User Management",
"VideoLibrary.Category.ChangeLog.Text":"User Change Log",
"VideoLibrary.Title.UI.Text":"An Introduction To Tracer Ensemble UI",
"VideoLibrary.Title.Alarms.Intro.Text":"An Introduction to Alarms",
"VideoLibrary.Title.Alarms.Actions.Text":"Managing Alarm Actions",
"VideoLibrary.Title.Alarms.Mgmt.Text":"Alarms Management",
"VideoLibrary.Title.Alarms.Config.Text":"Alarms Configuration",
"VideoLibrary.Title.CriticalControl.Text":"Criticial Control",
"VideoLibrary.Title.Dashboards.Creating.Text":"Creating Dashboards",
"VideoLibrary.Title.Dashboards.Utilizing.Text":"Utilizing Dashboards",
"VideoLibrary.Title.DataLogs.Intro.Text":"An Introduction to Data Logs and How to View Them",
"VideoLibrary.Title.DataLogs.Create.Text":"Creating Data Logs",
"VideoLibrary.Title.DataLogs.Edit.Text":"Editing Data Logs",
"VideoLibrary.Title.DataLogs.Delete.Text":"Deleting Data Logs",
"VideoLibrary.Title.DataLogs.Save.View.Text":"Saving and exporting Data Log view to Tree",
"VideoLibrary.Title.Overrides.Text":"Global Override Features",
"VideoLibrary.Title.Overrides.Definition.Text":"What are Overrides",
"VideoLibrary.Title.Overrides.Create.Text":"Making Overrides",
"VideoLibrary.Title.Overrides.Search.Query.Text":"Searching for Overrides (Setpoints & Overrides Query)",
"VideoLibrary.Title.Overrides.Search.Reports.Text":"Searching for Overrides (Using Reports)",
"VideoLibrary.Title.Setpoints.Text":"Utilizing Global Setpoint Changes",
"VideoLibrary.Title.Personalization.Text":"User Preferences",
"VideoLibrary.Title.Reports.Intro.Text":"An Introduction to Reports",
"VideoLibrary.Title.Reports.Custom.Text":"Custom Reports",
"VideoLibrary.Title.Reports.DataExport.Text":"Data Export Reports",
"VideoLibrary.Title.Reports.Standard.Text":"Standard Reports",
"VideoLibrary.Title.Schedules.Create.Text":"Creating Schedules",
"VideoLibrary.Title.Schedules.Calendar.Text":"Working with the Ensemble Calendar",
"VideoLibrary.Title.Schedules.Delete.Text":"Deleting Schedules",
"VideoLibrary.Title.Schedules.Edit.Text":"Editing Schedules",
"VideoLibrary.Title.Schedules.Exceptions.Text":"Managing Schedule Exceptions",
"VideoLibrary.Title.Schedules.Exceptions.Templates.Text":"Exception Templates",
"VideoLibrary.Title.Status.View.Text":"Viewing System Status",
"VideoLibrary.Title.Tenant.Intro.Text":"An Introduction to Tenant Services",
"VideoLibrary.Title.Tenant.Create.Text":"Creating Tenants",
"VideoLibrary.Title.Users.Profiles.Text":"Working with User Profiles",
"VideoLibrary.Title.Users.Roles.Intro.Text":"Understanding User Roles",
"VideoLibrary.Title.Users.Roles.Create.Text":"Creating and Managing User Roles",
"VideoLibrary.Title.ChangeLog.Text":"The User Change Log",
"VideoLibrary.Title.Architecture.Text":"An Introduction to Tracer Ensemble Architecture",
"VideoLibrary.Title.UI.Customize.Text":"Customizing the Tracer Ensemble User Interface",
"ImportProgressStatus.Percent.Complete.Text":"% Complete",
"ImportModifySupportFile.Upload.TitleHeader.Import.Text":"Import Support Files",
"ImportModifySupportFile.Assign.TitleHeader.Text":"Associate Support File",
"ImportModifySupportFile.Buildings.TitleHeader.Import.Text":"Import Support File - Select Buildings For Targets",
"ImportModifySupportFile.Buildings.TitleHeader.Edit.Text":"Edit Support File - Select Buildings For Targets",
"ImportModifySupportFile.Equipments.TitleHeader.Import.Text":"Import Support File - Select Equipment Associations",
"ImportModifySupportFile.Equipments.TitleHeader.Edit.Text":"Edit Support File - Select Equipment Associations",
"ImportModifySupportFile.Summary.TitleHeader.Import.Text":"Import Support File - Confirm Equipment Associations",
"ImportModifySupportFile.Summary.TitleHeader.Edit.Text":"Edit Support File - Confirm Equipment Associations",
"ImportModifySupportFile.Summary.UserMessage.Text":"Confirm your selections",
"ImportModifySupportFile.Heading.Text":"Import Support Files",
"ImportModifySupportFile.BrowseForFile.Text":"Browse for file",
"ImportModifySupportFile.FileNameLength.Text":"Error: Filename is too length.",
"ImportModifySupportFile.Browse.Text":"Browse...",
"ImportModifySupportFile.FileDescription.Text":"File Description",
"ImportModifySupportFile.UserMessage.Text":"Click Browse to select a file, enter a file description, and click Upload Files.",
"ImportModifySupportFile.Success.Text":"Support File Uploaded Successfully",
"ImportModifySupportFile.Uploaded.Text":"The file is already uploaded",
"ImportModifySupportFile.Description.Text":"Note: there is no requirement that a file include a description.",
"AssignFinishImportSupportFile.UserMessage.Text":"Would you continue to assign the support file or not?",
"AssignFinishImportSupportFile.Imported.Text":"File Uploaded",
"Wizards.AssignButton.Text":"Associate with Equipment >",
"Wizards.FinishedButton.Text":"Finished",
"Wizards.UploadButton.Text":"Upload File",
"SelectBuildingsSupportFile.UAText.Text":"Select one or more buildings to associate  this file with.",
"SelectBuildingsSupportFile.FileName.Text":"File Name",
"SelectBuildingsSupportFile.Description.Text":"Description",
"SelectBuildingsSupportFile.BuildingName.Text":"Building Name",
"SelectBuildingsSupportFile.Address.Text":"Address",
"SelectBuildingsSupportFile.City.Text":"City",
"SelectBuildingsSupportFile.State.Text":"State",
"SelectBuildingsSupportFile.AssociationHeading.Text":"Select Buildings for Status Page File Association",
"SelectBuildingsSupportFile.AssociationUAText.Text":"If you want to attach this file to equipment status pages, pick the buildings those equipment are in.",
"SelectBuildingsSupportFile.SelectBuildings.Text":"Select one or more buildings",
"SelectEquipmentSupportFile.UAText.Text":"Use the filters below to locate the equipment you want to associate this file with.",
"SelectEquipmentFamily.Heading.Text":"Select Equipment Family for this Support File",
"SelectEquipmentFamily.UAText.Text":"Select Equipment Family from the family list",
"SelectEquipmentSupportFile.FileName.Text":"File Name",
"SelectEquipmentSupportFile.Description.Text":"Description",
"SelectEquipmentSupportFile.Buildings.Text":"Buildings",
"SelectEquipmentSupportFile.EquipmentFamilyFilter.Text":"Equipment Family Filter",
"SelectEquipmentSupportFile.EquipmentFilter.Text":"Equipment Filter",
"SelectEquipmentSupportFile.ApplyFilter.Text":"Apply Filters",
"SelectEquipmentSupportFile.SiteName.Text":"Building Name",
"SelectEquipmentSupportFile.FamilyName.Text":"Family",
"SelectEquipmentSupportFile.EquipmentName.Text":"Equipment Name",
"SelectEquipmentSupportFile.AssociateUserMessage.Text":"Click Finish to  import the file and associate it with the equipment in the buildings you selected.",
"SelectEquipmentSupportFile.SelectEquipments.Text":"Select one or more equipment",
"SelectEquipmentSupportFile.and.Text":"and",
"SelectEquipmentSupportFile.etc.Text":"etc",
"ManageSupportFileLibrary.Edit.Text":"Edit",
"ManageSupportFileLibrary.Delete.Text":"Delete",
"ManageSupportFileLibrary.ImportSupportFile.Text":"Import File(s)",
"ManageSupportFileLibrary.Columns.Actions.Text":"Actions",
"ManageSupportFileLibrary.FileName.Text":"File Name",
"ManageSupportFileLibrary.Description.Text":"Description",
"ManageSupportFileLibrary.Association.Text":"Association",
"ManageSupportFileLibrary.Date.Text":"Date Uploaded",
"ManageSupportFileLibrary.UploadedBy.Text":"Uploaded By",
"EnumTSUploadedManuals.cboForColumn.Text":"0,DocName,Description,Association,UploadedOn,UploadedBy",
"EnumTSUploadedManuals.cboForColumn.0.Text":"No filter, view all",
"EnumTSUploadedManuals.cboForColumn.DocName.Text":"File Name",
"EnumTSUploadedManuals.cboForColumn.Description.Text":"Description",
"EnumTSUploadedManuals.cboForColumn.Association.Text":"Association",
"EnumTSUploadedManuals.cboForColumn.UploadedOn.Text":"Date Uploaded",
"EnumTSUploadedManuals.cboForColumn.UploadedBy.Text":"Uploaded By",
"AD0002.Text":"The password could not be changed because the password you entered is the same as the current password. Please enter a new password that has not been used recently.",
"AD0006.Text":"Cannot remove Access for {0} as it has been assigned as Home Page for this User.",
"AddAlarmEmailRouting1.Priorities.Text":"Priorities",
"AddAlarmEmailRouting1.Title.Text":"Add System Alarm E-mail Routing Rule",
"AddAlarmEmailRouting2.ColHeader.Text":"E-mail Address",
"AddAlarmEmailRouting2.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"AddAlarmEmailRouting2.Title.Text":"Add System Alarm E-mail Routing Rule",
"AddBuildingCustomAttributes.btnBack.Text":"< Back",
"AddBuildingCustomAttributes.btnNext.Text":"Next >",
"AddBuildingCustomAttributes.ContentHeader.Text":"Add New Building Custom Attribute",
"AddBuildingCustomAttributes.ContentHeaderModify.Text":"Edit Building Custom Attribute",
"AddBuildingCustomAttributes.DuplicateAttributeErrMsg.Text":"Error: The attribute name you specified is already in use. Please specify a unique name.  Click Back to see the list of existing names.",
"AddBuildingCustomAttributes.DuplicateAttributeValuesErr.Text":"Error: Please use each attribute value only once.",
"AddBuildingCustomAttributes.PageHeaderSummary.Text":"Add New Building Custom Attribute Summary",
"AddBuildingCustomAttributes.PageHeaderSummaryModify.Text":"Edit Building Custom Attribute Summary",
"AddBuildingCustomAttributes.HeaderAdd.Text":"Add",
"AddBuildingCustomAttributes.HeaderModify.Text":"Edit",
"AddBuildingCustomAttributes.lblCheckEmpty.Text":"Error: The wizard can’t proceed because none of the options below is selected. Select the type of custom attribute you would like to create and click Next.",
"AddBuildingCustomAttributes.lblFixedChoice.Text":"Fixed Choice List - You define list and users can pick only from the list",
"AddBuildingCustomAttributes.lblFixedChoiceExmp.Text":"Example: Class 1 or Class 2 or Class 3",
"AddBuildingCustomAttributes.lblFreeForm.Text":"Free Form Value - Users define single content item appropriate and unique for each building",
"AddBuildingCustomAttributes.lblFreeFormExmp.Text":"Example: Joe Smith 651-556-1212; this is a large building; Serviced by Nashville Office",
"AddBuildingCustomAttributes.lblGrowingChoice.Text":"Growing Choice List - You define initial list and users can select from list or add new items",
"AddBuildingCustomAttributes.lblGrowingChoiceExmp.Text":"Example: Red or Green or Yellow or <User Color 1> or <User Color 2>",
"AddBuildingCustomAttributes.lblSelectType.Text":"Select Type of Attribute",
"AddBuildingCustomAttributes.lblTwoChoice.Text":"Two Choices - You define two usually opposite values that users choose between",
"AddBuildingCustomAttributes.lblTwoChoiceExmp.Text":"Example: Yes or No. True or False, On or Off",
"AddBuildingCustomAttributes.lblUserAsstMessage.Text":"Select an option and click Next.",
"AddBuildingCustomAttributes.UpdateCustomAttributeError.Text":"Error: There is a problem encountered while trying to update custom attributes.",
"AddBuildingCustomAttributes.lblAttributeInfo.Text":"Attribute Information",
"AddBuildingCustomAttributes.lblSummaryUAText.Text":"Verify the information for the new custom attribute and click Finish to create it.",
"AddBuildingCustomAttributesFixedChoice.AttributeNameMaxLength.MaxLength":"50",
"AddBuildingCustomAttributesFixedChoice.btnBack.Text":"< Back",
"AddBuildingCustomAttributesFixedChoice.btnNext.Text":"Next >",
"AddBuildingCustomAttributesFixedChoice.lblAttributeName.Text":"Attribute Name",
"AddBuildingCustomAttributesFixedChoice.lblDefineFixed.Text":"Define Fixed Choice Attribute Values",
"AddBuildingCustomAttributesFixedChoice.lblDefineFixedDescription.Text":"Specify the number of choices you will define for the user.",
"AddBuildingCustomAttributesFixedChoice.lblQuantity.Text":"Quantity of Fixed Values",
"AddBuildingCustomAttributesFixedChoice.lblUserAsstMessage.Text":"Provide a name for the new attribute, complete the section below, and click Next.",
"AddBuildingCustomAttributesFixedChoice.lblUserAsstMessage2.Text":"Provide a value for each choice, select the options that follow, if desired, and click Next.",
"AddBuildingCustomAttributesFixedChoice2.btnBack.Text":"< Back",
"AddBuildingCustomAttributesFixedChoice2.btnFinish.Text":"Next >",
"AddBuildingCustomAttributesFixedChoice2.chkDefaultValue.Text":"Assign this default value to all new buildings",
"AddBuildingCustomAttributesFixedChoice2.chkHomePage.Text":"This attribute can be used when customizing the All Buildings page",
"AddBuildingCustomAttributesFixedChoice2.lblAttributrName.Text":"Attribute Name",
"AddBuildingCustomAttributesFixedChoice2.lblDefinedFixed.Text":"Define Fixed Choice Attribute Values",
"AddBuildingCustomAttributesFixedChoice2.Value.Text":"Attribute Value Choice",
"AddBuildingCustomAttributesFreeForm.AttributeNameMaxLength.MaxLength":"50",
"AddBuildingCustomAttributesFreeForm.btnBack.Text":"< Back",
"AddBuildingCustomAttributesFreeForm.btnFinish.Text":"Next >",
"AddBuildingCustomAttributesFreeForm.lblAttributeName.Text":"Attribute Name",
"AddBuildingCustomAttributesFreeForm.lblDefaultEntry.Text":"Text Field Default Entry",
"AddBuildingCustomAttributesFreeForm.lblDefineFree.Text":"Define Free Form Value Default Content",
"AddBuildingCustomAttributesFreeForm.lblDefineFreeDescription.Text":"Specify the maximum number of characters you want users to be able to put as the attribute value. Type the default text you want for the attribute value.",
"AddBuildingCustomAttributesFreeForm.lblMaxlength.Text":"Text Field Maximum Length",
"AddBuildingCustomAttributesFreeForm.lblUserAsstMessage.Text":"Provide a name for the new attribute, complete this page and click Next.",
"AddBuildingCustomAttributesFreeForm.TextFieldMaxLength.Text":"255",
"AddBuildingCustomAttributesGrowing.AttributeNameMaxLength.MaxLength":"50",
"AddBuildingCustomAttributesGrowing.btnBack.Text":"< Back",
"AddBuildingCustomAttributesGrowing.btnNext.Text":"Next >",
"AddBuildingCustomAttributesGrowing.lblAttributeName.Text":"Attribute Name",
"AddBuildingCustomAttributesGrowing.lblDefineGrowingAttributes.Text":"Define Growing Choice Attribute Values",
"AddBuildingCustomAttributesGrowing.lblQuantity.Text":"Initial Number of Values to Define",
"AddBuildingCustomAttributesGrowing.lblUserAsstMessage.Text":"Provide a name for the new attribute, complete this page, and click Next.",
"AddBuildingCustomAttributesGrowing.lblUserAsstNoofChoices.Text":"Specify the number of choices predefined for the user.",
"AddBuildingCustomAttributesGrowing.validation1.Text":"Quantity cannot be blank",
"AddBuildingCustomAttributesGrowing2.btnBack.Text":"< Back",
"AddBuildingCustomAttributesGrowing2.btnFinish.Text":"Next >",
"AddBuildingCustomAttributesGrowing2.chkHomePage.Text":"This attribute can be used when customizing the All Buildings page",
"AddBuildingCustomAttributesGrowing2.chkNewBuilding.Text":"Assign this default to all new buildings",
"AddBuildingCustomAttributesGrowing2.lblAttributeName.Text":"Attribute Name",
"AddBuildingCustomAttributesGrowing2.lblGrowingAttributes.Text":"Define Growing Choice Attribute Values",
"AddBuildingCustomAttributesGrowing2.Value.Text":"Attribute Value Choice",
"AddBuildingCustomAttributesTwoChoice.btnBack.Text":"< Back",
"AddBuildingCustomAttributesTwoChoice.btnFinish.Text":"Next >",
"AddBuildingCustomAttributesTwoChoice.chkHomePage.Text":"This attribute can be used when customizing the All Buildings page",
"AddBuildingCustomAttributesTwoChoice.chkNewBuilding.Text":"Assign this default value to all new buildings",
"AddBuildingCustomAttributesTwoChoice.FirstValue.Text":"Attribute Value Choice 1",
"AddBuildingCustomAttributesTwoChoice.lblAttribute.Text":"Attribute Name",
"AddBuildingCustomAttributesTwoChoice.lblDefineChoice.Text":"Define Two Choice Attribute Values",
"AddBuildingCustomAttributesTwoChoice.lblFirstValue.Text":"Attribute Value Choice 1",
"AddBuildingCustomAttributesTwoChoice.lblSecondValue.Text":"Attribute Value Choice 2",
"AddBuildingCustomAttributesTwoChoice.lblUserAsstDefineChoice.Text":"Provide a value for each choice and select the options that follow, as desired.",
"AddBuildingCustomAttributesTwoChoice.lblUserAsstNewAttribute.Text":"Provide a name for the new attribute, complete the section below, and click Next.",
"AddBuildingCustomAttributesTwoChoice.SecondValue.Text":"Attribute Value Choice 2",
"AddBuildingCustomAttributesTwoChoice.txtAttributeName.MaxLength":"50",
"AddFixedChoiceBuildingCustomAttributesConfirm.btnBack.Text":"< Back",
"AddFixedChoiceBuildingCustomAttributesConfirm.btnFinish.Text":"Finish",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblAttribute.Text":"Attribute Name",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblContentHeading.Text":"Review your selections below",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblHomePage.Text":"Can be used to customize the All Buildings page",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblLastChance.Text":"This is your last chance to go back and make changes. When you click Finish, each building will support the custom attribute indicated by the above settings.",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblLinks.Text":"You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblNewBuilding.Text":"Assign this default value to all new buildings",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblType.Text":"Type",
"AddFixedChoiceBuildingCustomAttributesConfirm.lblTypeText.Text":"Fixed Choice List",
"AddFixedChoiceBuildingCustomAttributesConfirm.SelectedNo.Text":"---",
"AddFixedChoiceBuildingCustomAttributesConfirm.SelectedNo1.Text":"No",
"AddFixedChoiceBuildingCustomAttributesConfirm.SelectedYes.Text":"Yes",
"AddFixedChoiceBuildingCustomAttributesConfirm.UndoText.Text":"The Fixed Choice Building Custom Attributes actions have been completed successfully and cannot be undone",
"AddFreeFormBuildingCustomAttributesConfirm.btnBack.Text":"< Back",
"AddFreeFormBuildingCustomAttributesConfirm.btnFinish.Text":"Finish",
"AddFreeFormBuildingCustomAttributesConfirm.lblAttribute.Text":"Attribute Name",
"AddFreeFormBuildingCustomAttributesConfirm.lblContentText.Text":"Review your selections below",
"AddFreeFormBuildingCustomAttributesConfirm.lblDefaultEntry.Text":"Text Field Default Entry",
"AddFreeFormBuildingCustomAttributesConfirm.lblLastChance.Text":"This is your last chance to go back and make changes. When you click Finish, each building will support the custom attribute indicated by the above settings.",
"AddFreeFormBuildingCustomAttributesConfirm.lblLinks.Text":"You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following",
"AddFreeFormBuildingCustomAttributesConfirm.lblMaxlength.Text":"Text Field Maximum Length",
"AddFreeFormBuildingCustomAttributesConfirm.lblType.Text":"Type",
"AddFreeFormBuildingCustomAttributesConfirm.lblTypeText.Text":"Free Form Value",
"AddFreeFormBuildingCustomAttributesConfirm.UndoText.Text":"The Free Form Building Custom Attributes actions have been completed successfully and cannot be undone",
"AddGrowingChoiceBuildingCustomAttributesConfirm.btnBack.Text":"< Back",
"AddGrowingChoiceBuildingCustomAttributesConfirm.btnFinish.Text":"Finish",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblAttribute.Text":"Attribute Name",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblContentText.Text":"Review your selections below",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblHomePage.Text":"Can be used to customize the All Buildings page",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblLastChance.Text":"This is your last chance to go back and make changes. When you click Finish, each building will support the custom attribute indicated by the above settings.",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblLinks.Text":"You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblNewBuilding.Text":"Assign this default value to all new buildings",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblType.Text":"Type",
"AddGrowingChoiceBuildingCustomAttributesConfirm.lblTypeText.Text":"Growing Choice List",
"AddGrowingChoiceBuildingCustomAttributesConfirm.SelectedNo.Text":"---",
"AddGrowingChoiceBuildingCustomAttributesConfirm.SelectedNo1.Text":"No",
"AddGrowingChoiceBuildingCustomAttributesConfirm.SelectedYes.Text":"Yes",
"AddGrowingChoiceBuildingCustomAttributesConfirm.UndoText.Text":"The Growing Choice Building Custom Attributes actions have been completed successfully and cannot be undone",
"AddRemoveDataShownEquipmentSubsystem.btnBack.Text":"< Back",
"AddRemoveDataShownEquipmentSubsystem.btnNext.Text":"Next >",
"AddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.Items":"<?xml version",
"AddRemoveDataShownEquipmentSubsystem.Header1.Text":"Equipment Data",
"AddRemoveDataShownEquipmentSubsystem.lblContentHeading.Text":"Add/Remove Data Shown on Equipment or Subsystem Page(s)",
"AddRemoveDataShownEquipmentSubsystem.lblEquipment.Text":"Equipment or Subsystem Family Type to Customize",
"CustomizeStatusPage.UserAssistanceMessage.Text":"Select the equipment or subsystem family type to customize and click Next.",
"AddRemoveDataShownEquipmentSubsystem1.btnBack.Text":"< Back",
"AddRemoveDataShownEquipmentSubsystem1.btnFinish.Text":"Finish",
"AddRemoveDataShownEquipmentSubsystem1.ColumnGrid1.Text":"Currently Displayed",
"AddRemoveDataShownEquipmentSubsystem1.ColumnGrid11.Text":"Currently Displayed",
"AddRemoveDataShownEquipmentSubsystem1.ColumnGrid2.Text":"System Default",
"AddRemoveDataShownEquipmentSubsystem1.ColumnGrid3.Text":"Conditions Table",
"AddRemoveDataShownEquipmentSubsystem1.ColumnGrid33.Text":"Status Table",
"AddRemoveDataShownEquipmentSubsystem1.Header1.Text":"Add/Remove {0} Equipment Summary Data",
"AddRemoveDataShownEquipmentSubsystem1.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"AddRemoveDataShownEquipmentSubsystem1.lblUserAsstLastChance.Text":"If you are satisfied with your selections, click Finish to apply them.",
"AddRemoveDataShownEquipmentSubsystem1.lblUserAsstLinks.Text":"You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following",
"AddRemoveDataShownEquipmentSubsystem1.lblUserAsstMessage.Text":"Select to show data points on the summary page and clear to delete data points from the summary page.",
"AddRemoveDataShownEquipmentSubsystem1.UndoText.Text":"Add/Remove Equipment Summary Data  have been completed successfully and cannot be undone",
"AddScheduleAttribute.btnAddNewAttribute.Text":"Add New Attribute",
"AddScheduleAttribute.btnCancel.Text":"Cancel",
"AddScheduleAttribute.DialogTitle.Text":"Tracer Ensemble - Add Schedule Attribute",
"AddScheduleAttribute.lblContentHeading.Text":"Tracer Ensemble Schedule Attribute",
"AddScheduleAttribute.lblNewAttributeName.Text":"New Attribute Name",
"AddScheduleAttribute.lblUserAsstMessage.Text":"Take care with your entry. Duplicates will be rejected and misspellings will be accepted.",
"AddTwoChoiceBuildingCustomAttributesConfirm.btnBack.Text":"< Back",
"AddTwoChoiceBuildingCustomAttributesConfirm.btnFinish.Text":"Finish",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblAttribute.Text":"Attribute Name",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblContentText.Text":"Review your selections below",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblFirstValue.Text":"Attribute Value Choice 1",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblHomePage.Text":"Can be used to customize the All Buildings page",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblLastChance.Text":"This is your last chance to go back and make changes. When you click Finish, each building will support the custom attribute indicated by the above settings.",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblLinks.Text":"You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblNewBuilding.Text":"Assign this default value to all new buildings",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblSecondValue.Text":"Attribute Value Choice 2",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblType.Text":"Type",
"AddTwoChoiceBuildingCustomAttributesConfirm.lblTypeText.Text":"Two Choices",
"AddTwoChoiceBuildingCustomAttributesConfirm.SelectedNo.Text":"---",
"AddTwoChoiceBuildingCustomAttributesConfirm.SelectedNo1.Text":"No",
"AddTwoChoiceBuildingCustomAttributesConfirm.SelectedYes.Text":"Yes",
"AddTwoChoiceBuildingCustomAttributesConfirm.UndoText.Text":"The Two Choice Building Custom Attributes actions have been completed successfully and cannot be undone",
"Administration.btnUploadBack.Text":"< Back",
"Administration.btnUploadFinish.Text":"Finish",
"Administration.hlnkApplySiteLicense.Text":"Register Site License",
"Administration.hlnkChangeTESAdminPassword.Text":"Change Tracer Ensemble Administrator Password",
"Administration.hlnkGlobalApplications.Text":"Global Applications",
"Administration.hlnkLicenseDownload.Text":"Download",
"Administration.hlnkLicensingServer.Text":"http://www.basregistration.trane.com/Registration/ControlsLicensing.htm",
"Administration.hlnkManageTESLicensing.Text":"Manage Tracer Ensemble Licensing",
"Administration.hlnkManageUsersAndRoles.Text":"Manage User Profiles and Roles",
"Administration.hlnkSystemLogs.Text":"System Logs",
"Administration.hlnkSystemStatus.Text":"System Status",
"Administration.hlnkSystemHealth.Text":"Advanced System Health",
"Administration.hlnkTestHarness.Text":"Development Test Harness",
"Administration.hlnkSimulator.Text":"BACnet Simulator",
"Administration.hlnkUploadLicenseFile.Text":"Upload License File",
"Administration.hlnkDatabaseMaintenance.Text":"Manage Database Size",
"Administration.hlnlApplyLicenseConfirm.Text":"Register Tracer Ensemble Site License",
"Administration.hlnlSystemMaintencance.Text":"System Maintenance",
"Administration.hlnluploadLicenseFile.Text":"Upload License File",
"Administration.hlnlViewHomePage.Text":"Home",
"Administration.hlnlViewLicenseInfo.Text":"View License Information",
"Administration.hlnlViewPanelLicensing.Text":"View Panel Licensing",
"Administration.hlnlViewParameters.Text":"System Parameters",
"Administration.hlnlViewSystemStatus.Text":"System Status",
"Administration.hlnkActiveDirectoryDomainService.Text":"Configure Active Directory Domain Service",
"Administration.lblApplyForLicenseSuccess.Text":"A license request file for this Tracer Ensemble site has been created.  The remaining steps to registering the site are as follows.",
"Administration.lblTracerEnsembleLicensing.Text":"Tracer Ensemble Licensing",
"Administration.lblTracerEnsembleRegisterLicense.Text":"Tracer Ensemble Licensing - Register License",
"Administration.lblUpdateTracerEnsembleLicense.Text":"Update Tracer Ensemble License",
"Administration.lblCustomerInformation.Text":"Customer Information",
"Administration.lblCustomerMessage.Text":"The Infomation Provided by you has been successfully updated in our System.",
"Administration.lblLicenceFile.Text":"License File",
"Administration.lblNoFileChosen.Text":"No File Chosen",
"Administration.lblLicenseinformation.Text":"License Information",
"Administration.lblLicenseRequestError.Text":"The license request file was not found. Please resubmit your license request application.",
"Administration.lblLicensingGuideStep1.Text":"Download the license request file.",
"Administration.lblLicensingGuideStep2.Text":"Use the following link to upload the license request file to the New Tracer Controls Product Licensing web page to obtain a license. You need to be connected to the Trane network to obtain a license.",
"Administration.lblLicensingGuideStep3.Text":"To activate your site license, upload your license on the following page:",
"Administration.lblManageTESLicensing.Text":"View and make changes to your Tracer Ensemble and panel licensing.",
"Administration.lblMessage.Text":"Please check the email provided by you at the time of registration to view instructions to complete your License Activation.",
"Administration.lblRegisterUploadSiteLicense.Text":"Register your Tracer Ensemble software serial number and upload the corresponding license file from Trane into the system.",
"Administration.lblSystemMaintencance.Text":"View system status and parameters, or manage licensing and the administrator password.",
"Administration.lblUserAsstAdmin.Text":"Click a link below to view and edit administrative options.",
"Administration.lblUserAsstGlobalApplications.Text":"View and modify alarm and schedule settings, global point controls, and custom system pages.",
"Administration.lblUserAsstManageBuildings.Text":"Add, delete, and modify buildings and their settings.",
"Administration.lblUserAsstManageTESlicensing.Text":"Click one of the options below.",
"Administration.lblUserAsstManageUsersAndRoles.Text":"Add, delete, and modify users, their privileges, and related settings.",
"Administration.lblUserAsstMessageApplySiteLicense.Text":"Register your license code.",
"Administration.lblUserAsstMessageApplyTESLicense.Text":"Complete this page and click Next to apply for a change in your Tracer Ensemble license.  (*required fields)",
"Administration.lblUserAsstMessageChangeTESAdminPassword.Text":"[UA Text]",
"Administration.lblUserAsstMessageCustomerInformation.Text":"Enter your personal, company, and contact information.",
"Administration.lblUserAsstMessageSystemStatus.Text":"View the overall system status and the status of the individual Tracer Ensemble applications.",
"Administration.lblUserAsstMessageuploadLicenseFile.Text":"Bring a new license file from Trane into the system.",
"Administration.lblUserAsstMessageViewLicenseInfo.Text":"View the license code and the customer data associated with the user license.",
"Administration.lblUserAsstMessageViewPanelLicensing.Text":"View and change the licensing status of individual panels.",
"Administration.lblUserAsstMessageViewParameters.Text":"View and edit the general parameters used by Tracer Ensemble system for building discovery, alarms, e-mail, global point control, and site synchronization.",
"Administration.lblUserAsstMssgLicenseInformation.Text":"Type or paste in the customer license code (serial number) that was provided to you by Trane.",
"Administration.lblUserAsstMessageSystemHealth.Text":"View advanced system health and the status of the individual Tracer Ensemble applications.",
"Administration.lblUserAsstMessageTestHarness.Text":"Access development test harness.",
"Administration.lblUserAsstMessageSimulator.Text":"Configure and active BACnet Simulation functionality for TracerEnsemble.",
"Administration.lblUserAsstSystemLogs.Text":"View and manage system tasks and logs for user changes and global point control.",
"Administration.lblUserAsstDatabaseMaintenance.Text":"View and edit settings that affect the size of the Tracer Ensemble database by controlling the number or age of records and logs that it stores.",
"Administration.lblActiveDirectoryDomainService.Text":"This link goes to the page where the installer will provide inputs and settings required to hook up Tracer Ensemble to use the ADDS for user login and profile data.",
"Administration.lblCriticalContSubHeader.Text":"Select items to add to critical control. Use the filter fields to narrow search results. To confirm your additions, enter your password and click Add. Note that leaving checkboxes unchecked will not remove the associated items from Critical Control.",
"Administration.lblManageViewCriticalContSubHeader.Text":"Items in the table are under Critical Control and can only be viewed or changed by users with the appropriate permissions. Use the Filters and Arrange By fields to sort Critical Control points.",
"Administration.lblCriticalPointPermission.Text":"One or more of the selected items in the table are under Critical Control and can only be released by users with the appropriate permissions.",
"Administration.lblViewParameters.Text":"----Insert User Assistance Text--",
"Administration.lbtnManageBuildings.Text":"Manage Buildings",
"Administration.ViewActiveStatus.Text":"License is Active",
"Administration.ViewPanelID.Text":"Device ID",
"Administration.ViewPanelLicenseValue.Text":"Licenses Required by this Device",
"Administration.ViewPanelName.Text":"Device Name",
"Administration.ViewPanelSiteName.Text":"Building Name",
"Administration.ViewPanelType.Text":"Model Name",
"Administration.ViewPanelApplyLicense.Text":"Apply License",
"AdministrationTHN.Text":"Actions and Settings",
"AlarmEmailRouting.btnApplyFilter.Text":"Apply Filter",
"AlarmEmailRouting.btnBack.Text":"< Back",
"AlarmEmailRouting.btnDelete.Text":"Delete",
"AlarmEmailRouting.cboForColumn.Items":"<?xml version",
"AlarmEmailRouting.CheckBoxVal.Text":"Error: Please Select atleast one record",
"AlarmEmailRouting.EmailAddress.Text":"E-mail Addresses",
"AlarmEmailRouting.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"AlarmEmailRouting.lblForColumn.Text":"For Column",
"AlarmEmailRouting.lblSelectRules.Text":"Selected E-mails",
"AlarmEmailRouting.lblShowOnly.Text":"Show Only",
"AlarmEmailRouting.lblUserAsstMessage.Text":"Rules apply to alarm priority levels marked with an ‘X’. Click a column head to sort. To change a rule, click it. To delete a rule, select it and click Delete. To show only selected data, set up For Column and Show Only. Click Apply Filter.",
"AlarmEmailRouting.lbtnAddNewRule.Text":"Add New Global E-mail Routing Rule",
"AlarmEmailRouting.MatchingAttribute.Text":"Matching Attribute",
"AlarmEmailRouting.RoutingRuleNameCol.Text":"E-mail Routing Rule Name",
"AlarmEmailRouting1.btnBack.Text":"< Back",
"AlarmEmailRouting1.btnNext.Text":"Next >",
"AlarmEmailRouting1.Header.Text":"Add System Rule",
"AlarmEmailRouting1.lblAllBuilding.Text":"All Buildings",
"AlarmEmailRouting1.lblEmailName.Text":"Name of the E-mail Routing Rule :",
"AlarmEmailRouting1.lblMatchingAttributeName.Text":"Matching Attribute Name",
"AlarmEmailRouting1.lblMatchingAttributeValue.Text":"Matching Attribute Value",
"AlarmEmailRouting1.lblPriorities.Text":"Select Alarm Priorities",
"AlarmEmailRouting1.lblSelectMatchingAttributes.Text":"Select Matching Attributes",
"AlarmEmailRouting1.lblSomeBuilding.Text":"Some Buildings",
"AlarmEmailRouting1.lblUserAsstAttributes.Text":"Select either All Buildings or Some Buildings as having system alarm e-mails routed to a recipient list. Set up Some Buildings, as necessary",
"AlarmEmailRouting1.lblUserAsstMessage.Text":"Complete the steps in this wizard to create an alarm e-mail routing rule for buildings in the system.",
"AlarmEmailRouting1.lblUserAsstPriorities.Text":"Select up to four alarm priorities that the recipients of this rule will receive e-mails for.",
"AlarmEmailRouting2.btnBack.Text":"< Back",
"AlarmEmailRouting2.btnDelete.Text":"Delete",
"AlarmEmailRouting2.btnFinish.Text":"Finish",
"AlarmEmailRouting2.Header.Text":"Add System Rule",
"AlarmEmailRouting2.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"AlarmEmailRouting2.lblAlarmEmail.Text":"Alarm E-mail Recipients",
"AlarmEmailRouting2.lblLastChance.Text":"This is your last chance to go back and make changes. When you click Finish, the system begins routing appropriate alarms for all buildings to the selected e-mail recipients.",
"AlarmEmailRouting2.lblName.Text":"Name",
"AlarmEmailRouting2.lblPriorities.Text":"Priorities",
"AlarmEmailRouting2.lblReviewRule.Text":"Review current rule selections",
"AlarmEmailRouting2.lblRule.Text":"Attribute Rule",
"AlarmEmailRouting2.lblSelectedMails.Text":"Selected E-mails",
"AlarmEmailRouting2.lblUserAsstMessage.Text":"Review your selections so far and continue with the next step of this wizard.",
"AlarmEmailRouting2.lblUserAsstVerify.Text":"Verify the setup selections for this rule.",
"AlarmEmailRouting2.lbtnNewRecipient.Text":"Add New Recipient",
"AlarmEmailRoutingTHN.Text":"Manage Alarm E-mail Routing",
"ApplicationType.Items":"<?xml version",
"ApplyForSiteLicenseMail.Address1.Text":"Address 1",
"ApplyForSiteLicenseMail.Address2.Text":"Address 2",
"ApplyForSiteLicenseMail.BeginSignature.Text":"-----Begin Signature------------------------------",
"ApplyForSiteLicenseMail.City.Text":"City",
"ApplyForSiteLicenseMail.Company.Text":"Company",
"ApplyForSiteLicenseMail.CustomerCode.Text":"Customer Code",
"ApplyForSiteLicenseMail.DearAdm.Text":"Dear Administrator,",
"ApplyForSiteLicenseMail.EMailAddress.Text":"Email Address",
"ApplyForSiteLicenseMail.EndLicenseRequestinfo.Text":"-----End License Request Info---------------------",
"ApplyForSiteLicenseMail.EndSignature.Text":"-----End Signature--------------------------------",
"ApplyForSiteLicenseMail.FirstLine.Text":"Following application has been received for Site License.",
"ApplyForSiteLicenseMail.FirstName.Text":"First Name",
"ApplyForSiteLicenseMail.LastName.Text":"Last Name",
"ApplyForSiteLicenseMail.PostalCode.Text":"Postal code",
"ApplyForSiteLicenseMail.Regards.Text":"With Regards,",
"ApplyForSiteLicenseMail.State.Text":"State",
"ApplyForSiteLicenseMail.TraneTeam.Text":"Trane Administration Team",
"ApplyTESLicense.btnBack.Text":"< Back",
"ApplyTESLicense.btnNext.Text":"Next >",
"ApplyTESLicense.lblAddress1.Text":"Address 1*",
"ApplyTESLicense.lblAddress2.Text":"Address 2",
"ApplyTESLicense.lblCity.Text":"City*",
"ApplyTESLicense.lblCompany.Text":"Company*",
"ApplyTESLicense.lblCustomerCode.Text":"Software Serial #*",
"ApplyTESLicense.lblEmailAddress.Text":"Email Address*",
"ApplyTESLicense.lblFirstName.Text":"First Name*",
"ApplyTESLicense.lblLastName.Text":"Last Name*",
"ApplyTESLicense.lblDefaultPwd.Text":"Default Password*",
"ApplyTESLicense.lblConfirmPwd.Text":"Confirm Password*",
"ApplyTESLicense.lblPostalCode.Text":"Postal Code*",
"ApplyTESLicense.lblState.Text":"State/Province",
"ApplyTESLicense.lblCountry.Text":"Country",
"ApplyTESLicense.lblRegLicenseLink.Text":"Licensing Server",
"ApplyTESLicense.hlnkRegisterLicense.Text":"www.basregistration.trane.com",
"AssignScheduleAttributes.Attributes.Text":"Schedule Name",
"AssignScheduleAttributes.btnAssign.Text":"Assign to Schedules",
"AssignScheduleAttributes.btnBack.Text":"< Back",
"AssignScheduleAttributes.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"AssignScheduleAttributes.lblAssignAttributes.Text":"Assign Attributes to Normal Schedule",
"AssignScheduleAttributes.lblContentHeading.Text":"Assign Attributes",
"AssignScheduleAttributes.lblSchedulesSelected.Text":"Building Schedules Selected",
"AssignScheduleAttributes.lblSelectedAttributes.Text":"Selected Attributes",
"AssignScheduleAttributes.lblUserAsstAssignAttributes.Text":"The list shows all attributes in the system that have not been assigned to at least one of the selected schedules. Select attributes and click Assign to Schedules.",
"AssignScheduleAttributes.lblUserAsstMessage.Text":"Review the list of selected building schedules and continue with the next step.",
"AssignScheduleAttributes.ScheduleAttributes.Text":"Attribute",
"BACnetCapture.Buttons.StopCapture.Text":"Stop Capture",
"BACnetCapture.Buttons.StartCapture.Text":"Start Capture",
"BACnetCapture.Buttons.Duration.Text":"Duration",
"BACnetCapture.lblBuildingName.Text":"Building Name",
"BACnetCapture.lblMinutes.Text":"Minutes",
"BACnetCapture.lblExportCapture.Text":"Export Capture:",
"BACnetCapture.lblViewOrExportFile.Text":"View or Export file from",
"BACnetCapture.lblTechnicianLogs.Text":"TechnicianLogs",
"BACnetCapture.lblCaptureTime.Text":"Capture Time:",
"BACnetCapture.lblStart.Text":"Start:",
"BACnetCapture.lblRequestedDuration.Text":"Requested Duration:",
"BACnetCapture.lblCaptureTitle.Text":"Capture Title",
"BACnetCapture.Buttons.Building.Text":"Select or Type Building Name",
"EnumBACnetCapture.Text":"1,2",
"EnumBACnetCapture.1.Text":"Hours",
"EnumBACnetCapture.2.Text":"Minutes",
"BACnetExplorer.BACnetExplorerTHN.Text":"BACnet Explorer",
"BACnetExplorer.lblUserAsstBACnetExplorer.Text":"This tool is designed for exploring devices on a BACnet Network, as well as verifying the readiness of Tracer Ensemble to support various equipment types.",
"BACnetExplorer.btnExplorer.Text":"BACnet Explorer",
"BACnetExplorer.btnAnalyzer.Text":"Site Analyzer",
"BACnetExplorer.lblDiscoveryPanelHeader.Text":"Discovered Objects",
"BACnetExplorer.lblTableInformationLabelHeader.Text":"Category",
"BACnetExplorer.lblTableInformationHeader.Text":"Value",
"BACnetExplorer.lblInformationLabel.Text":"Information:",
"BACnetExplorer.lblInformation.Text":"Value",
"BACnetExplorer.lblContextualControlPanelHeader.Text":"Control Panel",
"BACnetExplorer.btnWhoIs.Text":"WHOIS",
"BACnetExplorer.lblContextualReadPanelHeader.Text":"Read Property",
"BACnetExplorer.btnPerformRead.Text":"Read Selected",
"BACnetExplorer.lblReadResultLabel.Text":"Result:",
"BACnetExplorer.lblReadResult.Text":"---",
"BuildingAlarmEmailRouting.AlarmBreadCrumb.Text":"Building Alarms",
"BuildingAlarmEmailRouting.AlarmPriority.Text":"Alarm Priority Level",
"BuildingAlarmEmailRouting.btnBack.Text":"< Back",
"BuildingAlarmEmailRouting.EmailAddresses.Text":"E-mail Addresses",
"BuildingAlarmEmailRouting.Header.Text":"Manage Alarm E-mail Routing",
"BuildingAlarmEmailRouting.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"BuildingAlarmEmailRouting.lblContentHeading.Text":"Manage Alarm Routing E-mail List",
"BuildingAlarmEmailRouting.lblUserAsstMessage.Text":"View or change alarm routing e-mail address list for this building. Click a priority name to change its recipient list.",
"BuildingsAlarmEmailRouting1.btnBack.Text":"< Back",
"BuildingsAlarmEmailRouting1.btnDelete.Text":"Delete",
"BuildingsAlarmEmailRouting1.btnFinish.Text":"Finish",
"BuildingsAlarmEmailRouting1.BuildingName.Text":"Building Name",
"BuildingsAlarmEmailRouting1.EmailAddress.Text":"E-mail Address",
"BuildingsAlarmEmailRouting1.Header.Text":"Add Alarm Routing Rule",
"BuildingsAlarmEmailRouting1.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"BuildingsAlarmEmailRouting1.lblEmailRecipients.Text":"Alarm E-mail Recipients",
"BuildingsAlarmEmailRouting1.lblSelectAlarmPriorities.Text":"Select Alarm Priorities",
"BuildingsAlarmEmailRouting1.lblSelectedEmails.Text":"Selected E-mails",
"BuildingsAlarmEmailRouting1.lblUserAsstMessage.Text":"Complete the steps in this wizard to create a rule to route alarm e-mails for the listed buildings.",
"BuildingsAlarmEmailRouting1.lblUserAsstPriority.Text":"Select up to four alarm priorities to route alarm e-mails to a recipient list.",
"BuildingsAlarmEmailRouting1.lblUserAsstRecipients.Text":"Select e-mail recipients who will receive notification under this alarm routing rule. Add a new recipient. To delete a recipient, select an existing recipient and then click Delete.",
"BuildingsAlarmEmailRouting1.lbtnNewRecipients.Text":"Add New Recipient",
"BuildingsAlarmEmailRouting1.PrioritiesCol.Text":"Priorities",
"BuildingsAlarmEmailRouting1.Title.Text":"Add Alarm E-mail Routing Rule",
"ChangeAlarmRouting.E-mail.Text":"E-mail Address",
"ChangeBuildingAlarmEmailRouting.btnBack.Text":"< Back",
"ChangeBuildingAlarmEmailRouting.btnDelete.Text":"Delete",
"ChangeBuildingAlarmEmailRouting.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"ChangeBuildingAlarmEmailRouting.lblContentHeading.Text":"Change Alarm Routing E-mail List",
"ChangeBuildingAlarmEmailRouting.lblEmailRecipients.Text":"Alarm E-mail Recipients",
"ChangeBuildingAlarmEmailRouting.lblHeader.Text":"Change E-mail List",
"ChangeBuildingAlarmEmailRouting.lblSelectedEmail.Text":"Selected E-mails",
"ChangeBuildingAlarmEmailRouting.lblUserAsstMessage.Text":"Add a new recipient. To remove a recipient, select the e-mail address and then click Delete.",
"ChangeBuildingAlarmEmailRouting.lblUserAsstMessageRecipients.Text":"Add a new recipient. To remove a recipient, select the e-mail address and then click Delete.",
"ChangeBuildingAlarmEmailRouting.lbtnAddNewRec.Text":"Add New Recipient",
"CreateModifyAttributesPopup.btnCancel.Text":"Cancel",
"CreateModifyAttributesPopup.btnOk.Text":"Add E-mail Addresses",
"CreateModifyAttributesPopup.DialogTitle.Text":"Tracer Ensemble - Add New E-mail Address",
"CreateModifyAttributesPopup.lblContentHeading.Text":"Add New E-mail Address",
"CreateModifyAttributesPopup.lblUserAsstMessage.Text":"Type or paste one or more e-mail addresses. Separate addresses with commas.",
"CT00001.Text":"Unable to customize properties using Stored Procedures.",
"CT00002.Text":"Unable to set custom attribute on home page",
"CT00003.Text":"Unable to set the user preferences",
"CT00004.Text":"Error in XML while setting custom links for multiple pages.",
"CT00006.Text":"Error while setting the Custom links for objects.",
"CT00007.Text":"Error while setting the Custom links for building.",
"CT00008.Text":"Error while deleting attribute definitions.",
"CT00009.Text":"Attribute definition not found in database.",
"CT00010.Text":"Duplicate Attribute definition found",
"CT00011.Text":"Unable to insert attribute definition.",
"CT00012.Text":"Attribute Name cannot be blank.",
"CT00013.Text":"Customization File Not Found",
"CustomAttributeError.Text":"!",
"CustomAttributeType.FixedChoice.Text":"Fixed Choice List",
"CustomAttributeType.Freeform.Text":"Free Form Value",
"CustomAttributeType.GrowingChoice.Text":"Growing Choice List",
"CustomAttributeType.TwoChoice.Text":"Two Choices",
"CustomizeDisplayBuildingsHomePage.AttributeValidation.Text":"The primary and secondary grouping arrtibutes cannot be same",
"CustomizeDisplayBuildingsHomePage.btnBack.Text":"< Back",
"CustomizeDisplayBuildingsHomePage.btnFinish.Text":"Finish",
"AddRemoveEquipmentSummary.Header.Text":"Customize Data",
"CustomizeDisplayBuildingsHomePage.lblLinks.Text":"You may go to any portion of the application you like by using the options at the top of the page or clicking one of the following",
"CustomizeDisplayBuildingsHomePage.lblSelectIndexMessage.Text":"Select Number of Index Levels",
"CustomizeDisplayBuildingsHomePage.lblSpecificAttributes.Text":"Specific Grouping Attribute",
"CustomizeDisplayBuildingsHomePage.lblSpecificGroupHeading.Text":"Specific Grouping Attribute",
"CustomizeDisplayBuildingsHomePage.lblUserAsstGeneralGroup.Text":"Select the general building attribute you want used for the top level of organization on the home page index and the navigation tree.",
"CustomizeDisplayBuildingsHomePage.lblUserAsstMessage.Text":"Select index levels and grouping attributes to set up the hierarchy of the building links list on the home page and the navigation tree.",
"CustomizeDisplayBuildingsHomePage.lblUserAsstSpecificGroup.Text":"Select the specific building attribute you want used for the second level of organization on the home page index and the navigation tree.",
"CustomizeStatusPage.EquipmentDropDown.Text":"Equipment or Subsystem Family Type to Customize",
"CustomizeStatusPage.Heading.Text":"Customize System Pages",
"CustomizeStatusPage.NextButton.Text":"Next >",
"CustomizeStatusPage.FamilyType.20.Text":"Programmable Controller as Air Handler",
"CustomizeStatusPage.FamilyType.21.Text":"Programmable Controller as Chiller",
"CustomizeStatusPage.FamilyType.22.Text":"Programmable Controller as Chiller Plant",
"CustomizeStatusPage.FamilyType.23.Text":"Programmable Controller as Heat Pump Loop",
"CustomizeStatusPage.FamilyType.24.Text":"Programmable Controller as Input Output",
"CustomizeStatusPage.FamilyType.25.Text":"Programmable Controller as Space",
"CustomizeStatusPage.FamilyType.26.Text":"Programmable Controller as Variable Air System",
"CustomizeStatusPage.FamilyType.Text":"1,2,3,4,5,6,9,11,20,21,22,23,24,25,26",
"CustomizeSystemPages.ContentHeader.Text":"Customize System Pages",
"CustomizeSystemPages.hlnkListCustomGraphics.Text":"List Custom Graphics",
"CustomizeSystemPages.hlnkAssignGraphics.Text":"Assign Graphic",
"CustomizeSystemPages.ImportHomePage.Link.Text":"Import Home Page Custom Links",
"CustomizeSystemPages.lblDataOnEquipmentPage.Text":"Customize the equipment and subsystems pages so only the data you want to see is visible.",
"CustomizeSystemPages.lblAssignGraphics.Text":"Assign a graphic that is in the system to one or more status pages.",
"CustomizeSystemPages.lblDefineHomePageCusomLinks.Text":"Create links on the Tracer Ensemble home page to make it faster and easier to navigate to favorite places.",
"CustomizeSystemPages.lblHomePageIndex.Text":"Set up the hierarchy of the building links list on the home page and the Navigation Tree.",
"CustomizeSystemPages.lblImportHomePage.Text":"Click to import the list of custom page links on the right side of the Home page.",
"CustomizeSystemPages.lblListCustomGraphics.Text":"View a list of the custom graphics in the system.",
"CustomizeSystemPages.lblRemoveHomePage.Text":"Click to delete all Home page custom links from the system.",
"CustomizeSystemPages.lblUserAsstMessage.Text":"Click one of the options below.",
"CustomizeSystemPages.lbtnCustomDispBuildHome.Text":"Customize Building Grouping",
"CustomizeSystemPages.RemoveHomePageCustomLinksUserAssistMsg.Text":"Remove links currently displayed on the Tracer Ensemble home page.",
"CustomizeSystemPages.RemoveCustomPageLinksHeader.Text":"Remove Custom Links Confirmation",
"CustomizeSystemPages.lblRemoveCustomPageLinksConfirmMessage.Text":"You are about to remove all custom links from being displayed on the Tracer Ensemble home page.  Do you want to continue? Click Yes to remove the links or click No to keep them.",
"CustomizeSystemPages.Yes.Text":"Yes",
"CustomizeSystemPages.No.Text":"No",
"CustomPageLink.ManageCustomBuildingAttributes.Text":"Manage Building Custom Attributes",
"CustomPageLink.ManageUsers.Text":"Manage Users",
"DateTime.Items":"<?xml version",
"Default.All.Text":"All",
"default.CollapseAll.Text":"Collapse All",
"default.CustomPageLinks.Text":"Map(s)",
"default.ExpandAll.Text":"Expand All",
"default.lblBuildingIndex.Text":"Buildings Index",
"default.lblFindBuilding.Text":"Finding a Building",
"default.lblFindBuildings.Text":"Find Buildings",
"default.lblUserAsstSearchTips.Text":"Type a building name and click GO. To learn how to find multiple buildings, click",
"default.lbtnManageBuildings.Text":"Manage Buildings",
"default.RecentVisits.Text":"Recent Visits",
"default.SearchTips.Text":"Search Tips",
"SearchResult.lblUserAsstMessage.Text":"Click links under Name for details or select one or more rows and click an action button on the right.",
"DefineHomePage.Add.Text":"Add >",
"DefineHomePage.Back.Text":"< Back",
"DefineHomePage.Columns.AvailableFiles.Text":"Available Files",
"DefineHomePage.Columns.SelectedFiles.Text":"Selected Files",
"DefineHomePage.ContentHeading.Text":"Define Home Page Custom Links",
"DefineHomePage.Finish.Text":"Finish",
"DefineHomePage.lblCustomizeLinkName.Text":"Customize Link Name and Order",
"DefineHomePage.lblHeader.Text":"Header",
"DefineHomePage.lblInformation.Text":"Information",
"DefineHomePage.lblLinkHeader.Text":"Header",
"DefineHomePage.lblLinkHeaderText.Text":"Link Header",
"DefineHomePage.lblMaps.Text":"Maps",
"DefineHomePage.Next.Text":"Next >",
"DefineHomePage.Remove.Text":"< Remove",
"EditParameters.HeadingTitle.Text":"Edit System Parameters",
"Preferences.UserAssistance.Text":"View your general, data display, and regional preferences.  Click Edit to make changes.",
"EditPreferences.btnBack.Text":"< Back",
"EditPreferences.btnCancel.Text":"Cancel",
"EditPreferences.btnSave.Text":"Apply",
"EditPreferences.BtnCancelDashboard.Text":"Cancel",
"EditPreferences.BtnApply.Text":"Apply",
"EditPreferences.lblDashboardHeaderUAText.Text":"Select Dashboard",
"EditPreferences.lblDashboardUAText.Text":"Dashboard",
"EditPreferences.Columns.DataType.Text":"Data Type",
"EditPreferences.Columns.DateFormat.Text":"Date Format",
"EditPreferences.Columns.DefaultDataDisplay.Text":"Default Data Display",
"EditPreferences.Columns.DefaultOverridePriority.Text":"Default Override Priority",
"EditPreferences.Columns.DefaultOverride.Text":"Default Override",
"EditPreferences.Columns.DisplayFilters.Text":"Display Table Filters",
"EditPreferences.Columns.HomePage.Text":"My Home Page",
"EditPreferences.Columns.Language.Text":"Language",
"EditPreferences.Columns.Preference.Text":"Preference",
"EditPreferences.Columns.Setting.Text":"Setting",
"EditPreferences.Columns.TimeFormat.Text":"Time Format",
"EditPreferences.Columns.NumberFormat.Text":"Number Format",
"EditPreferences.Columns.DateSeparators.Text":"Date Separators",
"EditPreferences.Columns.Units.Text":"Unit",
"EditPreferences.Columns.Value.Text":"Value",
"EditPreferences.CustomHomepage.AllAlarms.Text":"All Alarms",
"EditPreferences.CustomHomepage.Tenant.Text":"Tenant",
"EditPreferences.CustomHomepage.Filler.Text":"",
"EditPreferences.CustomHomepage.TracerEnsemble.Text":"Tracer Ensemble Home",
"EditPreferences.DateFormat.DateDayMonthYearFormat.Text":"Day Month Year",
"EditPreferences.DateFormat.DateMonthDayYearFormat.Text":"Month Day Year",
"EditPreferences.DateFormat.DateYearMonthDayFormat.Text":"Year Month Day",
"EditPreferences.DefaultDataDisplay.CustomPage.Text":"Graphics",
"EditPreferences.DefaultDataDisplay.StockPage.Text":"Status",
"EditPreferences.DisplayFilters.Display.Text":"Yes",
"EditPreferences.DisplayFilters.DoNotDisplay.Text":"No",
"EditPreferences.DisplayNotification.Display.Text":"Yes",
"EditPreferences.DisplayNotification.DoNotDisplay.Text":"No",
"EditPreferences.Columns.DisplayNotification.Text":"Product Notifications",
"EditPreferences.Dimension.1.Text":"Temperature",
"EditPreferences.Dimension.10.Text":"Thermal Ramp Rate by Temperature",
"EditPreferences.Dimension.11.Text":"Mass",
"EditPreferences.Dimension.13.Text":"Seconds to Minutes",
"EditPreferences.Dimension.14.Text":"Percentage",
"EditPreferences.Dimension.15.Text":"Concentration",
"EditPreferences.Dimension.16.Text":"Seconds",
"EditPreferences.Dimension.17.Text":"Temperature Offset",
"EditPreferences.Dimension.18.Text":"Generic Pressure",
"EditPreferences.Dimension.19.Text":"Generic Flow",
"EditPreferences.Dimension.2.Text":"Gaseous Pressure",
"EditPreferences.Dimension.3.Text":"Fluid Pressure",
"EditPreferences.Dimension.4.Text":"Gaseous Flow",
"EditPreferences.Dimension.5.Text":"Fluid Flow",
"EditPreferences.Dimension.6.Text":"Cooling Capacity",
"EditPreferences.Dimension.7.Text":"Enthalpy",
"EditPreferences.Dimension.8.Text":"Temperature Delta",
"EditPreferences.Dimension.9.Text":"Thermal Ramp Rate by Time",
"EditPreferences.Dimension.20.Text":"Time",
"EditPreferences.Dimension.21.Text":"Power Electrical",
"EditPreferences.Dimension.22.Text":"Power Cooling",
"EditPreferences.Dimension.23.Text":"Power Heating",
"EditPreferences.Dimension.24.Text":"Energy Electrical",
"EditPreferences.Dimension.25.Text":"Energy Cooling",
"EditPreferences.Dimension.26.Text":"Energy Heating",
"EditPreferences.Dimension.27.Text":"Area",
"EditPreferences.Dimension.28.Text":"Acceleration",
"EditPreferences.Dimension.29.Text":"Duct Pressure",
"EditPreferences.Dimension.30.Text":"Building Pressure",
"EditPreferences.Dimension.31.Text":"Gaseous Volume",
"EditPreferences.Dimension.32.Text":"Fluid Volume",
"EditPreferences.Dimension.Text":"1,2,3,18,4,5,19,31,32,6,7,8,9,10,11,21,22,23,24,25,26,27,28,29,30",
"EditPreferences.HomePageChooser.lblSelectGraphicUA.Text":"Complete the field below to select a custom graphic to act as your home page.",
"EditPreferences.HomePageChooser.Heading.Text":"Select Custom Graphic",
"EditPreferences.HomePageChooser.SelectDashboard.Text":"Select Dashboard",
"EditPreferences.HomePageChooser.SelectGraphicType.Text":"Select Graphic Type",
"EditPreferences.HomePageChooser.SelectGraphicFile.Text":"Select Graphic File",
"EditPreferences.HomePageChooser.SelectGraphicContext.Text":"Select Graphic Object Context",
"EditPreferences.HomePageChooser.rbtnStandard.Text":"Standard",
"EditPreferences.HomePageChooser.rbtnCustom.Text":"Custom",
"EditPreferences.HomePageChooser.rbtnBuilding.Text":"Building",
"EditPreferences.HomePageChooser.NoGraphic.Text":"No Graphic",
"EditPreferences.HomePageChooser.ErrorNoGraphicSelected.Text":"No graphic has been selected.  Please select a graphic or Cancel.",
"EditPreferences.HomePageChooser.SelectCustomGraphic.Text":"Select Custom Graphic...",
"EditPreferences.lblDisplayUnitsHeading.Text":"Data Display Units",
"EditPreferences.lblDisplayUnitsUserAsstMsg.Text":"Select Inch-Pound (IP) or International System (SI) for all the standard units or select Custom and specify each unit of measurement.",
"EditPreferences.lblGeneralPreferencesHeading.Text":"General Preferences",
"EditPreferences.lblGeneralPreferencesUserAsstMessage.Text":"Complete this page and click Save.",
"EditPreferences.lblRegionalSettingsHeading.Text":"Regional Settings",
"EditPreferences.lblUserAsstMessage.Text":"Complete this page and click Save.",
"EditPreferences.lblUserAsstMessageRegionalSettings.Text":"Select your country from the list for its standard regional settings, or select Custom settings and specify each setting.",
"EditPreferences.rbtnCustom.Text":"Custom",
"EditPreferences.rbtnCustomSettings.Text":"Custom Settings",
"EditPreferences.rbtnInchPounds.Text":"Inch-Pounds(IP)",
"EditPreferences.rbtnInternationalSystem.Text":"International System(SI)",
"EditPreferences.rbtnRegional.Text":"Use the language, date format and time format for",
"EditPreferences.TimeFormat.Time12HourFormat.Text":"12-Hour",
"EditPreferences.TimeFormat.Time24HourFormat.Text":"24-Hour",
"EditPreferences.NumberFormat.Dot.Text":"9,999,999.99",
"EditPreferences.NumberFormat.Comma.Text":"9 999 999,99",
"EditPreferences.NumberFormat.DotComma.Text":"9.999.999,99",
"EditPreferences.NumberFormat.DotDot.Text":"9.999.999.99",
"EditPreferences.NumberFormat.NoSpaceDot.Text":"9999999.99",
"EditPreferences.NumberFormat.NoSpaceComma.Text":"9999999,99",
"EditPreferences.DateSeparators.HyphenSeparator.Text":"Hyphen(-)",
"EditPreferences.DateSeparators.SlashSeparator.Text":"Slash(/)",
"EditPreferences.DateSeparators.DotSeparator.Text":"Period(.)",
"EditPreferences.DateSeparators.UnderscoreSeparator.Text":"Underscore(_)",
"EditPreferences.Title.Text":"Edit Preferences",
"EditPreferences.DefaultValue.Text":"--Select--",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.AirhandlerPageContent.xml.Text":"Air Handler",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.ChillerPageContent.xml.Text":"Chiller",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.ChillerPlantPageContent.xml.Text":"ChillerPlant",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.HeatPumpLoopPageContent.xml.Text":"Heat Pump Loop",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.InputOutputPageContent.xml.Text":"Input/Output",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.PCasAirhandlerPageContent.xml.Text":"Programmable Controller as Air Handler",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.PCasChillerPlantPageContent.xml.Text":"Programmable Controller as Chiller Plant",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.PCasHeatPumpLoopPageContent.xml.Text":"Programmable Controller as Heat Pump Loop",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.PCasSpacePageContent.xml.Text":"Programmable Controller as Space",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.PCasVariableAirSystemPageContent.xml.Text":"Programmable Controller as Variable Air System",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.PPCasChillerPageContent.xml.Text":"Programmable Controller as Chiller",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.ProgrammableControllerPageContent.xml.Text":"Programmable Controller",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.SpacePageContent.xml.Text":"Space",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.Text":"ChillerPageContent.xml,AirhandlerPageContent.xml,SpacePageContent.xml,HeatPumpLoopPageContent.xml,ChillerPlantPageContent.xml,VariableAirSystemPageContent.xml,InputOutputPageContent.xml,ProgrammableControllerPageContent.xml,PCasAirhandlerPageContent.xml,PCasSpacePageContent.xml,PCasHeatPumpLoopPageContent.xml,PCasChillerPlantPageContent.xml,PCasVariableAirSystemPageContent.xml,PCasChillerPageContent.xml",
"EnumAddRemoveDataShownEquipmentSubsystem.cboEquipSubSystem.VariableAirSystemPageContent.xml.Text":"Variable Air System",
"EnumAlarmEmailRouting.cboForColumn.0.Text":"No filter,view all",
"EnumAlarmEmailRouting.cboForColumn.attr_name.Text":"Matching Attribute",
"EnumAlarmEmailRouting.cboForColumn.emailids.Text":"E-mail Addresses",
"EnumAlarmEmailRouting.cboForColumn.EmailRoutingRule.Text":"Rule Name",
"EnumAlarmEmailRouting.cboForColumn.ent_pri_id.Text":"Priorities",
"EnumAlarmEmailRouting.cboForColumn.Text":"0,EmailRoutingRule,ent_pri_id,attr_name,emailids",
"EnumAlarmEmailRouting.cboShowOnly.0.Text":"No filter, view all",
"EnumAlarmEmailRouting.cboShowOnly.Text":"0",
"EnumApplicationType.0.Text":"Unknown Application",
"EnumApplicationType.1.Text":"System",
"EnumApplicationType.10.Text":"User Preferences",
"EnumApplicationType.11.Text":"Administration",
"EnumApplicationType.12.Text":"Navigation",
"EnumApplicationType.13.Text":"Test Harness",
"EnumApplicationType.14.Text":"BACnet Services",
"EnumApplicationType.15.Text":"BACnet Simulator",
"EnumApplicationType.16.Text":"Global Change",
"EnumApplicationType.17.Text":"Process Tracker",
"EnumApplicationType.28.Text":"Work Order",
"EnumApplicationType.2.Text":"Site",
"EnumApplicationType.3.Text":"Status",
"EnumApplicationType.4.Text":"Alarm",
"EnumApplicationType.5.Text":"Data Log",
"EnumApplicationType.6.Text":"Schedule",
"EnumApplicationType.7.Text":"Global Point Control",
"EnumApplicationType.9.Text":"Security",
"EnumApplicationType.Text":"0,1,2,3,4,5,6,7,9,10,11,12,13,14,15,16,17,28",
"EnumDateTime.1.Text":"Last Five Minutes",
"EnumDateTime.10.Text":"Last 1 Month",
"EnumDateTime.11.Text":"Last 3 Months",
"EnumDateTime.2.Text":"Last Fifteen Minutes",
"EnumDateTime.3.Text":"Last 1 Hour",
"EnumDateTime.4.Text":"Last 4 Hours",
"EnumDateTime.5.Text":"Last 1 Day",
"EnumDateTime.6.Text":"Last 2 Days",
"EnumDateTime.7.Text":"Last 3 Days",
"EnumDateTime.8.Text":"Last 1 Week",
"EnumDateTime.9.Text":"Last 2 Weeks",
"EnumDateTime.Text":"1,2,3,4,5,6,7,8,9,10,11",
"EnumDefineHomePage.CustomeHomePageLinkOrder.1.Text":"1",
"EnumDefineHomePage.CustomeHomePageLinkOrder.10.Text":"10",
"EnumDefineHomePage.CustomeHomePageLinkOrder.2.Text":"2",
"EnumDefineHomePage.CustomeHomePageLinkOrder.3.Text":"3",
"EnumDefineHomePage.CustomeHomePageLinkOrder.4.Text":"4",
"EnumDefineHomePage.CustomeHomePageLinkOrder.5.Text":"5",
"EnumDefineHomePage.CustomeHomePageLinkOrder.6.Text":"6",
"EnumDefineHomePage.CustomeHomePageLinkOrder.7.Text":"7",
"EnumDefineHomePage.CustomeHomePageLinkOrder.8.Text":"8",
"EnumDefineHomePage.CustomeHomePageLinkOrder.9.Text":"9",
"EnumDefineHomePage.CustomeHomePageLinkOrder.Text":"1,2,3,4,5,6,7,8,9,10",
"EnumEditParameters.IsSynchronizationEnable.true.Text":"Yes",
"EnumEditParameters.IsSynchronizationEnable.false.Text":"No",
"EnumEditParameters.IsSynchronizationEnable.Text":"0,1",
"EnumEditParameters.IsSynchPanelTimeWithUTC.true.Text":"Yes",
"EnumEditParameters.IsSynchPanelTimeWithUTC.false.Text":"No",
"EnumEditParameters.IsSynchPanelTimeWithUTC.Text":"0,1",
"EnumEditParameters.SiteSynchronization.0.Text":"Daily",
"EnumEditParameters.SiteSynchronization.1.Text":"Weekly",
"EnumEditParameters.SiteSynchronization.Text":"0,1",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.0.Text":"Sunday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.1.Text":"Monday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.2.Text":"Tuesday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.3.Text":"Wednesday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.4.Text":"Thursday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.5.Text":"Friday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.6.Text":"Saturday",
"EnumEditParameters.SiteSynchronizationDayOfTheWeek.Text":"0,1,2,3,4,5,6",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.0.Text":"12:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.1.Text":"01:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.10.Text":"10:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.11.Text":"11:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.12.Text":"12:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.13.Text":"01:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.14.Text":"02:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.15.Text":"03:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.16.Text":"04:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.17.Text":"05:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.18.Text":"06:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.19.Text":"07:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.2.Text":"02:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.20.Text":"08:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.21.Text":"09:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.22.Text":"10:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.23.Text":"11:00 PM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.3.Text":"03:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.4.Text":"04:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.5.Text":"05:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.6.Text":"06:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.7.Text":"07:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.8.Text":"08:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.9.Text":"09:00 AM",
"EnumEditParameters.SiteSynchronizationTimeOfTheDay.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23",
"EnumEditParameters.Status.VarianceAlgorithm.Text":"0,1",
"EnumEditParameters.Status.VarianceAlgorithm.0.Text":"Amount out of Comfort Zone",
"EnumEditParameters.Status.VarianceAlgorithm.1.Text":"Space Temp - Active Setpoint",
"EnumEditPreferences.cboUnits.IP.1.Text":"64",
"EnumEditPreferences.cboUnits.IP.10.Text":"94",
"EnumEditPreferences.cboUnits.IP.11.Text":"40",
"EnumEditPreferences.cboUnits.IP.18.Text":"58,61,56,113",
"EnumEditPreferences.cboUnits.IP.19.Text":"84,89",
"EnumEditPreferences.cboUnits.IP.2.Text":"58,61",
"EnumEditPreferences.cboUnits.IP.29.Text":"58,61",
"EnumEditPreferences.cboUnits.IP.30.Text":"58,61",
"EnumEditPreferences.cboUnits.IP.3.Text":"56,113",
"EnumEditPreferences.cboUnits.IP.4.Text":"84",
"EnumEditPreferences.cboUnits.IP.5.Text":"89",
"EnumEditPreferences.cboUnits.IP.6.Text":"52",
"EnumEditPreferences.cboUnits.IP.7.Text":"24,117",
"EnumEditPreferences.cboUnits.IP.8.Text":"120",
"EnumEditPreferences.cboUnits.IP.9.Text":"110",
"EnumEditPreferences.cboUnits.IP.21.Text":"48,47,49",
"EnumEditPreferences.cboUnits.IP.22.Text":"52",
"EnumEditPreferences.cboUnits.IP.23.Text":"50",
"EnumEditPreferences.cboUnits.IP.24.Text":"19",
"EnumEditPreferences.cboUnits.IP.25.Text":"22,19",
"EnumEditPreferences.cboUnits.IP.26.Text":"20,19",
"EnumEditPreferences.cboUnits.IP.27.Text":"1",
"EnumEditPreferences.cboUnits.IP.28.Text":"10263",
"EnumEditPreferences.cboUnits.IP.31.Text":"79,83",
"EnumEditPreferences.cboUnits.IP.32.Text":"83,79",
"EnumEditPreferences.cboUnits.SI.1.Text":"62",
"EnumEditPreferences.cboUnits.SI.10.Text":"92",
"EnumEditPreferences.cboUnits.SI.11.Text":"39",
"EnumEditPreferences.cboUnits.SI.18.Text":"53,59,54,114,112",
"EnumEditPreferences.cboUnits.SI.19.Text":"87,85,88,115,116",
"EnumEditPreferences.cboUnits.SI.2.Text":"53,59,54,114",
"EnumEditPreferences.cboUnits.SI.29.Text":"53,59,54,114",
"EnumEditPreferences.cboUnits.SI.30.Text":"53,59,54,114",
"EnumEditPreferences.cboUnits.SI.3.Text":"54,112",
"EnumEditPreferences.cboUnits.SI.4.Text":"87,85,88,115,116",
"EnumEditPreferences.cboUnits.SI.5.Text":"87,116",
"EnumEditPreferences.cboUnits.SI.6.Text":"48",
"EnumEditPreferences.cboUnits.SI.7.Text":"118",
"EnumEditPreferences.cboUnits.SI.8.Text":"121",
"EnumEditPreferences.cboUnits.SI.9.Text":"111",
"EnumEditPreferences.cboUnits.SI.21.Text":"48,47,49",
"EnumEditPreferences.cboUnits.SI.22.Text":"48",
"EnumEditPreferences.cboUnits.SI.23.Text":"48",
"EnumEditPreferences.cboUnits.SI.24.Text":"17",
"EnumEditPreferences.cboUnits.SI.25.Text":"17",
"EnumEditPreferences.cboUnits.SI.26.Text":"17",
"EnumEditPreferences.cboUnits.SI.27.Text":"0",
"EnumEditPreferences.cboUnits.SI.28.Text":"166",
"EnumEditPreferences.cboUnits.SI.31.Text":"80,81,190,82",
"EnumEditPreferences.cboUnits.SI.32.Text":"82,80,81,190",
"EnumEditPreferences.cboUnits.Text":"1,2,3,18,4,5,19,6,7,8,9,10,11",
"EnumManageScheduleAttributes.cboForColumn.0.Text":"No filter, view all",
"EnumManageScheduleAttributes.cboForColumn.1.Text":"Published",
"EnumManageScheduleAttributes.cboForColumn.2.Text":"Attribute",
"EnumManageScheduleAttributes.cboForColumn.3.Text":"Assigned to Schedules",
"EnumManageScheduleAttributes.cboForColumn.Text":"0,1,2,3",
"EnumManageScheduleAttributes.cboShowOnly.0.Text":"No filter, view all",
"EnumManageScheduleAttributes.cboShowOnly.Text":"0",
"EnumPreferences.cboUnitSystem.IP.Text":"Inch-Pounds",
"EnumPreferences.cboUnitSystem.SI.Text":"International System (SI)",
"EnumPreferences.cboUnitSystem.Text":"SI,IP",
"EnumProcessStep.0.Text":"",
"EnumProcessStep.1.Text":"Checking Higher Priority Object",
"EnumProcessStep.2.Text":"Checking Value Same On Target",
"EnumProcessStep.3.Text":"Creating IO Request",
"EnumProcessStep.4.Text":"Reading Trigger Value",
"EnumProcessStep.5.Text":"Reading Virtual Trigger Value",
"EnumProcessStep.6.Text":"Releasing Target Point",
"EnumProcessStep.7.Text":"Updating Transaction Table",
"EnumProcessStep.8.Text":"Writing Target Value",
"EnumProcessStep.9.Text":"Create Object",
"EnumProcessStep.10.Text":"Read Object",
"EnumProcessStep.11.Text":"Write Object",
"EnumProcessStep.12.Text":"Set Value",
"EnumProcessStep.13.Text":"Read Property Value",
"EnumProcessStep.14.Text":"Add Property To Read",
"EnumProcessStep.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14",
"EnumTransactionErrorType.0.Text":"Success",
"EnumTransactionErrorType.1.Text":"No Such Site",
"EnumTransactionErrorType.10.Text":"No Metadata For BACnet Device",
"EnumTransactionErrorType.11.Text":"BACnet Device Not Supported",
"EnumTransactionErrorType.12.Text":"No Access To Device",
"EnumTransactionErrorType.13.Text":"BACnet Device Not Licensed",
"EnumTransactionErrorType.14.Text":"Service Not Supported By Device",
"EnumTransactionErrorType.15.Text":"Failure To Read Dimension Packet",
"EnumTransactionErrorType.16.Text":"No Such Object",
"EnumTransactionErrorType.17.Text":"Object Offline",
"EnumTransactionErrorType.18.Text":"No Metadata For Object Type",
"EnumTransactionErrorType.19.Text":"Object Not Supported",
"EnumTransactionErrorType.2.Text":"Site Not Yet Connected",
"EnumTransactionErrorType.20.Text":"Object Does Not Support Required Property",
"EnumTransactionErrorType.21.Text":"No Access To Objects Of Family",
"EnumTransactionErrorType.22.Text":"No Access To Objects Of Type",
"EnumTransactionErrorType.23.Text":"Schedule Object Has No Room",
"EnumTransactionErrorType.24.Text":"Database Failure",
"EnumTransactionErrorType.25.Text":"Communication Timeout",
"EnumTransactionErrorType.26.Text":"Communication Offline",
"EnumTransactionErrorType.27.Text":"Communication Busy",
"EnumTransactionErrorType.28.Text":"Communication Error",
"EnumTransactionErrorType.29.Text":"Task Overrun During Data Harvester",
"EnumTransactionErrorType.3.Text":"Site Offline",
"EnumTransactionErrorType.30.Text":"Task Overrun During Global Point Control",
"EnumTransactionErrorType.31.Text":"Target Point In Multiple Global References",
"EnumTransactionErrorType.32.Text":"Value Over Maximum",
"EnumTransactionErrorType.33.Text":"Value Under Minimum",
"EnumTransactionErrorType.34.Text":"Property Is ReadOnly",
"EnumTransactionErrorType.35.Text":"Create Object Failed",
"EnumTransactionErrorType.36.Text":"Delete Object Failed",
"EnumTransactionErrorType.37.Text":"Value Present On Higher Priority",
"EnumTransactionErrorType.4.Text":"No Access To Site",
"EnumTransactionErrorType.5.Text":"Failed To Make Communication Link",
"EnumTransactionErrorType.6.Text":"Failed To Connect Communication Link",
"EnumTransactionErrorType.7.Text":"No Such Device",
"EnumTransactionErrorType.8.Text":"BACnet Device Not Yet Connected",
"EnumTransactionErrorType.9.Text":"BACnet Device Offline",
"EnumTransactionErrorType.38.Text":"Failed To Start All Sites",
"EnumTransactionErrorType.39.Text":"Failed To Start Site",
"EnumTransactionErrorType.40.Text":"Start Site Successful",
"EnumTransactionErrorType.41.Text":"Too Many Schedules In Tracker",
"EnumTransactionErrorType.42.Text":"License Violation",
"EnumTransactionErrorType.43.Text":"Protocol Not Supported",
"EnumTransactionErrorType.44.Text":"Site Already Discovered",
"EnumTransactionErrorType.45.Text":"Add Building Failed",
"EnumTransactionErrorType.46.Text":"Process Alarm Failed",
"EnumTransactionErrorType.47.Text":"Ack Of Alarm Failed",
"EnumTransactionErrorType.48.Text":"Alarm Email Routing Failed",
"EnumTransactionErrorType.49.Text":"Alarm Report Failed",
"EnumTransactionErrorType.50.Text":"No Alarmable Objects Found",
"EnumTransactionErrorType.51.Text":"No Panels Found",
"EnumTransactionErrorType.52.Text":"Upload Site Successful",
"EnumTransactionErrorType.53.Text":"Value Present On Same Priority",
"EnumTransactionErrorType.54.Text":"Application Shutdown",
"EnumTransactionErrorType.55.Text":"No Such User",
"EnumTransactionErrorType.56.Text":"Write Access Denied",
"EnumTransactionErrorType.57.Text":"Panel Alarm Subscription Failed",
"EnumTransactionErrorType.58.Text":"Panel Alarm Unsubscription Failed",
"EnumTransactionErrorType.59.Text":"Panel AlarmSubscriptionFailed RecipientList Full",
"EnumTransactionErrorType.60.Text":"Panel Offline",
"EnumTransactionErrorType.61.Text":"Unsupported Panel Priority",
"EnumTransactionErrorType.62.Text":"Broadcast ACK Alarm",
"EnumTransactionErrorType.63.Text":"Site Report Configuration Not Available",
"EnumTransactionErrorType.64.Text":"Database Size Exceeded",
"EnumTransactionErrorType.65.Text":"Alarm Summary Failed",
"EnumTransactionErrorType.66.Text":"Enrollment Summary Failed",
"EnumTransactionErrorType.67.Text":"Event Summary Failed",
"EnumTransactionErrorType.69.Text":"Create Panel Report Failed",
"EnumTransactionErrorType.70.Text":"Virtual Panel",
"EnumTransactionErrorType.71.Text":"No Panel Objects Found",
"EnumTransactionErrorType.72.Text":"Failed",
"EnumTransactionErrorType.73.Text":"Export DataLogs Failed",
"EnumTransactionErrorType.77.Text":"Write To The Object Failed",
"EnumTransactionErrorType.78.Text":"Backup Failed",
"EnumTransactionErrorType.79.Text":"Restore Failed",
"EnumTransactionErrorType.80.Text":"Cancelled",
"EnumTransactionErrorType.81.Text":"Evox (http) Call Failed",
"EnumTransactionErrorType.82.Text":"Failed",
"EnumTransactionErrorType.83.Text":"Failed to read license",
"EnumTransactionErrorType.84.Text":"SC Offline",
"EnumTransactionErrorType.89.Text":"SC Evox Failed",
"EnumTransactionErrorType.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,70,71,72,73,77,78,79,80,81",
"EnumTransactionType.0.Text":"No Transaction",
"EnumTransactionType.1.Text":"Startup Site Component",
"EnumTransactionType.2.Text":"Startup Connect Site",
"EnumTransactionType.3.Text":"Startup Restart Discovery",
"EnumTransactionType.4.Text":"Time Synchronization User Request",
"EnumTransactionType.5.Text":"Time Synchronization Background",
"EnumTransactionType.6.Text":"Database Synchronization User Request",
"EnumTransactionType.7.Text":"Database Synchronization Background",
"EnumTransactionType.8.Text":"Delete Site Request",
"EnumTransactionType.9.Text":"Heartbeat Manager Backround",
"EnumTransactionType.10.Text":"Reconnect Manager Background",
"EnumTransactionType.11.Text":"New Panel Upload Background",
"EnumTransactionType.12.Text":"New Object Upload Background",
"EnumTransactionType.13.Text":"Building Discovery User Request",
"EnumTransactionType.14.Text":"Heartbeat Processor Background",
"EnumTransactionType.15.Text":"Delete Site Background Heartbeat",
"EnumTransactionType.16.Text":"Reconnect Processor Background",
"EnumTransactionType.17.Text":"Delete Site Background Reconnect",
"EnumTransactionType.18.Text":"Startup Alarming Background",
"EnumTransactionType.19.Text":"Process Alarm",
"EnumTransactionType.20.Text":"Acknowledge Alarm Request",
"EnumTransactionType.21.Text":"All Points In Alarm Request",
"EnumTransactionType.26.Text":"Global Set point Change",
"EnumTransactionType.31.Text":"Delete Global Reference",
"EnumTransactionType.32.Text":"Modify Global Reference",
"EnumTransactionType.33.Text":"Change Of Value",
"EnumTransactionType.34.Text":"Startup Global Point Control",
"EnumTransactionType.35.Text":"GPC Background Process",
"EnumTransactionType.40.Text":"Setpoint Change",
"EnumTransactionType.44.Text":"All Points in Override Request",
"EnumTransactionType.45.Text":"Global Override Request",
"EnumTransactionType.48.Text":"Simplified Override Request",
"EnumTransactionType.49.Text":"Manual Override Request",
"EnumTransactionType.50.Text":"Equipment Override Request",
"EnumTransactionType.51.Text":"Startup Scheduling",
"EnumTransactionType.52.Text":"Create Schedule Panel",
"EnumTransactionType.53.Text":"Modify Schedule Panel",
"EnumTransactionType.54.Text":"Delete Schedule Panel",
"EnumTransactionType.55.Text":"Change Multiple Panel Schedules",
"EnumTransactionType.56.Text":"Create Exception Schedule",
"EnumTransactionType.57.Text":"Modify Exception Schedule",
"EnumTransactionType.58.Text":"Delete Exception Schedule",
"EnumTransactionType.59.Text":"Startup Schedule",
"EnumTransactionType.60.Text":"Delete Site",
"EnumTransactionType.61.Text":"Site Connect",
"EnumTransactionType.62.Text":"System Health",
"EnumTransactionType.63.Text":"Startup DataLogs",
"EnumTransactionType.64.Text":"DataLog Background Process",
"EnumTransactionType.65.Text":"DataLogs Delete Site",
"EnumTransactionType.66.Text":"DataLogs Site Connect",
"EnumTransactionType.67.Text":"DataLogs System Health",
"EnumTransactionType.72.Text":"Diagnostic Reset",
"EnumTransactionType.76.Text":"Create Schedule Template",
"EnumTransactionType.77.Text":"Modify Schedule Template",
"EnumTransactionType.78.Text":"Delete Schedule Template",
"EnumTransactionType.79.Text":"Panel Alarm Processing",
"EnumTransactionType.80.Text":"Timed Override Request",
"EnumTransactionType.81.Text":"Panel Alarm Subscription",
"EnumTransactionType.83.Text":"Site Commissioning",
"EnumTransactionType.84.Text":"Force Rotation",
"EnumTransactionType.85.Text":"Force Add",
"EnumTransactionType.86.Text":"Force Subtract",
"EnumTransactionType.87.Text":"Update Chiller Sequence",
"EnumTransactionType.88.Text":"Chiller Failure Reset",
"EnumTransactionType.89.Text":"Make Chiller Available",
"EnumTransactionType.90.Text":"Make Chiller Unavailable",
"EnumTransactionType.91.Text":"Point Service",
"EnumTransactionType.92.Text":"Database Maintenance",
"EnumTransactionType.93.Text":"Reset Panel",
"EnumTransactionType.94.Text":"Clear Panel RAM",
"EnumTransactionType.95.Text":"Get Alarm Summary",
"EnumTransactionType.96.Text":"Get Enrollment Summary",
"EnumTransactionType.97.Text":"Event Summary",
"EnumTransactionType.98.Text":"Password Reset",
"EnumTransactionType.99.Text":"Create Calendar",
"EnumTransactionType.100.Text":"Modify Calendar",
"EnumTransactionType.101.Text":"Delete Calendar",
"EnumTransactionType.102.Text":"Add New Devices",
"EnumTransactionType.103.Text":"Delete Exception Schedule Group",
"EnumTransactionType.104.Text":"Export Data Logs",
"EnumTransactionType.105.Text":"Delete Notification Class",
"EnumTransactionType.106.Text":"Create Notification Class",
"EnumTransactionType.107.Text":"Modify Notification Class",
"EnumTransactionType.108.Text":"Modify Alarm EventLog Object",
"EnumTransactionType.109.Text":"Backup Device",
"EnumTransactionType.110.Text":"Restore Device",
"EnumTransactionType.111.Text":"Manual Logoff Security",
"EnumTransactionType.112.Text":"Set Critical Point",
"EnumTransactionType.113.Text":"Remove Critical Point",
"EnumTransactionType.114.Text":"Change Critical Point",
"EnumTransactionType.115.Text":"Silence Device",
"EnumTransactionType.116.Text":"After Hours Change",
"EnumTransactionType.118.Text":"After Hours Lighting",
"EnumTransactionType.120.Text":"Preventative Maintenance Process",
"EnumTransactionType.121.Text":"Edit Data Log",
"EnumTransactionType.126.Text":"Alarm Log Report",
"EnumTransactionType.Text":"0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,26,31,32,33,34,35,40,44,45,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,72,76,77,78,79,80,81,83,84,85,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,118,120,121,126",
"EnumUserChangeLog.cboForColumn.0.Text":"No Filter, view all",
"EnumUserChangeLog.cboForColumn.1.Text":"User ID",
"EnumUserChangeLog.cboForColumn.2.Text":"DateTime",
"EnumUserChangeLog.cboForColumn.3.Text":"Building",
"EnumUserChangeLog.cboForColumn.4.Text":"Application",
"EnumUserChangeLog.cboForColumn.5.Text":"Affected",
"EnumUserChangeLog.cboForColumn.6.Text":"Request",
"EnumUserChangeLog.cboForColumn.Text":"0,1,2,3,4,5,6",
"EnumViewBuildingSystemTasks.cboForColumn.1.Text":"No filter, view all",
"EnumViewBuildingSystemTasks.cboForColumn.2.Text":"Task",
"EnumViewBuildingSystemTasks.cboForColumn.3.Text":"Message",
"EnumViewBuildingSystemTasks.cboForColumn.4.Text":"Date/Time",
"EnumViewBuildingSystemTasks.cboForColumn.5.Text":"Status",
"EnumViewBuildingSystemTasks.cboForColumn.6.Text":"Expires",
"EnumViewBuildingSystemTasks.cboForColumn.7.Text":"Can Retry",
"EnumViewBuildingSystemTasks.cboForColumn.Text":"1,2,3,4,5,6,7",
"EnumViewParameter.EmailAuthorization.1.Text":"true",
"EnumViewParameter.EmailAuthorization.2.Text":"false",
"EnumViewParameter.EmailAuthorization.Text":"1,2",
"EnumViewSystemTasks.cboForColumn.0.Text":"No filter, view all",
"EnumViewSystemTasks.cboForColumn.1.Text":"Date/Time",
"EnumViewSystemTasks.cboForColumn.2.Text":"Building",
"EnumViewSystemTasks.cboForColumn.3.Text":"Device",
"EnumViewSystemTasks.cboForColumn.4.Text":"Affected",
"EnumViewSystemTasks.cboForColumn.5.Text":"Application",
"EnumViewSystemTasks.cboForColumn.6.Text":"Request",
"EnumViewSystemTasks.cboForColumn.7.Text":"Process Step",
"EnumViewSystemTasks.cboForColumn.8.Text":"Details",
"EnumViewSystemTasks.cboForColumn.9.Text":"Count",
"EnumViewSystemTasks.cboForColumn.Text":"0,1,2,3,4,5,6,7,8,9",
"EquipmentSummary.BackButton.Text":"< Back",
"EquipmentSummary.CustomizeSystemPage.Text":"Customize System Pages",
"EquipmentSummary.FinishButton.Text":"Finish",
"EquipmentSummary.Grid.CurrentlyDisplayed.Text":"Currently Displayed",
"EquipmentSummary.Grid.StatusTable.Text":"Status Table",
"EquipmentSummary.Grid.SystemDefault.Text":"System Default",
"EquipmentSummary.Heading.FamilyName.Text":"Add/Remove {0} Equipment Summary Data",
"EquipmentSummary.Heading.Text":"Add/Remove Equipment Summary Data",
"EquipmentSummary.Message.Text":"Select the data points you want to appear on the equipment summary.",
"EquipmentSummary.lblUserAsstLastChance.Text":"If you are satisfied with your selections, click Finish to apply them.",
"Error.DefineHomePageLinks.Text":"Please correct the Links Order",
"GlobalApplications.hlnkCustomizeSystemPages.Text":"Customize System Pages",
"GlobalApplications.hlnkGlobalPointControl.Text":"Global Point Control",
"GlobalApplications.hlnkManageAlarmSettings.Text":"Manage Alarm Settings",
"GlobalApplications.hlnkManageScheduleSettings.Text":"Manage Schedule Settings",
"GlobalApplications.lblUserAsstAdmin.Text":"Click one of the options below.",
"GlobalApplications.lblUserAsstCustomizeSystemPages.Text":"--Insert User Assistance Text--",
"GlobalApplications.lblUserAsstGlobalPointControl.Text":"Create and edit global references, or manage virtual points.",
"GlobalApplications.lblUserAsstManageAlarmSettings.Text":"View and modify settings for alarm priority mapping, notification classes, e-mail addresses and routing, ignored alarms, and panel communication alarms.",
"GlobalApplications.lblUserAsstManageScheduleSettings.Text":"View and modify settings used for scheduling.",
"GlobalApplications.TitleHeader.Text":"Global Applications",
"GlobalSetpointDetails.lblBldgHdrSC.Text":"Setpoints with Tracer SCs",
"GlobalSetpointDetails.lblBldgHdrBCU.Text":"Setpoints with BCUs and Trackers",
"GlobalSetpointDetails.Affected.Text":"Affected",
"GlobalSetpointDetails.ChangeBy.Text":"Change By",
"GlobalSetpointDetails.DateTime.Text":"Date/Time",
"GlobalSetpointDetails.Details.Text":"Details",
"GlobalSetpointDetails.SetpointLabels.0.Text":"Unoccupied Cooling Setpoint -",
"GlobalSetpointDetails.SetpointLabels.1.Text":"Occupied Cooling Setpoint -",
"GlobalSetpointDetails.SetpointLabels.2.Text":"Occupied Heating Setpoint -",
"GlobalSetpointDetails.SetpointLabels.3.Text":"Unoccupied Heating Setpoint -",
"GlobalSetpointDetails.SetpointLabels.4.Text":"Occupied StandBy Heating Setpoint -",
"GlobalSetpointDetails.SetpointLabels.5.Text":"Occupied StandBy Cooling Setpoint -",
"GlobalSetpointDetails.SetpointLabels.6.Text":"Space Temperature Setpoint -",
"GlobalSetpointDetails.SetpointLabels.7.Text":"Active Setpoint Request -",
"GlobalSetpointDetails.SetpointLabels.8.Text":"Occupied Offset -",
"GlobalSetpointDetails.SetpointLabels.9.Text":"Occupied Standby Offset -",
"GlobalSetpointDetails.SetpointLabels.10.Text":"Occupied Humidity Setpoint -",
"GlobalSetpointDetails.SetpointLabels.11.Text":"Cooling Setpoint High Limit -",
"GlobalSetpointDetails.SetpointLabels.12.Text":"Cooling Setpoint Low Limit -",
"GlobalSetpointDetails.SetpointLabels.13.Text":"Heating Setpoint High Limit -",
"GlobalSetpointDetails.SetpointLabels.14.Text":"Heating Setpoint Low Limit -",
"GlobalSetpointDetails.SetpointLabels.15.Text":"Local Control -",
"GlobalSetpointDetails.TitleHeader.Text":"Global Setpoint Changes",
"GlobalSetpointDetails.UserAssistance.Text":"This page shows details of the selected changes in the log.",
"GlobalSetpointDetails.Values.Text":"Values",
"HomeTHN.Text":"All Buildings",
"ImportCustomGraphics.CustmGrphcs.Text":"Custom Graphics",
"ImportCustomGraphics.DirectoryPath.Text":"[Directory] - [Path]",
"ImportCustomGraphics.EmptyData.Text":"No Data available.</br> Please Click 'Refresh' to Upload Graphics File.",
"ImportCustomGraphics.FamilyType.1.Text":"Space",
"ImportCustomGraphics.FamilyType.11.Text":"Area",
"ImportCustomGraphics.FamilyType.2.Text":"Chiller",
"ImportCustomGraphics.FamilyType.3.Text":"AirHandler",
"ImportCustomGraphics.FamilyType.5.Text":"ChillerPlant",
"ImportCustomGraphics.FamilyType.6.Text":"HeatPumpLoop",
"ImportCustomGraphics.FamilyType.9.Text":"VariableAirSystem",
"ImportCustomGraphics.FamilyType.Text":"1,2,3,5,6,11,9",
"ImportCustomGraphics.FileName.Text":"File Name",
"ImportCustomGraphics.GraphicName.Text":"Graphic Name",
"ImportCustomGraphics.GraphicsList.Text":"Graphic List",
"ImportCustomGraphics.RefreshButton.Text":"Refresh",
"ImportCustomGraphics.RemoveGraphicsUA.Text":"One or more custom graphics in the database is no longer present in the file system.  Would you like to delete these graphics from the database?",
"ImportCustomGraphics.RemoveYesButton.Text":"Yes",
"ImportCustomGraphics.RemoveNoButton.Text":"No",
"ImportCustomGraphics.UserAssistanceMessage.Text":"This page shows any custom graphics loaded into the system.  Click Refresh to update the page.",
"ImportCustomGraphics.FilePath.Text":"File Path",
"ImportCustomGraphics.LanguageName.Text":"Language",
"ImportCustomGraphics.GraphicCount.0.Text":"Graphic",
"ImportCustomGraphics.GraphicCount.1.Text":"Graphics",
"ImportCustomGraphics.Importing.Text":"Importing...",
"ImportCustomGraphics.PercentComplete.Text":"% Complete.",
"ImportHomepageCustomLinks.btnImportCustomLinks.Text":"Yes-Import Home Page Custom Links",
"ImportHomepageCustomLinks.DialogTitle.Text":"Tracer Ensemble - Import Home Page Custom Links",
"ImportHomepageCustomLinks.lblContentHeading.Text":"Import Home Page Custom Links",
"ImportHomepageCustomLinks.lblUserAsstMessage.Text":"Click to import the file on your system that contains customization details. The details will be stored on the server. Each Home page will contain the hyperlinks to custom pages in the system.",
"L00001.Text":"Invalid UserName/Password",
"L00002.Text":"Password Expired",
"L00003.Text":"Password cannot be blank",
"L00004.Text":"Password Confirmation failed",
"L00005.Text":"Error setting new password",
"L00009.Text":"Your Session has expired",
"lblCustomizeLinkName.UserAssistance.Text":"Specify a name for each link and use the numbers under Link Order to specify the order in which the links will appear on the home page 1 is the first link.",
"Links.PrinterFriendly.Text":"View Printer-Friendly Page",
"ManageAdvancedTasks.ContentHeader.Text":"Manage Advanced Tasks",
"ManageAdvancedTasks.lblLaunchTESMaintenanceApp.Text":"Launch Tracer Ensemble System Maintenance Application",
"ManageAdvancedTasks.lblUserAsstAlarms.Text":"Configure the levels of alarms and how they are managed within the system.",
"ManageAdvancedTasks.lblUserAsstCustomize.Text":"Click to create and manage descriptive fields for sorting, searching, grouping and display.",
"ManageAdvancedTasks.lblUserAsstMessage.Text":"This page enables administrators to configure, customize, manage and setup advanced details of system operation.",
"ManageAdvancedTasks.lblUserAsstSchedule.Text":"Click to view and manage the advanced settings for the scheduling application.",
"ManageAdvancedTasks.lblUserAsstSystemPage.Text":"Customize home, building, and equipment pages by adding and modifying custom pages.",
"ManageAdvancedTasks.lblUserAsstTESLaunch.Text":"Click to open the System Maintenance application to monitor Tracer Ensemble system status and manage product licensing.",
"ManageAdvancedTasks.lblUserAsstTESSysMaint.Text":"Click to view and manage global point control operations.",
"ManageAdvancedTasks.lbtnCustomizeSysPages.Text":"Customize System Pages",
"ManageAdvancedTasks.lbtnGPControl.Text":"Launch Tracer Ensemble Global Point Control Application",
"ManageAdvancedTasks.lbtnManageAlarmSett.Text":"Manage Alarm Settings",
"ManageAdvancedTasks.lbtnManageBuildCustAttri.Text":"Manage Building Custom Attributes",
"ManageAdvancedTasks.lbtnManageScheduleAttributes.Text":"Manage Schedule Attributes",
"ManageAlarmPriorities.AlarmPriority.Text":"Tracer Ensemble Alarm Priority",
"ManageAlarmPriorities.btnBack.Text":"< Back",
"ManageAlarmPriorities.btnFinish.Text":"Finish",
"ManageAlarmPriorities.btnFinishBack.Text":"< Back",
"ManageAlarmPriorities.btnNext.Text":"Next >",
"ManageAlarmPriorities.lblContentHeading.Text":"Select Panel Type",
"ManageAlarmPriorities.lblMapPriority.Text":"Map Alarm Priorities",
"ManageAlarmPriorities.lblPanelType.Text":"Select Panel Type",
"ManageAlarmPriorities.lblUserAsstLastChance.Text":"This is your last chance to go back and make changes. When you click Finish, the selected default alarm mappings are applied to buildings added to the system.",
"ManageAlarmPriorities.lblUserAsstMessage.Text":"Select a panel type below to determine how the system will setup the default alarm mappings when this panel type is discovered for a new building",
"ManageAlarmPriorities.lblUserAsstPriority.Text":"Select the desired Tracer Ensemble Alarm Priority for each desired Panel Priority.",
"ManageAlarmPriorities.PanelPriority.Text":"Priority In Panel",
"ManageAlarmSettings.btnBack.Text":"< Back",
"ManageAlarmSettings.btnNext.Text":"Next >",
"ManageAlarmSettings.lblPageSubTitle.Text":"Select Panel Type To Map",
"ManageAlarmSettings.lblPanelType.Text":"Select panel type to map",
"ManageAlarmSettings.lblUserAsstMessage.Text":"Select a panel type below to determine how the system will setup the default alarm mappings when this panel type is discovered for a new buidling.",
"ManageAlarmSettingsHeader.Text":"Manage Alarm Settings",
"ManageBuildingAlarmPriorities.AlarmPriority.Text":"Tracer Ensemble Alarm Priority",
"ManageBuildingAlarmPriorities.btnBack.Text":"< Back",
"ManageBuildingAlarmPriorities.btnFinish.Text":"Finish",
"ManageBuildingAlarmPriorities.btnNext.Text":"Next >",
"ManageBuildingAlarmPriorities.lblContentHeading.Text":"Map Alarm Priorities",
"ManageBuildingAlarmPriorities.lblFooterDescription.Text":"This is your last chance to go back and make changes. When you click Finish, the selected alarm mappings are applied to the panel selected.",
"ManageBuildingAlarmPriorities.lblMapPanel.Text":"Select Panel Type",
"ManageBuildingAlarmPriorities.lblPanelType.Text":"Panel Type",
"ManageBuildingAlarmPriorities.lblPriorityDescription.Text":"Select the desired Tracer Ensemble Alarm  Priority for each desired Panel Priority.",
"ManageBuildingAlarmPriorities.lblUserAsstMessage.Text":"Select a panel below to determine how the system will setup the alarm mappings for this panel",
"ManageBuildingAlarmPriorities.PanelPriority.Text":"Priority In Panel",
"ManageBuildingCustomAttributes.AttributeName.Text":"Attribute Name",
"ManageBuildingCustomAttributes.AttributeType.Text":"Attribute Type",
"ManageBuildingCustomAttributes.btnBack.Text":"< Back",
"ManageBuildingCustomAttributes.btnDelete.Text":"Delete",
"ManageBuildingCustomAttributes.CurrentlyinUse.Text":"Currently in Use",
"ManageBuildingCustomAttributes.CustomAttributeDeleteError.Text":"Error: Unable to delete one or more custom attribute(s).",
"ManageBuildingCustomAttributes.ErrorText.Text":"Error: A selected attribute cannot be deleted because it is assigned as an attribute for customizing the All Buildings page. To delete the attribute, please remove the assignment first.",
"ManageBuildingCustomAttributes.AlarmingErrorText.Text":"Error: A selected attribute cannot be deleted because it is assigned to an alarm routing rule.  To delete the attribute, please remove the assignment first.",
"ManageBuildingCustomAttributes.ErrorText1.Text":"Please Select Attribute Name to delete.",
"ManageBuildingCustomAttributes.Header.Text":"Manage Building Custom Attributes",
"ManageBuildingCustomAttributes.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"ManageBuildingCustomAttributes.lblSelected.Text":"Selected Attributes",
"ManageBuildingCustomAttributes.lblUserAsstMessage.Text":"Each building can have up to ten custom attributes.  Click links under Attribute Name for details or select one or more rows and click Delete.",
"ManageBuildingCustomAttributes.lbtnAddCustomAttribute.Text":"Add New Building Custom Attribute",
"ManageBuildingCustomAttributes.ValueList.Text":"Value List",
"ManageProgrammableController.AssignedEquipmentFamily.Text":"Assigned Equipment Family",
"ManageProgrammableController.btnApply.Text":"Apply New Values",
"ManageProgrammableController.CurrentEquipmentFamily.Text":"Current Equipment Family",
"ManageProgrammableController.EquipmentName.Text":"Equipment Name",
"ManageProgrammableController.EquipmentType.Text":"Equipment Type",
"ManageProgrammableController.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"ManageProgrammableController.lblContentHeading.Text":"Manage Programmable Controllers",
"ManageProgrammableController.lblModify.Text":"Modified Attributes",
"ManageProgrammableController.lblModifyAssignments.Text":"Modified Assignments",
"ManageProgrammableController.lblUserAsstMessage.Text":"Specify the primary function of the building's programmable controllers and click Apply New Values.",
"ManageScheduleAttributes.AssignSchedules.Text":"Assigned to Schedules",
"ManageScheduleAttributes.Attribute.Text":"Attribute",
"ManageScheduleAttributes.btnApplyFilter.Text":"Apply Filter",
"ManageScheduleAttributes.btnDelete.Text":"Delete",
"ManageScheduleAttributes.btnPublish.Text":"Publish",
"ManageScheduleAttributes.cboForColumn.Items":"<?xml version",
"ManageScheduleAttributes.cboShowOnly.Items":"<?xml version",
"ManageScheduleAttributes.Header.Text":"Manage Tracer Ensemble Schedule Attributes",
"ManageScheduleAttributes.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"ManageScheduleAttributes.lblAssignSchedules.Text":"Assigned to Schedules",
"ManageScheduleAttributes.lblAttribute.Text":"Attribute",
"ManageScheduleAttributes.lblForColumn.Text":"For Column",
"ManageScheduleAttributes.lblPublished.Text":"Published",
"ManageScheduleAttributes.lblSelectedAttributes.Text":"Selected Attributes",
"ManageScheduleAttributes.lblShowOnly.Text":"Show Only",
"ManageScheduleAttributes.lblUserAsstMessage.Text":"The list shows all schedule attributes. Click an attribute and modify it. To delete an attribute, select it and click Delete.",
"ManageScheduleAttributes.lbtnAddScheduleAttribute.Text":"Add New Schedule Attribute",
"ManageScheduleAttributes.Published.Text":"Published",
"ManageTESLicensingPage.lblBack.Text":"< Back",
"ManageTracerEnsembleLicensing.HeaderTitle.Text":"Manage Tracer Ensemble Licensing",
"ManageUserProfilesAndRoles.lblUserAsstManageUsers.Text":"--Insert User Assistance Text--",
"ManageUserProfilesAndRoles.lblUserAsstMessage.Text":"--Insert User Assistance Text--",
"ManageUserProfilesAndRoles.lblUserAsstRoles.Text":"--Insert User Assistance Text--",
"ManageUserProfilesAndRoles.lnkManageProfiles.Text":"Manage User Profiles",
"ManageUserProfilesAndRoles.lnkManageRoles.Text":"Manage User Roles",
"ManageUserProfilesAndRoles.TitleHeader.Text":"Manage User Profiles and Roles",
"CriticalControl.HeaderTitle.Text":"Add To Critical Control",
"ManageViewCriticalControl.HeaderTitle.Text":"Manage Critical Control",
"No.Text":"No",
"no_filter.Text":"No filter, view all",
"Parameters.AlarmMesssageStringFilePath.Text":"Alarm Message String File Path",
"Parameters.AlarmPriorityMappingFilePath.Text":"Alarm Priority Mapping File Path",
"Parameters.Alarmscheduleventmappingfilepath.Text":"Schedule event mapping file path",
"Parameters.GlobalPointControlLogChangeOfValueFailures.Text":"Log Change Of Value Failures",
"Parameters.GlobalPointControlLogChangeOfValueSuccesses.Text":"Log Change of Value Successes",
"Parameters.GlobalPointControlLogOverrideFailures.Text":"Log Override Failures",
"Parameters.GlobalPointControlLogOverrideSuccesses.Text":"Log Override Successes",
"Parameters.GlobalPointControlLogTargetPointFailures.Text":"Log Target Point Failures",
"Parameters.GlobalPointControlLogTargetPointSuccesses.Text":"Log Target Point Successes",
"Parameters.GlobalPointControlLogTriggerPointCommFailures.Text":"Log Trigger Point Comm Failures",
"Parameters.GlobalPointControLogOverrideFailures.Text":"Log Override Failures",
"Parameters.lblAdministratorEmailAddress.Text":"Administrator E-mail Address",
"Parameters.lblAdministratorPassword.Text":"Administrator Password",
"Parameters.lblAdministratorUserName.Text":"Administrator User Name",
"Parameters.lblConfirmAdministratorPassword.Text":"Confirm Password",
"Parameters.lblAlarmApplicationMaxNumberOfLogEntries.Text":"Max number of log entries",
"Parameters.lblAlarmEmailFilePath.Text":"Alarm email(template) file path",
"Parameters.lblBackNetDeviceID.Text":"BACnet Device ID",
"Parameters.lblBackNetDeviceIDForTracer.Text":"BACnet Device ID for Tracer",
"Parameters.lblBackNetDeviceIDForTracker.Text":"BACnet Device ID for Tracker",
"Parameters.lblLOcalDeviceUDPPort.Text":"TES Device UDP Port",
"Parameters.lblEmailAuthentication.Text":"E-mail Authentication",
"Parameters.lblGlobalpointLogChangeofValueFailures.Text":"Log Change of Value Failures",
"Parameters.lblGlobalpointLogChangeofValueSuccesses.Text":"Log Change of Value Successes",
"Parameters.lblGlobalpointLogTargetPointFailures.Text":"Log Target Point Failures",
"Parameters.lblGlobalpointLogTargetPointSuccesses.Text":"Log Target Point Successes",
"Parameters.lblGlobalpointLogTriggerPointCommFailures.Text":"Log Trigger Point Comm Failures",
"Parameters.lblGlobalpointLogTriggerPointSuccesses.Text":"Log Trigger Point Comm Successes",
"Parameters.lblServerNameParameters.Text":"Mail Server Name",
"Parameters.lblMailServerTimeOut.Text":"Mail Server Timeout",
"Parameters.lblMailServerPort.Text":"Mail Server Port",
"Parameters.No.Text":"No",
"Parameters.Disable.Text":"Disable",
"Parameters.IsSynchEnabled.Text":"Auto Synchronization Enabled",
"Parameters.SynchronizationOccurs.Text":"Synchronization Occurs",
"Parameters.IsUTCSynchEnabled.Text":"Synchronization With UTC",
"Parameters.TimeOfDay.Text":"Time of Day",
"Parameters.DayOfWeek.Text":"Day of the Week",
"Parameters.Yes.Text":"Yes",
"Parameters.Enable.Text":"Enable",
"Parameters.Status.VarianceAlgorithm.Text":"Variance Algorithm",
"Parameters.GeneralUISettingsLanguage.Text":"System Default Language",
"Parameters.ReportApplicationSettingsMaxRetry.Text":"Maximum Retry",
"Parameters.SiteSecurityParametersHttpPortSwitching.Text":"HTTP / HTTPS Port Switching",
"Parameters.lblenableSSL.Text":"Secure Socket Layers (SSL)",
"Parameters.GeneralUISettingsLoginBackgroundCustomization.Text":"Customize background image",
"Parameters.default.Text":"Default",
"Parameters.custom.Text":"Custom",
"Preference.btnBack.Text":"< Back",
"Preferences.btnEditPreferences.Text":"Edit",
"Preferences.cboUnitSystem.Items":"<?xml version",
"Preferences.Columns.DataType.Text":"Data Type",
"Preferences.Columns.Preference.Text":"Preference",
"Preferences.Columns.Setting.Text":"Setting",
"Preferences.Columns.Units.Text":"Units",
"Preferences.Columns.Value.Text":"Value",
"Preferences.CurrentRegionalSetting.Text":"Current Regional Settings",
"Preferences.CurrentRegionalSettingValue.Custom.Text":"Custom",
"Preferences.CurrentRegionalSettingValue.US.Text":"US",
"Preferences.DataDisplay.CustomPage.Text":"Graphics",
"Preferences.DataDisplay.StockPage.Text":"Status",
"Preferences.DefaultDataDisplay.Text":"Default Data Display",
"Preferences.DefaultOverridePriorityLevel.Text":"Default Override Priority Level",
"Preferences.DefaultOverride.Text":"Default Override",
"Preferences.DisplayFilters.Text":"Display Table Filters",
"Preferences.DisplayFilters.Display.Text":"Yes",
"Preferences.DisplayFilters.DoNotDisplay.Text":"No",
"Preferences.DisplayNotification.Text":"Product Notifications",
"Preferences.DisplayNotification.Display.Text":"Yes",
"Preferences.DisplayNotification.DoNotDisplay.Text":"No",
"Preferences.HomePage.AllAlarms.Text":"All Alarms",
"Preferences.HomePage.Tenant.Text":"Tenant",
"Preferences.HomePage.WorkOrder.Text":"WorkOrder",
"Preferences.HomePage.Filler.Text":"",
"Preferences.HomePage.TracerEnsemble.Text":"Tracer Ensemble Home",
"Preferences.Language.Text":"Language",
"Preferences.lblApply.Text":"Modified Preferences",
"Preferences.lblCurrentValue.Text":"Current Value",
"Preferences.lblDataDisplayValuesHeading.Text":"Data Display Values",
"Preferences.lblGeneralPreferencesHeading.Text":"General Preferences",
"Preferences.lblHomePage.Text":"My Home Page",
"Preferences.lblNewValue.Text":"New Value",
"Preferences.lblRegionalSettingsHeading.Text":"Regional Settings",
"Preferences.lblUserAsstHomePage.Text":"Select the home page that displays after login.",
"Preferences.Title.Text":"Preferences",
"ProcessStep.Items":"<?xml version",
"ProgressIndicator.Header.Text":"Loading...",
"RegisterTESSiteLicense.lblBackToActionsAndSettings.Text":"< Action and Settings",
"RegisterTESSiteLicense.lblCreateLicenseHeading.Text":"Use the Server ID to Create a License File",
"RegisterTESSiteLicense.lblCreateLicenseUAText.Text":"Click this button to go to the BASRegistration.trane.com website in a new browser window. From there you can create a license file. Then return to this window to upload the license file.",
"RegisterTESSiteLicense.lblGenerateServerId.Text":"Generate Server ID",
"RegisterTESSiteLicense.lblErrorSerialNumber.Text":"Error: You left necessary fields blank or entered invalid values. Review and correct any fields with \"!\" next to them.",
"RegisterTESSiteLicense.lblSerialNum.Text":"Software Serial Number",
"RegisterTESSiteLicense.lblServerId.Text":"Server ID",
"RegisterTESSiteLicense.lblUserAssistAdmin.Text":"This installation is not licensed. Enter the software serial number which Tracer Ensemble will use to create a server ID. Enter the server ID on the licensing site to create a license file. Upload the license file to this page.",
"RegisterTESSiteLicense.lblCopy.Text":"Copy To Clipboard",
"RegisterTESSiteLicense.btnViewDeviceLicensing.Text":"View Device Licensing",
"RegisterTESSiteLicense.btnUpdateTracerEnsembleLicense.Text":"Update Tracer Ensemble License",
"RegisterTESSiteLicense.lblApply.Text":"Apply",
"RegisterTESSiteLicense.lblCancel.Text":"Cancel",
"RegisterTESSiteLicense.btnUploadLicenseFile.Text":"Upload License File",
"RegisterTESSiteLicense.lblLicenseFeatures.Text":"Licensable Add-on Features",
"RegisterTESSiteLicense.lblLicenseFeaturesTenant.Text":"Tenant",
"RegisterTESSiteLicense.lblLicenseFeaturesWorkOrder.Text":"Work Order",
"RegisterTESSiteLicense.lblLicenseFeaturesSAMLSSO.Text":"SAML 2.0 SSO",
"RegisterTESSiteLicense.AIAssistant.Text":"AI Assistant",
"RegisterTESSiteLicense.UploadFile.SuccessMessageFormat":"License {0} Uploaded Successfully",
"RegisterTESSiteLicense.UploadLicenseError2.Text":"Invalid License. Either the Software Maintenance Plan does not exist or the plan is expired, however you may still update your Tracer Ensemble installation.",
"RegisterTESSiteLicense.UploadLicenseError1.Text":"The file that you attempted to upload does not have the expected license file format.",
"RegisterTESSiteLicense.LicenseError1.Text":"The license file is not found.",
"RegisterTESSiteLicense.LicenseError3.Text":"The license file you attempted to use is invalid.",
"RegisterTESSiteLicense.LicenseError6.Text":"The license file you attempted to use has invalid host Id.",
"RegisterTESSiteLicense.LicenseError7.Text":"The license file you attempted to use expired on",
"RegisterTESSiteLicense.helpWhatIfImOffline.Text":"You must have internet access in order to go to the BASRegistration.trane.com web site.<br/><br/> If you do not have internet access at your current location, use the Copy to Clipboard button to capture the Server ID. Save Server ID and move to a location where you do have internet access. Then open a browser and go to the BASRegistration.trane.com to start creating a license file. When prompted, use the Server ID that you already saved.",
"RegisterTESSiteLicense.helpWhatIsCopy.Text":"Use this button to put the Server ID onto the Windows clipboard. Then you can use the \"Ctrl\" and the \"V\" keys simultaneously to paste the Server ID where your cursor is, such as into the licensing web site or into a text editor for later use.",
"RegisterTESSiteLicense.WhatisExpirationDate.Text":"After the Software Maintenance Plan expires, you will be able to use the currently installed version of Tracer Ensemble, upgrade to versions that were released prior to the expiration date, and install service packs for those versions.<br/><br/> You will not be able to upgrade to versions of Tracer Ensemble released after the expiration date unless you renew your Software Maintenance Plan.",
"RegisterTESSiteLicense.FeaturesAdded.NotLicensed.Text":"Feature not licensed",
"RegisterTESSiteLicense.Tenants.LicensedFor.Text":"Licensed for {0} Tenants",
"RegisterTESSiteLicense.Licensed.Text":"Licensed",
"RegisterTESSiteLicense.CriticalControl.Text":"Critical Control",
"RegisterTESSiteLicense.DashBoard.Text":"DashBoard",
"RegisterTESSiteLicense.WhatIf.Text":"What if I'm offline?",
"RegisterTESSiteLicense.Copy.Text":"What is copy?",
"RegisterTESSiteLicense.WhatIsThis.Text":"What is this?",
"RegisterTESSiteLicense.LicenseInfo.Title.Text":"License Information",
"RegisterTESSiteLicense.LicenseType.Full.Text":"Full Tracer Ensemble",
"RegisterTESSiteLicense.LicenseType.Express.Text":"Tracer Ensemble Express",
"RegisterTESSiteLicense.lblGoToWebsite.Text":"Go to Website",
"RegisterTESSiteLicense.lblFileNameDefault.Text":"[No License File]",
"RegisterTESSiteLicense.lblLicenseUsedFormat.Text":"{0} of {1}",
"RemoveCustomLinkHomePage.btnRemoveCustomLinks.Text":"Yes - Remove Home Page Custom Links",
"RemoveCustomLinkHomePage.DialogTitle.Text":"Tracer Ensemble - Remove Home Page Custom Links",
"RemoveCustomLinkHomePage.lblContentHeading.Text":"Remove Home Page Custom Links",
"RemoveCustomLinkHomePage.lblUserAsstMessage1.Text":"Click to remove the custom links section on the Tracer Ensemble Home Page. The links and their heading details will be removed from the server and all Home pages in the system.",
"RemoveCustomLinkHomePage.lblUserAsstMessage2.Text":"Are you sure you want to remove all Tracer Ensemble Home Page Custom Links?",
"RemoveScheduleAttribute.btnCancel.Text":"Cancel",
"RemoveScheduleAttribute.btnModifyAttribute.Text":"ModifyAttribute",
"RemoveScheduleAttribute.DialogTitle.Text":"Tracer Ensemble - Modify Schedule Attribute",
"RemoveScheduleAttribute.lblContentHeading.Text":"Tracer Ensemble Schedule Attribute",
"RemoveScheduleAttribute.lblCurrentAttributeName.Text":"Current Attribute Name",
"RemoveScheduleAttribute.lblNewAttributeName.Text":"New Attribute Name",
"RemoveScheduleAttribute.lblUserAsstMessage.Text":"Take care with your entry. Duplicates will be rejected and misspellings will be accepted.",
"RemoveScheduleAttributes.attributes.Text":"Attribute",
"RemoveScheduleAttributes.btnBack.Text":"< Back",
"RemoveScheduleAttributes.btnRemove.Text":"Remove",
"RemoveScheduleAttributes.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"RemoveScheduleAttributes.lblBuildingSchedules.Text":"Building Schedules Selected",
"RemoveScheduleAttributes.lblContentHeading.Text":"Remove Attributes",
"RemoveScheduleAttributes.lblRemoveAttributes.Text":"Remove Attributes from Normal Schedule",
"RemoveScheduleAttributes.lblSelectedAttributes.Text":"Selected Attributes",
"RemoveScheduleAttributes.lblUserAsstMessage.Text":"Review the list of selected buildings and continue with the next step.",
"RemoveScheduleAttributes.lblUserAsstRemoveAttributes.Text":"The list shows all attributes in the system that are assigned to the selected schedules. Select attributes and click Remove from Schedules.",
"RemoveScheduleAttributes.ScheduleName.Text":"Schedule Name",
"ScheduleAttributes.btnAssign.Text":"Assign Attributes",
"ScheduleAttributes.btnBack.Text":"< Back",
"ScheduleAttributes.btnRemove.Text":"Remove Attributes",
"ScheduleAttributes.CurAttributeList.Text":"Current Attributes List",
"ScheduleAttributes.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"ScheduleAttributes.lblContentHeading.Text":"Manage Schedule Attributes",
"ScheduleAttributes.lblSelectedSchedules.Text":"Selected Schedules",
"ScheduleAttributes.lblUserAsstMessage.Text":"Select a schedule name and assign or remove its attributes.",
"ScheduleAttributes.lbtnManageScheduleAttributes.Text":"Manage Tracer Ensemble Schedule Attributes",
"ScheduleAttributes.PageSize.Text":"25",
"ScheduleAttributes.ScheduleName.Text":"Schedule Name",
"SearchResult.SearchResults.Text":"Search Result",
"SetModifyBuildingAccess.AddressCol.Text":"Address",
"SetModifyBuildingAccess.btnApplyFilter.Text":"Apply Filter",
"SetModifyBuildingAccess.btnBack.Text":"< Back",
"SetModifyBuildingAccess.btnFinish.Text":"Next >",
"SetModifyBuildingAccess.CityCol.Text":"City",
"SetModifyBuildingAccess.CurrentAccessCol.Text":"Current Access",
"SetModifyBuildingAccess.FilterDefaultText.Text":"Type {0} comparison text",
"SetModifyBuildingAccess.lblForColumn.Text":"For Column",
"SetModifyBuildingAccess.lblShowOnly.Text":"Show Only",
"SetModifyBuildingAccess.lblUserAsstMessage.Text":"Apply filters to display a subset of the list. Select and deselect to set and remove building access for the user.",
"SetModifyBuildingAccess.NameCol.Text":"Building Name",
"SetModifyBuildingAccess.NewAccessCol.Text":"New Access",
"SetModifyBuildingAccess.StateCol.Text":"State",
"SetModifyBuildingAccess.THNAdd.Text":"Set Building Access",
"SetModifyBuildingAccess.THNModify.Text":"Modify Building Access",
"Simulator.SimulatorTHN.Text":"BACnet Simulator",
"Simulator.lblUserAsstSimulator.Text":"This is the development front-end for the BACnet Simulator component functionality of TracerEnsemble.",
"Simulator.lblDeviceListHeader.Text":"Selected Devices",
"Simulator.lblTableInformationLabelHeader.Text":"Category",
"Simulator.lblTableInformationHeader.Text":"Value",
"Simulator.lblInformationLabel.Text":"Information:",
"Simulator.lblInformation.Text":"---",
"Simulator.lblContextualControlPanelHeader.Text":"Control Panel",
"Simulator.btnAddSite.Text":"Add Site",
"Simulator.btnAddObject.Text":"Add Object",
"Simulator.btnRemoveSelected.Text":"Remove Selected",
"Simulator.btnImportConfiguration.Text":"Import",
"Simulator.btnExportConfiguration.Text":"Export",
"SystemHealth.SystemHealthTHN.Text":"Advanced System Health",
"SystemHealth.lblUserAsstSystemHealth.Text":"The page displays the Advanced System Health of the TracerEnsemble system.  Designed for use for diagnostics, configuration, and field triage.",
"SystemLogs.hlnkGlobalPointControlLog.Text":"Global Point Control Log",
"SystemLogs.hlnkUserChangeLog.Text":"User Change Log",
"SystemLogs.hlnkViewSystemTasks.Text":"View System Tasks",
"SystemLogs.lblUserAsstGlobalPointControlLog.Text":"View or delete entries in the global point control log.",
"SystemLogs.lblUserAsstSystemLogs.Text":"Click one of the options below.",
"SystemLogs.lblUserAsstUserChangeLog.Text":"View or delete entries in the user change log.",
"SystemLogs.lblUserAsstViewSystemTasks.Text":"View or delete tasks from the system task log.",
"SystemLogs.TitleHeader.Text":"Logs and Reports",
"SystemMaintenance.HeadingTitle.Text":"System",
"SystemMaintenance.lblUserAssistance.Text":"[U/A Text]",
"SystemTask.BuildingName.Text":"Building Name",
"SystemTask.CommunicationState.Text":"Communication State",
"SystemTask.DM_SCHEDULE_FAILURE.Text":"Download FAILED",
"SystemTask.DM_SCHEDULE_SUCCESS.Text":"Download completed successfully",
"SystemTask.DM_SITE_SYNC_FAILURE.Text":"Synchronization FAILED",
"SystemTask.DM_SITE_SYNC_SUCCESS.Text":"Synchronization completed successfully",
"SystemTask.LastRetryDateTime.Text":"Last Retry Date/Time",
"SystemTask.PageSize.Text":"25",
"SystemTaskDetails.btnBack.Text":"< Back",
"SystemTaskDetails.btnRetry.Text":"Retry",
"SystemTaskDetails.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"SystemTaskDetails.lblDate.Text":"Date and Time",
"SystemTaskDetails.lblExpirationTime.Text":"Task Expires",
"SystemTaskDetails.lblSelectedBuildings.Text":"Selected Buildings",
"SystemTaskDetails.lblTask.Text":"Task",
"SystemTaskDetails.lblTaskFailed.Text":"Task Failed For Buildings",
"SystemTaskDetails.lblTaskMessage.Text":"Task Message",
"SystemTaskDetails.lblUserAsstMessage.Text":"Select buildings that this task failed for and then click Retry.",
"SystemTaskDetails.lbtnTaskHistory.Text":"Task History",
"SystemTaskDetailsTHN.Text":"System Task Details",
"SytemMAintenance.lblBack.Text":"< Back",
"T00002.Text":"Unexpected Error",
"T00005.Text":"Invalid set of arguments",
"T00008.Text":"System is not in run mode.",
"TaskHistory.btnBack.Text":"< Back",
"TaskHistory.BuildingName.Text":"Building Name",
"TaskHistory.hlnkPrinterFriendly.Text":"View Printer-Friendly Page",
"TaskHistory.LastRetryDateTime.Text":"Last Retry Date/Time",
"TaskHistory.lblAffectedBuildings.Text":"Affected Buildings",
"TaskHistory.lblDate.Text":"Date and Time",
"TaskHistory.lblExpirationTime.Text":"Task Expires",
"TaskHistory.lblTask.Text":"Task",
"TaskHistory.lblTaskMessage.Text":"Message",
"TaskHistory.lblUserAsstMessage.Text":"History of task success for all buildings the task was assigned to.",
"TaskHistory.NoOfRetries.Text":"Number of Retries",
"TaskHistory.PageSize.Text":"25",
"TaskHistory.RetryResult.Text":"Retry Result",
"TaskHistoryTHN.Text":"Task History",
"TestHarness.TestHarnessTHN.Text":"Development Test Harness",
"TestHarness.lblUserAsstTestHarness.Text":"This page is a development front-end used for integration verification and diagnosis of problems.",
"TransactionErrorType.Items":"<?xml version",
"TransactionType.Items":"<?xml version",
"UnitCelsius.Text":"C",
"UnitFahrenheit.Text":"F",
"UnitPercentage.Text":"%",
"Unknown.TitleHeader.Text":"Setpoint Changes",
"Unknown.UserAssistance.Text":"Click one of the options below.",
"UpdateLicensing.UserAssistAdmin.Text":"Enter the Server ID on the licensing site to create an updated license file. Upload the license file to this page.",
"UpdateLicensing.PageTitle.Text":"Update Tracer Ensemble License",
"UpdateLicensing.BackToManageLicensing.Text":"< Tracer Ensemble Licensing",
"UserChangeLog.Affected.Text":"Object Name",
"UserChangeLog.Application.16.Text":"Global Change",
"UserChangeLog.Application.3.Text":"Status",
"UserChangeLog.Application.6.Text":"Schedule",
"UserChangeLog.Application.Text":"Application Name",
"UserChangeLog.Building.Text":"Building Name",
"UserChangeLog.Columns.Affected.Text":"Affected",
"UserChangeLog.Columns.Application.Text":"Application",
"UserChangeLog.Columns.Building.Text":"Building",
"UserChangeLog.Columns.DateTime.Text":"Date/Time",
"UserChangeLog.Columns.Request.Text":"Request",
"UserChangeLog.Columns.UserId.Text":"User ID",
"UserChangeLog.Delete.Confirmation.Text":"You are about to delete the selected processes from the system.  Do you want to continue?",
"UserChangeLog.EnterAppName.Text":"Enter Application Name to Filter",
"UserChangeLog.EnterBuildingName.Text":"Enter Building Name to Filter",
"UserChangeLog.EnterObjectName.Text":"Enter Object Name to Filter",
"UserChangeLog.EnterUserName.Text":"Enter User Name to Filter",
"UserChangeLog.EnterRequestType.Text":"Enter Request Type to Filter",
"UserChangeLog.lblSelectedLog.Text":"Selected Log",
"UserChangeLog.lblUserAsstMessage.Text":"This page shows changes made by users.  Click links under Request for details or select a row and click Delete to remove it from the log.",
"UserChangeLog.TitleHeader.Text":"User Change Log",
"UserChangeLog.Transaction.26.Text":"Global Setpoint Changes",
"UserChangeLog.Transaction.40.Text":"Setpoint Change",
"UserChangeLog.Transaction.45.Text":"Override",
"UserChangeLog.Transaction.49.Text":"Override",
"UserChangeLog.Transaction.50.Text":"Override",
"UserChangeLog.Transaction.52.Text":"Create Schedule",
"UserChangeLog.Transaction.53.Text":"Modify Schedule",
"UserChangeLog.Transaction.54.Text":"Delete Schedule",
"UserChangeLog.Transaction.55.Text":"Change MultiplePanel Schedule",
"UserChangeLog.Transaction.56.Text":"Create Exception",
"UserChangeLog.Transaction.57.Text":"Modify Exception",
"UserChangeLog.Transaction.58.Text":"Delete Exception",
"UserChangeLog.Transaction.69.Text":"Logged On",
"UserChangeLog.Transaction.70.Text":"Logged Off",
"UserChangeLog.Transaction.71.Text":"Logged Off",
"UserChangeLog.Transaction.98.Text":"Password Reset",
"UserChangeLog.Transaction.72.Text":"Reset Diagnostic",
"UserChangeLog.Transaction.76.Text":"Create Template",
"UserChangeLog.Transaction.77.Text":"Modify Template",
"UserChangeLog.Transaction.78.Text":"Delete Tamplate",
"UserChangeLog.Transaction.80.Text":"Timed Override",
"UserChangeLog.Transaction.84.Text":"Force Rotation",
"UserChangeLog.Transaction.85.Text":"Force Add",
"UserChangeLog.Transaction.86.Text":"Force Subtract",
"UserChangeLog.Transaction.87.Text":"Update Chiller Sequence",
"UserChangeLog.Transaction.88.Text":"Chiller Failure Reset",
"UserChangeLog.Transaction.89.Text":"Make Available",
"UserChangeLog.Transaction.90.Text":"Make Unavailable",
"UserChangeLog.Transaction.91.Text":"Point Service",
"UserChangeLog.Transaction.93.Text":"Panel Reset",
"UserChangeLog.Transaction.111.Text":"Logged Off",
"UserChangeLog.TransactionType.52.Text":"Created Schedule",
"UserChangeLog.TransactionType.53.Text":"Changed Schedule",
"UserChangeLog.TransactionType.54.Text":"Deleted Schedule",
"UserChangeLog.TransactionType.55.Text":"Changed Schedule",
"UserChangeLog.TransactionType.56.Text":"Created Exception",
"UserChangeLog.TransactionType.57.Text":"Changed Exception",
"UserChangeLog.TransactionType.58.Text":"Deleted Exception",
"UserChangeLog.TransactionType.60.Text":"Deleted Site",
"UserChangeLog.TransactionType.76.Text":"Created Schedule Template",
"UserChangeLog.TransactionType.77.Text":"Changed Schedule Template",
"UserChangeLog.TransactionType.78.Text":"Deleted Schedule Template",
"UserChangeLog.TransactionType.84.Text":"Forced Rotation",
"UserChangeLog.TransactionType.85.Text":"Forced Add",
"UserChangeLog.TransactionType.86.Text":"Forced Subtract",
"UserChangeLog.TransactionType.87.Text":"Changed Chiller Sequence",
"UserChangeLog.TransactionType.88.Text":"Reset Failed Chiller",
"UserChangeLog.TransactionType.89.Text":"Made Available",
"UserChangeLog.TransactionType.90.Text":"Made Unavailable",
"UserChangeLog.TransactionType.91.Text":"Changed Point Service",
"UserChangeLog.TransactionType.93.Text":"Reset Panel",
"UserChangeLog.TransactionType.94.Text":"Reset and Cleared RAM",
"UserChangeLog.TransactionType.98.Text":"Reset Password",
"UserChangeLog.TransactionType.99.Text":"Created Calendar",
"UserChangeLog.TransactionType.100.Text":"Modified Calendar",
"UserChangeLog.TransactionType.101.Text":"Deleted Calendar",
"UserChangeLog.TransactionType.112.Text":"Added to Critical Control",
"UserChangeLog.TransactionType.113.Text":"Removed from Critical Control",
"UserChangeLog.TransactionType.114.Text":"Changed Critical Control",
"UserChangeLog.TransactionType.116.Text":"After-Hours Request",
"UserChangeLog.TransactionType.117.Text":"After-Hours Release",
"UserChangeLog.TransactionType.128.Text":"User Management",
"UserChangeLog.TransactionType.130.Text":"Data Log",
"UserChangeLog.TransactionType.Default.Text":"Changed",
"UserChangeLog.TransactionType.ReleaseControl.Text":"Released Control for",
"UserChangeLog.Transaction.From.Text":"From",
"UserChangeLog.Transaction.To.Text":"To",
"UserChangeLog.TransactionTenantOccupied.Text":"Occupied",
"UserChangeLog.Transaction.AtPriority.Text":"At Priority",
"UserChangeLog.Transaction.For.Text":"For",
"UserChangeLog.User ID.Text":"User Name",
"UserChangeLog.Multiple.Text":"Multiple",
"UserChangeLog.Comment.Text":"Comment: {0} with electronic signature",
"UserChangeLog.txtComment.Text":"Comment:",
"UserChangeLog.AcknowledgedStatement.Text":"Acknowledged Statement",
"UserChangeLog.CommentTenant.Text":"Tenant:",
"UserChangeLog.CommentTenantZone.Text":"Zone:",
"UserChangeLog.Point.Text":"Point:",
"UserChangeLog.Transaction45.Text":"Point Change",
"UserChangeLog.Transaction48.Text":"Point Change",
"UserChangeLog.Transaction49.Text":"Point Change",
"UserChangeLog.Transaction50.Text":"Point Change",
"UserChangeLog.Transaction40.Text":"Point Change",
"UserChangeLog.Transaction80.Text":"Point Change",
"UserChangeLog.Transaction26.Text":"Point Change",
"UserChangeLog.Transaction91.Text":"Point Change",
"UserChangeLog.Transaction84.Text":"Chiller Plant Change",
"UserChangeLog.Transaction85.Text":"Chiller Plant Change",
"UserChangeLog.Transaction86.Text":"Chiller Plant Change",
"UserChangeLog.TransactionDisplayName.Default.Text":"Point Change",
"Value.Text":"value",
"ViewBuildingSchedules.btnApply.Text":"Apply",
"ViewBuildingSchedules.btnBack.Text":"< Back",
"ViewBuildingSchedules.btnBackward.Text":"<< Backward",
"ViewBuildingSchedules.btnForward.Text":"Forward >>",
"ViewBuildingSchedules.lblContentHeading.Text":"View Building Schedules",
"ViewBuildingSchedules.lblSelectDay.Text":"Select a day to view",
"ViewBuildingSchedules.lblUserAsstMessage.Text":"The graphic provides a read-only view of selected schedules for comparison.  To make changes in these schedules or leave this screen, click Back.",
"ViewBuildingSystemTasks.btnApplyFilter.Text":"Apply Filter",
"ViewBuildingSystemTasks.btnDelete.Text":"Delete",
"ViewBuildingSystemTasks.btnRetry.Text":"Retry",
"ViewBuildingSystemTasks.Can_Retry.Text":"Can Retry",
"ViewBuildingSystemTasks.cboForColumn.Items":"<?xml version",
"ViewBuildingSystemTasks.DateTime.Text":"Date/Time",
"ViewBuildingSystemTasks.Expires.Text":"Expires",
"ViewBuildingSystemTasks.Last_Failed_Retry.Text":"Last Failed Retry",
"ViewBuildingSystemTasks.lblContentHeading.Text":"System Tasks",
"ViewBuildingSystemTasks.lblForColumn.Text":"For Column",
"ViewBuildingSystemTasks.lblSelectTasks.Text":"Selected Tasks",
"ViewBuildingSystemTasks.lblShowOnly.Text":"Show Only",
"ViewBuildingSystemTasks.lblUserAsstMessage.Text":"To show only selected data, set up For column and Show only. Click Apply Filter. Click a column head to sort. Select Tasks and click Retry or Delete.",
"ViewBuildingSystemTasks.Message.Text":"Message",
"ViewBuildingSystemTasks.Status.Text":"Status",
"ViewBuildingSystemTasks.Tasks.Text":"Tasks",
"ViewLicenseInfo.lblAddress1.Text":"Address 1",
"ViewLicenseInfo.lblAddress2.Text":"Address 2",
"ViewLicenseInfo.lblCity.Text":"City",
"ViewLicenseInfo.lblCountry.Text":"Country",
"ViewLicenseInfo.lblCompany.Text":"Company",
"ViewLicenseInfo.lblEmailAddress.Text":"Email Address",
"ViewLicenseInfo.lblFirstName.Text":"First Name",
"ViewLicenseInfo.lblLastName.Text":"Last Name",
"ViewLicenseInfo.lblLicenseCustomerCode.Text":"Software Serial #",
"ViewLicenseInfo.lblPostalCode.Text":"Postal Code",
"ViewLicenseInfo.lblState.Text":"State",
"ViewLicenseInfo.lblLicenseType.Text":"License Type",
"ViewLicenseInfo.lblLicenseStartDate.Text":"License Creation Date",
"ViewLicenseInfo.lblLicenseEndDate.Text":"Software Maintenance Plan Expiration Date",
"ViewPanelLicensing.btnActivateLicenses.Text":"Activate Licenses",
"ViewPanelLicensing.btnDeactivateLicenses.Text":"Deactivate Licenses",
"ViewPanelLicensing.btnBack.Text":"< Tracer Ensemble Licensing",
"ViewPanelLicensing.lblLicenseUsed.Text":"Active Licenses",
"ViewPanelLicensing.lblNumberOfPanels.Text":"Number Of Devices",
"ViewPanelLicensing.lblTentativeLicenseUsed.Text":"Tentative Licenses Used",
"ViewPanelLicensing.lblUserAsstMessageViewPanelLicensing.Text":"This page shows the licensing status of each of the panels registered with Tracer ES.",
"ViewPanelLicensing.lblViewPanelLicensing.Text":"View Device Licensing",
"ViewPanelLicensing.lblYes.Text":"Yes",
"ViewPanelLicensing.lblNo.Text":"No",
"ViewParameter.Alarmpriority.Text":"Alarm Priority Mapping File Path",
"ViewParameter.EnableAudibleAlarm.Text":"Enable Audible Alarms",
"ViewParameter.AudibleAlarmMediaPath.Text":"Audible Alarm File Path",
"ViewParameterError.Text":"configuration File Error",
"ViewParameters.btnEditParameters.Text":"Edit",
"HubParameters.btnEditParameters.Text":"Edit",
"HubParameters.btnCreateVirtualHub.Text":"Create Virtual Hub",
"HubParameters.btnManageHubAction.Text":"Manage Hub Action",
"HubParameters.URIError.Text":"Invalid URI entered.",
"HubParameters.HubPortError.Text":"Port Number cant be zero.",
"HubParameters.VmacError.Text":"Invalid VMAC entered.",
"HubParameters.HubuidError.Text":"Invalid HubUID entered.",
"HubParameters.lblHubServer.Text":"Enable Ensemble Hub Server",
"EditHubParameters.HeadingTitle.Text":"Edit Hub Parameters",
"ViewParameters.Columns.Parameters.Text":"Parameter",
"ViewParameters.Columns.Value.Text":"Value",
"ViewParameters.Columns.ShowOnLogin.Text":"Show on Login",
"ViewParameters.Columns.InUse.Text":"In Use",
"ViewParameters.EditTitle.Text":"Parameters",
"ViewParameters.HeadingTitle.Text":"System Parameters",
"HubParameters.HeadingTitle.Text":"Hub Parameters",
"ViewParameters.lblAlarmApplicationParameters.Text":"Alarm Application Parameters",
"ViewParameters.lblBuildingDiscoveryParametersHeading.Text":"Building Discovery Parameters",
"HubParameters.lblHubParametersHeading.Text":"Hub Parameters",
"ViewHubParameters.HeadingTitle.Text":"View Hub Parameters",
"ViewParameters.lblEmailServerParameters.Text":"E-mail Server Parameters",
"ViewParameters.lblLoggingParameters.Text":"Logging Parameters",
"ViewParameters.lblGlobalPointControlParameters.Text":"Global Point Control Parameters",
"ViewParameters.lblSiteSynchParameter.Text":"Site Synchronization Parameters",
"ViewParameters.lblTimeSynchParameters.Text":"Time Synchronization Parameters",
"ViewParameters.lblStatusApplicationParameters.Text":"Status Application Parameters",
"ViewParameters.lblGeneralDisplaySettingsParameters.Text":"General Display Settings",
"ViewParameters.lblSystemLanguageParameters.Text":"System Language Support",
"ViewParameters.lblReportApplicationSettings.Text":"Report Application Settings",
"ViewParameters.lblSiteSecurityParameters.Text":"Site Security Parameters",
"ViewSystemStatus.CurrSts.Text":"Current System State",
"ViewSystemStatus.LastAction.Text":"Last Action",
"ViewSystemStatus.Name.Text":"Name",
"ViewSystemStatus.ServerIP.Text":"Server IP Address",
"ViewSystemStatus.ServerName.Text":"Server Name",
"ViewSystemStatus.Status.Text":"Status",
"ViewSystemStatus.StsObtained.Text":"Status Obtained",
"ViewSystemStatus.TESVersion.Text":"Tracer Ensemble Product Version",
"ViewSystemStatus.GetDatabaseVersion.Text":"Tracer Ensemble Database Version",
"ViewSystemStatus.Threads.Text":"Threads",
"ViewSystemStatus.TitleHeader.Text":"System Status",
"ViewSystemStatus.TracerApp.Text":"Tracer Ensemble Applications",
"ViewSystemStatus.UserAssistance.Text":"This page shows the current server status and network performance, and the health of the individual applications that make up Tracer Ensemble.",
"ViewSystemStatus.Enum.Unknown.Text":"Unknown",
"ViewSystemStatus.Enum.Initialized.Text":"Initialized",
"ViewSystemStatus.Enum.Operational.Text":"Operational",
"ViewSystemStatus.Enum.NotOperational.Text":"Not Operational",
"ViewSystemTasks.Affected.Text":"Affected",
"ViewSystemTasks.ApplicationName.Text":"Application",
"ViewSystemTasks.btnApplyFilter.Text":"Apply Filter",
"ViewSystemTasks.btnDelete.Text":"Delete",
"ViewSystemTasks.btnRetry.Text":"Retry",
"ViewSystemTasks.Building.Text":"Building",
"ViewSystemTasks.cboForColumn.Items":"<?xml version",
"ViewSystemTasks.DateTime.Text":"Date/Time",
"ViewSystemTasks.Device.Text":"Device",
"ViewSystemTasks.DM_ALARM.Text":"Communications",
"ViewSystemTasks.DM_DATA_COLLECTION.Text":"Trending",
"ViewSystemTasks.DM_SCHEDULE.Text":"Scheduler",
"ViewSystemTasks.DM_SITE_SYNC.Text":"System",
"ViewSystemTasks.Error.Text":"Details",
"ViewSystemTasks.lblForColumn.Text":"For Column",
"ViewSystemTasks.lblSelectTasks.Text":"Selected Tasks",
"ViewSystemTasks.lblShowOnly.Text":"Show Only",
"ViewSystemTasks.lblUserAsstMessage.Text":"This page shows tasks the system did not complete.  Select one or more rows and click Delete to remove them from the list.",
"ViewSystemTasks.Message.Text":"Message",
"ViewSystemTasks.No.Text":"No",
"ViewSystemTasks.PageSize.Text":"25",
"ViewSystemTasks.ProcessStep.Text":"Process Step",
"ViewSystemTasks.Request.Text":"Request",
"ViewSystemTasks.Retry.Text":"Retry",
"ViewSystemTasks.Tasks.Text":"Task",
"ViewSystemTasks.Yes.Text":"Yes",
"ViewSystemTasks.LogCount.Text":"Count",
"ViewSystemTasksTHN.Text":"System Tasks",
"ViewTask.Message.Text":"View Tasks",
"ViewTask.NotChecked.Text":"At least one checkbox must be checked",
"ConfigureADDServices.TitleHeader.Text":"Configure Network Authentication Domain Services",
"ConfigureADDServices.UserAssistance.Text":"This page shows the system to configure Network Authentication Services.",
"ConfigureADDServices.lblADDConnectionStatus.Text":"Active Directory Connection Status",
"ConfigureADDServices.lblADDServerName.Text":"Domain",
"ConfigureADDServices.lblADDIPAddress.Text":"IP Address or DNS Name",
"ConfigureADDServices.lblADDLoginID.Text":"User Name",
"ConfigureADDServices.lblADDPassword.Text":"Password",
"ConfigureADDServices.btnConnectionString.Text":"Test Connection",
"ConfigureADDServices.ConnectionSuccess.Text":"Successfully connected to authentication server. Click Save below to remain connected to and use this service.",
"ConfigureADDServices.DomainNotAvailable.Text":"Connection failed: Unable to reach provided server on that domain.",
"ConfigureADDServices.InvalidCredentials.Text":"Connection failed: Invalid user name and password combination.",
"ConfigureADDServices.ConnectionTesting.Text":"Testing...",
"ConfigureADDServices.ConnectionFailure.Text":"Connection Failed",
"ConfigureADDServices.lblTestConnectionResult.Text":"Connection Test",
"ConfigureADDServices.rdbtnDisableConfiguration.Text":"Disabled",
"ConfigureADDServices.rdbtnEnableConfiguration.Text":"Enable Active Directory Authentication",
"ConfigureADDServices.lblSpecDomainServerInfo.Text":"Specify the Domain Server Information",
"ConfigureADDServices.lblSpecUserCredentials.Text":"Specify the credentials used to access the Domain Server",
"Error.UI.PasswordMatchesUserId.Text":"Error: The password and username should not be same.",
"Wizards.BackButton.Text":"< Back",
"Wizards.CancelButton.Text":"Cancel",
"Wizards.DeleteButton.Text":"Delete",
"Wizards.EditButton.Text":"Edit",
"Wizards.FinishButton.Text":"Finish",
"Wizards.NextButton.Text":"Next >",
"PwdResetDetails.UserAssistance.Text":"This page shows details of selected changes in the log.",
"PwdResetDetails.Details.Text":"Details",
"PwdResetDetails.Affected.Text":"Affected",
"PwdResetDetails.ChangeBy.Text":"Change By",
"PwdResetDetails.DateTime.Text":"Date/Time",
"PanelResetDetails.Affected.Text":"Affected",
"PanelResetDetails.Building.Text":"Building",
"PanelResetDetails.DateTime.Text":"Date/Time",
"PanelResetDetails.ChangeBy.Text":"Change By",
"PanelResetDetails.Details.Text":"Details",
"PanelResetDetails.PanelType.Text":"Panel Type",
"PanelResetDetails.UserAssistance.Text":"This page shows details of selected changes in the log.",
"PanelResetDetails.Header.Text":"Panel Reset Details",
"PointServiceDetails.Header.Text":"Point Service Details",
"OverrideDetails.Header.Text":"Override Details",
"OverrideDetails.Details.Text":"Details",
"OverrideDetails.UserAssistance.Text":"This page shows details of the selected override in the log.",
"OverrideDetails.DateTime.Text":"Date/Time",
"OverrideDetails.Building.Text":"Building",
"OverrideDetails.Affected.Text":"Affected",
"OverrideDetails.RequestedValue.Text":"Requested Value",
"OverrideDetails.Priority.Text":"Priority",
"OverrideDetails.ChangeBy.Text":"Change By",
"OverrideDetails.PointService.Text":"Point Service",
"OverrideDetails.OutOfService.Text":"Out Of Service",
"OverrideDetails.ReleaseControl.Text":"Release Control",
"PwdResetDetails.Header.Text":"Password Reset Details",
"ResetDiagnosticDetails.Header.Text":"Reset Diagnostic Details",
"SetpointChangeDetails.Header.Text":"Setpoint Changes",
"SetpointChangeDetails.Details.Text":"Details",
"SetpointChangeDetails.UserAssistance.Text":"This page shows details of the selected changes in the log.",
"SetpointChangeDetails.DateTime.Text":"Date/Time",
"SetpointChangeDetails.Building.Text":"Building",
"SetpointChangeDetails.Affected.Text":"Affected",
"SetpointChangeDetails.PropertyName.Text":"Property",
"SetpointChangeDetails.NewValue.Text":"New Value",
"SetpointChangeDetails.OldValue.Text":"Old Value",
"SetpointChangeDetails.ChangeBy.Text":"Changed By",
"ViewPanelLicensing.PanelType.0.Text":"Unknown",
"ViewPanelLicensing.PanelType.100.Text":"Tracer BCU",
"ViewPanelLicensing.PanelType.101.Text":"BCU Bridge",
"ViewPanelLicensing.PanelType.200.Text":"Tracker",
"ViewPanelLicensing.PanelType.4.Text":"Generic BACnet Device",
"ViewPanelLicensing.PanelType.5.Text":"BMN Tracker",
"ViewPanelLicensing.PanelType.6.Text":"Generic BACnet Device",
"ViewPanelLicensing.PanelType.7.Text":"Trane Application",
"ViewPanelLicensing.PanelType.210.Text":"UC210",
"ViewPanelLicensing.PanelType.400.Text":"UC400",
"ViewPanelLicensing.PanelType.401.Text":"BCI-C",
"ViewPanelLicensing.PanelType.402.Text":"BCI-I",
"ViewPanelLicensing.PanelType.403.Text":"BCI-R",
"ViewPanelLicensing.PanelType.405.Text":"BCI2-I",
"ViewPanelLicensing.PanelType.406.Text":"BCI2-R",
"ViewPanelLicensing.PanelType.407.Text":"BCI2-C",
"ViewPanelLicensing.PanelType.600.Text":"UC600",
"ViewPanelLicensing.PanelType.800.Text":"UC800",
"ViewPanelLicensing.PanelType.900.Text":"Tracer SC",
"ViewPanelLicensing.PanelType.901.Text":"Tracer SC+",
"ViewPanelLicensing.PanelType.902.Text":"Tracer SC Concierge",
"ViewPanelLicensing.PanelType.998.Text":"Pivot",
"Administration.FileName.Text":"File Name",
"Administration.LinkName.Text":"Link Name",
"Administration.LinkOrder.Text":"Link Order",
"Addministration.AddUserProfile.Text":"Add User Profile",
"Administration.EditUserProfile.Text":"Edit User Profile",
"Administration.EditSystemParameters.Error1.Text":"Application could not make changes to System Parameters",
"Administration.EditSystemParameters.Error2.Text":"There is another person making changes. Please check after some time.",
"CustomizeDisplayBuildingsHomePage.Error1.Text":"Application could not save the group levels",
"ViewPanelLicensing.Error1.Text":"Error: Current Panel Count is greater then total number of panels",
"ViewPanelLicensing.Error2.Text":"Error: You did not select any items.  Select items before you click an action button.",
"ViewPanelLicensing.Error3.Text":"Error: License count exceeded, please contact Administrator.",
"UploadLicensing.Error1.Text":"Error: The license file cannot be uploaded because it is invalid or cannot be recognized.",
"ApplyLicensing.Error1.Text":"Customer code does not match, please verify",
"ApplyLicensing.Error2.Text":"License request could not be sent, Please try again",
"DefineHomePageCustomLinks.Error1.Text":"Selected Files List cannot exceed 25 count",
"DefineHomePageCustomLinks.SetGraphicContext.Text":"Set Graphic Context",
"DefineHomePageCustomLinks.SetGraphicContextUserAsst.Text":"Complete the fields below to set the context of the custom graphic.",
"DefineHomePageCustomLinks.Building.Text":"Building",
"DefineHomePageCustomLinks.Family.Text":"Family",
"DefineHomePageCustomLinks.ObjectType.Text":"Object Type",
"DefineHomePageCustomLinks.ObjectName.Text":"Object Name",
"DefineHomePageCustomLinks.SiteName.Text":"Site Name",
"DefineHomePageCustomLinks.Context.Text":"Context",
"DefineHomePageCustomLinks.GraphicDefined.Text":"Graphic-defined",
"DefineHomePageCustomLinks.AddContext.Text":"Add Context",
"DefineHomePageCustomLinks.Change.Text":"Change",
"DefineHomePageCustomLinks.Remove.Text":"Remove",
"Windows.lblDataSource.Text":"Data Source:",
"Windows.lblDataBaseName.Text":"DataBase Name:",
"Windows.lblDataBaseUserName.Text":"User Name:",
"Windows.lblDataBasePassword.Text":"Password:",
"Parameters.lblNetworkDeviceID.Text":"Local Network Name",
"Parameters.lblSubnetMaskID.Text":"Local Subnet Mask",
"Parameters.lblprimaryHubUri.Text":"Primary Hub URI",
"Parameters.lblFailOverHubUri.Text":"FailOver Hub URI",
"Parameters.lblnodeCertificatePath.Text":"Node Certificate Path",
"Parameters.lblcaCertificatePath.Text":"CA Certificate Path",
"Parameters.lblissuerCertificatePath.Text":"Issuer CA Certificate Path",
"Parameters.lblhubVMAC.Text":"Hub VMAC",
"Parameters.lblhubUuid.Text":"Hub Uuid",
"Parameters.lblportNumber.Text":"Port Number",
"Parameters.lblBACNetSCServerCertificatePath.Text":"Hub Server Certificate Path",
"Parameters.lbltlsProtocol.Text":"TLS Protocol",
"ViewParameters.lblDatabaseParameters.Text":"DataBase Parameters",
"Windows.lblTimeInterval.Text":"Auto Log Off Time Interval",
"Windows.lblSSL.Text":"SSL",
"Windows.lblWebCofigAPPSetting.Text":"Settings",
"Windows.Error.Text":"SSL: {0} is incompatiable with your IIS settings.",
"Windows.Warning.Text":"Incompatible Trane Connect settings.\nPlease restart the Remote Access Service from Tracer Ensemble",
"EnumWindows.SSL.Text":"0,1,2",
"EnumWindows.SSL.0.Text":"None",
"EnumWindows.SSL.1.Text":"Password",
"EnumWindows.SSL.2.Text":"All",
"Windows.lblLogDirectory.Text":"Log Directory",
"Windows.lblMaxNumberOfLogDirectiories.Text":"Max Number Of Log Directories",
"Windows.lblMaxNumberOfAppLogFiles.Text":"Max Number Of Application Log Files",
"Parameters.lblMaxAppLogFilesSize.Text":"Max Application Log File Size",
"Links.TracerEnsembleHome.Text":"Tracer Ensemble Home",
"Links.MyHome.Text":"My Home",
"ImportCustomGraphics.Header.Text":"Custom Graphics",
"Empty.LinkHeaderName.Text":"---",
"BuildingTree.lblNone.Text":"None",
"ViewParameters.UserAssistance.Text":"This page shows the general parameters used by Tracer Ensemble system for building discovery, alarms, e-mail, global point control, and site synchronization. Click Edit to make changes.",
"EditSystemParameters.UserAssistance.Text":"Type new values or make new selections for the system parameters as desired and click Save.",
"ViewLicenseInformation.UserAssistance.Text":"This page shows licensing information for the system you are using.",
"UploadLicense.UserAssistance.Text":"Complete this page and click Finish to upload a new license file.  Click Browse, then locate and select the license file you want to use.",
"DefineCustomHomepage.UserAssistance1.Text":"Complete the section below and click Finish to apply the changes.",
"SystemMaintenance.lblUserAsstAdmin.Text":"Click one of the options below.",
"Parameters.UsernameMinimumLength.Text":"Username Minimum Length",
"Parameters.UsernameMaximumLength.Text":"Username Maximum Length",
"Parameters.UsernameRequiresMixedCase.Text":"Username Requires Mixed Case",
"Parameters.UsernameRequiresNumber.Text":"Username Requires Number",
"Parameters.UsernameRequiresSymbol.Text":"Username Requires Symbol",
"Parameters.PasswordMinimumLength.Text":"Password Minimum Length",
"Parameters.PassowrdMaximumLength.Text":"Password Maximum Length",
"Parameters.PasswordRequiresMixedCase.Text":"Password Requires Mixed Case",
"Parameters.PasswordRequiresNumber.Text":"Password Requires Number",
"Parameters.PasswordRequiresSymbol.Text":"Password Requires Symbol",
"Parameters.PasswordMayContainUsername.Text":"Password May Contain Username",
"Parameters.PasswordMayContainCommonWord.Text":"Password May Contain CommonWord",
"Parameters.PasswordMayContainCommonSequences.Text":"Password May Contain Common Sequences",
"Parameters.PasswordMayContainRepeatedCharacterSeries.Text":"Password May Contain Repeated Character Series",
"Parameters.PasswordHistory.Text":"Password History",
"Parameters.PasswordExpiresInDays.Text":"Password Expires In Days",
"ViewParameters.lblUserNamePasswordParameters.Text":"User Security Parameters",
"CustomizeStatusPageGlobal.lblUserAsstAdmin.Text":"Select the equipment or subsystem family type to customize and click Next.",
"EquipmentSummary.UserAssistanceMessage.Text":"Select to show data points on the summary page and clear to delete data points from the summary page.",
"EnumEditSystemParameters.UserNameDropdowlist.Text":"1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25",
"EnumEditSystemParameters.UserNameDropdowlist.1.Text":"1",
"EnumEditSystemParameters.UserNameDropdowlist.2.Text":"2",
"EnumEditSystemParameters.UserNameDropdowlist.3.Text":"3",
"EnumEditSystemParameters.UserNameDropdowlist.4.Text":"4",
"EnumEditSystemParameters.UserNameDropdowlist.5.Text":"5",
"EnumEditSystemParameters.UserNameDropdowlist.6.Text":"6",
"EnumEditSystemParameters.UserNameDropdowlist.7.Text":"7",
"EnumEditSystemParameters.UserNameDropdowlist.8.Text":"8",
"EnumEditSystemParameters.UserNameDropdowlist.9.Text":"9",
"EnumEditSystemParameters.UserNameDropdowlist.10.Text":"10",
"EnumEditSystemParameters.UserNameDropdowlist.11.Text":"11",
"EnumEditSystemParameters.UserNameDropdowlist.12.Text":"12",
"EnumEditSystemParameters.UserNameDropdowlist.13.Text":"13",
"EnumEditSystemParameters.UserNameDropdowlist.14.Text":"14",
"EnumEditSystemParameters.UserNameDropdowlist.15.Text":"15",
"EnumEditSystemParameters.UserNameDropdowlist.16.Text":"16",
"EnumEditSystemParameters.UserNameDropdowlist.17.Text":"17",
"EnumEditSystemParameters.UserNameDropdowlist.18.Text":"18",
"EnumEditSystemParameters.UserNameDropdowlist.19.Text":"19",
"EnumEditSystemParameters.UserNameDropdowlist.20.Text":"20",
"EnumEditSystemParameters.UserNameDropdowlist.21.Text":"21",
"EnumEditSystemParameters.UserNameDropdowlist.22.Text":"22",
"EnumEditSystemParameters.UserNameDropdowlist.23.Text":"23",
"EnumEditSystemParameters.UserNameDropdowlist.24.Text":"24",
"EnumEditSystemParameters.UserNameDropdowlist.25.Text":"25",
"EnumEditSystemParameters.ReportMaxRetryDropdowlist.Text":"0,1,2,3",
"EnumEditSystemParameters.ReportMaxRetryDropdowlist.0.Text":"0",
"EnumEditSystemParameters.ReportMaxRetryDropdowlist.1.Text":"1",
"EnumEditSystemParameters.ReportMaxRetryDropdowlist.2.Text":"2",
"EnumEditSystemParameters.ReportMaxRetryDropdowlist.3.Text":"3",
"SystemAdminFileUpload.Browse.Text":"Browse...",
"RecentVisitPage.Text":"Recent Visit",
"EnumBuilding.PriorityList.1.Text":"1 - User - Emergency",
"EnumBuilding.PriorityList.2.Text":"2 - Custom Programming - No Min",
"EnumBuilding.PriorityList.3.Text":"3 - Minimum On/Off",
"EnumBuilding.PriorityList.4.Text":"4 - User - High",
"EnumBuilding.PriorityList.5.Text":"5 - Custom Programming - High",
"EnumBuilding.PriorityList.6.Text":"6 - Miscellaneous",
"EnumBuilding.PriorityList.7.Text":"7 - Demand Limiting",
"EnumBuilding.PriorityList.8.Text":"8 - Miscellaneous",
"EnumBuilding.PriorityList.9.Text":"9 - VAV Air Systems",
"EnumBuilding.PriorityList.10.Text":"10 - Chiller Plant Control",
"EnumBuilding.PriorityList.11.Text":"11 - Area Control",
"EnumBuilding.PriorityList.12.Text":"12 - User - Low",
"EnumBuilding.PriorityList.13.Text":"13 - Miscellaneous",
"EnumBuilding.PriorityList.14.Text":"14 - Timed Override",
"EnumBuilding.PriorityList.15.Text":"15 - Time of Day Schedules",
"EnumBuilding.PriorityList.16.Text":"16 - Custom Programming - Low",
"EnumBuilding.Language.de-DE.Text":"de-DE",
"EnumBuilding.Language.en-US.Text":"en-US",
"EnumBuilding.Language.es-MX.Text":"es-MX",
"EnumBuilding.Language.fr-FR.Text":"fr-FR",
"EnumBuilding.Language.zh-CN.Text":"zh-CN",
"EnumBuilding.Language.pl-PL.Text":"pl-PL",
"EnumBuilding.Language.en-CA.Text":"en-CA",
"EnumBuilding.Language.id-ID.Text":"id-ID",
"EnumBuilding.Language.ja-JP.Text":"ja-JP",
"EnumBuilding.Language.ko-KR.Text":"ko-KR",
"EnumBuilding.Language.pt-BR.Text":"pt-BR",
"EnumBuilding.Language.th-TH.Text":"th-TH",
"EnumBuilding.Language.zh-TW.Text":"zh-TW",
"EnumBuilding.Language.ar-QA.Text":"ar-QA",
"ViewParameters.lblAllPointOverridePriority.Text":"All Point Override Priority Parameters for BCUs and Trackers",
"ViewParameters.lblAllPointOverridePriorityforSC.Text":"All Point Override Priority Parameters for BACnet Devices",
"Parameters.lblRoutingEnabled.Text":"Routing Enabled",
"EnumEditParameters.RoutingEnabled.Text":"0,1",
"EnumEditParameters.RoutingEnabled.0.Text":"Yes",
"EnumEditParameters.RoutingEnabled.1.Text":"No",
"WindowApplication.lblAuthenticate.Text":"Authenticate connection using:",
"WindowApplication.rbWinAuthentication.Text":"Windows authentication credentials of current user",
"WindowApplication.rbServerAuthentication.Text":"Server authentication using the Login ID and password below",
"DefineHomePageLinks.AddRemove.Text":"Error:  You did not select any items.  Select items before you click an action button.",
"DefineHomePageLinks.NoneSelected.Text":"Error:  Either you did not select any items or you attempted to remove all of the links.  To remove all of the links, go to Customize System Pages, and then click Remove Home Page Custom Links.",
"DefineHomePageLinks.rbtnGlobal.Text":"Global",
"DefineHomePageLinks.rbtnStandard.Text":"Standard",
"DefineHomePageLinks.rbtnCustom.Text":"Custom",
"DefineHomePageLinks.rbtnBuilding.Text":"Building",
"GraphicConverter.Close.Text":"Warning! The graphics conversion utility is still running. Closing the Tracer Ensemble Smart Client could lead to corrupted or unconverted graphic files. Do you want to close the Tracer Ensemble Smart Client?",
"GraphicConverterTitle.Header.Text":"Graphics Conversion Utility",
"GraphicConverterTitle.ConvertingBuilding.Text":"Converting Building",
"GraphicConverterTitle.of.Text":"of",
"GraphicConverterTitle.ConvertingStandard.Text":"Converting Standard",
"GraphicConverterTitle.ConvertingCustom.Text":"Converting Custom",
"GraphicConverterTitle.Convertingv1Label.Text":"Convert V1 Graphics",
"GraphicConverterTitle.status.Text":"Status:",
"GraphicConverterTitle.statusIdle.Text":"Idle",
"GraphicConverterTitle.Complete.Text":"Complete",
"GraphicConverterTitle.CompleteWithErrors.Text":"Complete With Errors",
"GraphicConverterTitle.Initializing.Text":"Processing",
"ProgressIndicatorLoading.Text":"Loading",
"SaveChangesPrompt.Text":"Warning! You currently have unsaved changes. Do you want to save your changes? Click Yes to save your changes or No to discard them.",
"IntegrationTest.RunButton.Text":"Run",
"IntegrationTest.Column.Component.Text":"Component",
"IntegrationTest.Column.TypeName.Text":"Type Name",
"IntegrationTest.Column.TestName.Text":"Test Name",
"IntegrationTest.Column.Comment.Text":"Comment",
"IntegrationTestHarness.IntegrationTestHarnessTHN.Text":"Integration Test Harness",
"IntegrationTestHarness.lblUserAsstTestHarness.Text":"This page is a development front-end used for integration verification and diagnosis of problems.",
"IntegrationTestHarness.lblUserAsstTestHarnessFinished.Text":"Test batch has been submitted.  Check the Integration Test Log for results.",
"IntegrationTestHarness.lblUserAsstTestHarnessNoTests.Text":"No Tests configured in App.config or no tests marked with a Test attribute",
"DataLogAttributes.lbtnManageAttributesPages.Text":"Manage Data Log Attributes",
"DataLogAttributes.lblManageAttributesPage.Text":"View, edit, delete, and assign data log attributes to data logs.",
"AssignGraphics.ContentHeader.Text":"Assign Graphic",
"AssignGraphicsSelectFamilyObject.lblUserAsstAdmin.Text":"Select the location, file name, family and object type for the graphic, and click Next.",
"AssignGraphicsSelectFamilyObject.lblLinkHeaderText.Text":"Select Graphic for Assignment",
"AssignGraphicsSelectFamilyObject.GraphicFileLocation.Text":"Graphic File Location",
"AssignGraphicsSelectFamilyObject.rbtnStandard.Text":"Standard",
"AssignGraphicsSelectFamilyObject.rbtnCustom.Text":"Custom",
"AssignGraphicsSelectFamilyObject.rbtnBuilding.Text":"Building",
"AssignGraphicsSelectFamilyObject.GraphicFileName.Text":"Graphic File Name",
"AssignGraphicsSelectFamilyObject.NoGraphic.Text":"No Graphic",
"AssignGraphicsSelectFamilyObject.SelectObjectType.Text":"Select Object Type for this Graphic",
"AssignGraphicsSelectFamilyObject.FamilyType.Text":"Family",
"AssignGraphicsSelectFamilyObject.ObjectType.Text":"Object Type",
"AssignGraphicsSelectBuildings.lblUserAsstAdmin.Text":"Verify the graphic assignment information, select buildings, and click Next.",
"AssignGraphicsSelectBuildings.lblGraphicAssignment.Text":"Graphic Assignment",
"AssignGraphicsSelectBuildings.lblSelectedGraphic.Text":"Selected Graphic",
"AssignGraphicsSelectBuildings.lblObjectType.Text":"Object Type",
"AssignGraphicsSelectBuildings.lblSelectTargets.Text":"Select Buildings for Targets",
"AssignGraphicsSelectBuildings.lblSelectTargetUserAsst.Text":"Select all buildings in the list that contain the targets to which you want to assign the graphic.",
"AssignGraphicsSelectBuildings.Columns.BuildingName.Text":"Building Name",
"AssignGraphicsSelectBuildings.Columns.Address.Text":"Address",
"AssignGraphicsSelectBuildings.Columns.City.Text":"City",
"AssignGraphicsSelectBuildings.Columns.State.Text":"State",
"AssignGraphicsSelectTargets.lblUserAsstAdmin.Text":"Verify the graphic assignment information, select targets, and click Next.",
"AssignGraphicsSelectTargets.lblGraphicAssignment.Text":"Graphic Assignment",
"AssignGraphicsSelectTargets.lblSelectedGraphic.Text":"Selected Graphic",
"AssignGraphicsSelectTargets.lblObjectType.Text":"Object Type",
"AssignGraphicsSelectTargets.lblFilterTargets.Text":"Filter List of Available Targets",
"AssignGraphicsSelectTargets.lblSelectTargetUserAsst.Text":"Specify the filter fields and click Apply Filters as needed to locate specific objects. Select objects in the Available Targets list and click Add, or select objects in the Selected Targets list and click Remove.",
"AssignGraphicsSelectTargets.lblSelectBuildings.Text":"Building Filter",
"AssignGraphicsSelectTargets.lblSelectPanels.Text":"Panel Filter",
"AssignGraphicsSelectTargets.lblObjectName.Text":"Object Name Filter",
"AssignGraphicsSelectTargets.AvailableTargets.Text":"Available Targets",
"AssignGraphicsSelectTargets.SelectedTargets.Text":"Selected Targets",
"AssignGraphicsSelectTargets.Columns.AvailableBuildings.Text":"Building",
"AssignGraphicsSelectTargets.Columns.AvailablePanel.Text":"Panel",
"AssignGraphicsSelectTargets.Columns.AvailableObject.Text":"Object Name",
"AssignGraphicsSelectTargets.ApplyFilter.Text":"Apply Filters",
"AssignGraphicsSelectTargets.ObjectFilter.Text":"If this filter contains any text, only objects with the exact text in their name will be found.",
"AssignGraphicsSelectTargets.Add.Text":"Add",
"AssignGraphicsSelectTargets.Remove.Text":"Remove",
"AssignGraphicFinalize.UserAssistance.Text":"Verify the graphic assignment and target object information and click Finish to complete the assignment.",
"AssignGraphicFinalize.lblGraphicAssignment.Text":"Graphic Assignment",
"AssignGraphicFinalize.lblSelectedGraphic.Text":"Selected Graphic",
"AssignGraphicFinalize.lblObjectType.Text":"Object Type",
"AssignGraphicFinalize.lblTargetObjects.Text":"Target Objects",
"AssignGraphicFinalize.Columns.BuildingName.Text":"Building",
"AssignGraphicFinalize.Columns.Panel.Text":"Panel",
"AssignGraphicFinalize.Columns.ObjectName.Text":"Object Name",
"AssignGraphicFinalize.Back.Text":"< Back",
"AssignGraphicFinalize.Finish.Text":"Finish",
"EnumEditPreferences.OverridePreference.Text":"0,1",
"EnumEditPreferences.OverridePreference.0.Text":"Advanced",
"EnumEditPreferences.OverridePreference.1.Text":"Simplified",
"ResetDiagnosticDetails.UserAssistance.Text":"This page shows details of the selected changes in the log.",
"ResetDiagnosticDetails.Details.Text":"Details",
"ResetDiagnosticDetails.Affected.Text":"Affected",
"ResetDiagnosticDetails.Building.Text":"Building",
"ResetDiagnosticDetails.DateTime.Text":"Date/Time",
"ResetDiagnosticDetails.ResetBy.Text":"Reset By",
"ResetDiagnosticDetails.ResetProperty.Text":"Reset Property",
"ResetDiagnosticDetails.ResetValue.Text":"Reset Value",
"ResetDiagnosticDetails.DiagnosticMessageTitle.Text":"Diagnostic Message",
"ResetDiagnosticDetails.PropertyNameTitle.Text":"Property",
"DataBaseStatus.TitleHeader.Text":"DataBase Status",
"DataBaseStatus.lblDataBaseMessage.Text":"This page is to view Database Status.",
"DataBaseStatus.lblShowDataBaseSize.Text":"Current Database Size:",
"DataBaseStatus.TableName.Text":"Table Name",
"DataBaseStatus.TableDesc.Text":"Table Description",
"DataBaseStatus.RowCount.Text":"Row Count",
"DataBaseStatus.Size.Text":"Size (In MB)",
"DatabaseMaintenance.lblUserAsstAdmin.Text":"This page shows the parameters used by Tracer Ensemble system to manage the size of the database. Click Edit to make changes. Click Run Now to delete old records immediately.",
"DatabaseMaintenance.HeadingTitle.Text":"Manage Database Size - Edit",
"DatabaseMaintenance.lblMaxDBSizeText.Text":"Database Size Management",
"DatabaseMaintenance.lblMaxDBSizeUAText.Text":"Select an option below to determine how you want to manage the overall size of the Tracer Ensemble database, and then specify the options associated with your choice.",
"DatabaseMaintenance.optNoDBLimit.Text":"Do not delete old data",
"DatabaseMaintenance.optDBLimit.Text":"Delete old data based on a schedule",
"DatabaseMaintenance.lblMaxDBSize.Text":"Maximum database size",
"DatabaseMaintenance.lblSchedule.Text":"Schedule",
"DatabaseMaintenance.lblDay.Text":"Day",
"DatabaseMaintenance.lblTime.Text":"Time",
"DatabaseMaintenance.optDataFileSize.Text":"Delete old data based on database file size",
"DatabaseMaintenance.lblGBLabel.Text":"GB",
"DatabaseMaintenance.lblGBLimitInfo.Text":"(Must be between 1.75 and 1000gigabytes)",
"DatabaseMaintenance.lblDeleteData.Text":"Delete data older than",
"EnumDatabaseMaintenance.Period.Text":"1,2",
"EnumDatabaseMaintenance.Period.1.Text":"Days",
"EnumDatabaseMaintenance.Period.2.Text":"Months",
"DatabaseMaintenance.lblDBSizeSchedule.Text":"Check the database size on a regular schedule",
"DatabaseMaintenance.lblDayToCheck.Text":"Select day to check",
"DatabaseMaintenance.optDaily.Text":"Daily",
"DatabaseMaintenance.optWeekly.Text":"Weekly on this day",
"DatabaseMaintenance.optDay.Text":"Monthly on this day",
"EnumDatabaseMaintenance.ScheduleFrequency.Text":"0,1,2",
"EnumDatabaseMaintenance.ScheduleFrequency.0.Text":"Daily",
"EnumDatabaseMaintenance.ScheduleFrequency.1.Text":"Weekly",
"EnumDatabaseMaintenance.ScheduleFrequency.2.Text":"Monthly",
"EnumDatabaseMaintenance.WeekDays.Text":"0,1,2,3,4,5,6",
"EnumDatabaseMaintenance.WeekDays.0.Text":"Sunday",
"EnumDatabaseMaintenance.WeekDays.1.Text":"Monday",
"EnumDatabaseMaintenance.WeekDays.2.Text":"Tuesday",
"EnumDatabaseMaintenance.WeekDays.3.Text":"Wednesday",
"EnumDatabaseMaintenance.WeekDays.4.Text":"Thursday",
"EnumDatabaseMaintenance.WeekDays.5.Text":"Friday",
"EnumDatabaseMaintenance.WeekDays.6.Text":"Saturday",
"DatabaseMaintenance.lblTimeofDay.Text":"Select time of day to check",
"DatabaseMaintenance.lblOptimizedESTime.Text":"Optimized by Tracer Ensemble server",
"DatabaseMaintenance.optConfiguredTime.Text":"Check at this Time",
"DatabaseMaintenance.chkDeleteSave.Text":"Check the database and delete old data items now when I click save",
"DatabaseMaintenance.lblTimeFormat.Text":"HH:MM",
"DatabaseMaintenance.lblTimeFormatPart.Text":"TT",
"Buttons.Cancel.Text":"Cancel",
"Buttons.Save.Text":"Save",
"DatabaseMaintenance.lblMaxDBSizeWarningText.Text":"<b>CAUTION</b>: Selecting an option to delete old data will result in data log values being permanently deleted from the Tracer Ensemble database.",
"ManageDatabaseMaintenance.HeadingTitle.Text":"Manage Database Size",
"ManageDatabaseMaintenance.lblUserAsstAdmin.Text":"View and edit settings that affect the size of the Tracer Ensemble database by controlling the number or age of records and logs that it stores.",
"ManageDatabaseMaintenance.lblDbSizeMaintenance.Text":"Database Size Management",
"ManageDatabaseMaintenance.lblUADbSizeMaintenance.Text":"Indicate whether the system should delete records when the database becomes large and set a schedule for deletion.",
"ManageDatabaseMaintenance.lblDatabaseType.Text":"Database type",
"ManageDatabaseMaintenance.lblCurrentDbSize.Text":"Current size",
"ManageDatabaseMaintenance.lblDeleteOldData.Text":"Delete old data",
"ManageDatabaseMaintenance.lblDataAge.Text":"Data age for deletion",
"ManageDatabaseMaintenance.lblDataDeletedBase.Text":"Data deleted based on",
"ManageDatabaseMaintenance.lblAppLogManagement.Text":"Application Logs",
"ManageDatabaseMaintenance.lblUAAppLogManagement.Text":"For each log type, specify whether or not you would like to limit the number of log entries that are retained in the database.  If you select Yes for any log type, you must also specify the maximum number of entries to be retained at any time.",
"ManageDatabaseMaintenance.LogApplication.Text":"Log type",
"ManageDatabaseMaintenance.EnforceLimit.Text":"Limit",
"ManageDatabaseMaintenance.MaxLogEntries.Text":"Maximum Log Entries",
"ManageDatabaseMaintenance.SQLServer.Text":"SQL Server",
"ManageDatabaseMaintenance.MonthsOld.Text":"months old",
"ManageDatabaseMaintenance.DatabaseSizeGreater.Text":"Database size greater than",
"ManageDatabaseMaintenance.AlarmLogEntries.Text":"Alarm log entries",
"ManageDatabaseMaintenance.GPCLogEntries.Text":"Global point log entries",
"ManageDatabaseMaintenance.SystemLogEntries.Text":"System action entries",
"ManageDatabaseMaintenance.UserChangeEntries.Text":"User change log entries",
"ManageDatabaseMaintenance.AlarmLogMaxEntries.Text":"Unlimited alarm log entries",
"ManageDatabaseMaintenance.GPCLogMaxEntries.Text":"Unlimited global point log entries",
"ManageDatabaseMaintenance.SystemLogMaxEntries.Text":"Unlimited system log entries",
"ManageDatabaseMaintenance.UserChangeLogMaxEntries.Text":"Unlimited user change log entries",
"ManageDatabaseMaintenance.EnforceLimitYes.Text":"Yes",
"ManageDatabaseMaintenance.EnforceLimitNo.Text":"No",
"ManageDatabaseMaintenance.UnlimitedLogs.Text":"Unlimited logs",
"ManageDatabaseMaintenance.LogEntries.Text":"Log Entries",
"ManageDatabaseMaintenance.lblSettings.Text":"Settings",
"ManageDatabaseMaintenance.btnEdit.Text":"Edit",
"ManageDatabaseMaintenance.lblDbMaintennace.Text":"Database Maintenance",
"ManageDatabaseMaintenance.btnExecute.Text":"Run Now",
"ManageDatabaseMaintenance.Yes.Text":"Yes",
"ManageDatabaseMaintenance.No.Text":"No",
"ManageDatabaseMaintenance.GB.Text":"GB",
"ManageDatabaseMaintenance.DayOld.Text":"days old",
"ManageDatabaseMaintenance.MaxDbSize.Text":"Database size greater than",
"ManageDatabaseMaintenance.SQLExpress.Text":"SQL Server Express",
"ManageDatabaseMaintenance.Failure.Text":"Error while updating Configuration",
"ManageDatabaseMaintenance.SQLServerStandard.Text":"Standard Edition",
"ManageDatabaseMaintenance.Scheduleday.Text":"Scheduled every day at",
"ManageDatabaseMaintenance.ScheduleWeek.Text":"Scheduled weekly every",
"ManageDatabaseMaintenance.ScheduleMonth.Text":"Scheduled monthly on",
"ManageDatabaseMaintenance.at.Text":"at",
"ManageDatabaseMaintenance.AM.Text":"AM",
"ManageDatabaseMaintenance.PM.Text":"PM",
"ManageDatabaseMaintenance.UnlimitedAlarms.Text":"Unlimited Alarms",
"ManageDatabaseMaintenance.UnlimitedGPCEntries.Text":"Unlimited Global point log entries",
"ManageDatabaseMaintenance.UnlimitedSystemLogEntries.Text":"Unlimited System action entries",
"ManageDatabaseMaintenance.UnlimitedUserChangeLogEntries.Text":"Unlimited User change log entries",
"ManageDatabaseMaintenance.Alarms.Text":"Alarms",
"ManageDatabaseMaintenance.GPCEntries.Text":"Global point log entries",
"ManageDatabaseMaintenance.UserChangeLogEntries.Text":"User change log entries",
"ManageDatabaseMaintenance.LastDayOfMonth.Text":"Last Day of Month",
"TESDataLog.Text":"Data Log",
"TESAlarmPriority.Text":"Alarm Priority",
"TESObjectParent.Text":"Object Parent",
"TESObjectPropertyEnum.Text":"Object Property Enum",
"TESObjectConfiguration.Text":"Object Configuration",
"TESObject.Text":"Object",
"TESEvoxKeyname.Text":"Evox Keyname",
"TESAnalogMultistateEvoxNormalizationRuleDetails.Text":"Analog Multistate Evox Normalization Rule Details",
"TESEquipmentRole.Text":"Equipment Role",
"TESSystemTaskLog.Text":"System Task Log",
"TESTransaction.Text":"Transaction",
"TESAlarmValue.Text":"Alarm Value",
"TESUserLogonDetail.Text":"User Logon Detail",
"TESAlarmTextByLanguage.Text":"Alarm Text By Language",
"TESDataLogDefinition.Text":"Data Log Definition",
"TESDataLogAssignedAttribute.Text":"Data Log Assigned Attribute",
"TESEvoxKeynameEnum.Text":"Evox Key name Enum",
"TESScheduleEvent.Text":"Schedule Event",
"TESCustomPage.Text":"Custom Page",
"TESMultistateToMultistateEvoxNormalizationRuleDetails.Text":"Multistate To Multistate Evox Normalization Rule Details",
"TESScheduleDay.Text":"Schedule Day",
"TESComponentRole.Text":"Component Role",
"TESUnit.Text":"Unit",
"TESDiscoveredSchedule.Text":"Discovered Schedule",
"TESEventEnrollment.Text":"Event Enrollment",
"TESTransactionType.Text":"Transaction Type",
"TESEvoxNormalizationRule.Text":"Evox Normalization Rule",
"TESAlarmType.Text":"Alarm Type",
"TESAlarmEventSubscription.Text":"Alarm Event Subscription",
"TESObject_Archive.Text":"Object Archive",
"TESAlarmLog.Text":"Alarm Log",
"TESBinaryMultistateEvoxNormalizationRuleDetails.Text":"Binary Multistate Evox Normalization Rule Details",
"TESSystemError.Text":"System Error",
"TESUserUnit.Text":"User Unit",
"TESNavigationTree.Text":"Navigation Tree",
"TESAlarmNewObjectQueue.Text":"Alarm New Object Queue",
"TESSchedule.Text":"Schedule",
"TESSiteTransaction.Text":"Site Transaction",
"TESSiteTransactionDetail.Text":"Site Transaction Detail",
"TESAnalogBinaryEvoxNormalizationRuleDetails.Text":"Analog Binary Evox Normalization Rule Details",
"TESDimension.Text":"Dimension",
"TESScheduleMember.Text":"Schedule Member",
"TESApplication.Text":"Application",
"TESComponent.Text":"Component",
"TESAction.Text":"Action",
"TESPanel.Text":"Panel",
"TESScheduleTransaction.Text":"Schedule Transaction",
"TESDataLogNewObjectQueue.Text":"Data Log New Object Queue",
"TESMultiplierOffsetEvoxNormalizationRuleDetails.Text":"Multiplier Offset Evox Normalization Rule Details",
"TESDiscoveryPanelLog.Text":"Discovery Panel Log",
"TESObjectFamily.Text":"Object Family",
"__RefactorLog.Text":"Refactor Log",
"TESCustomAttributeDefinition.Text":"Custom Attribute Definition",
"TESNetworkNumber.Text":"Network Number",
"TESDiscoveredScheduleMember.Text":"DiscoveredScheduleMember",
"TESRecentUserVisit.Text":"Recent User Visit",
"TESReportType.Text":"Report Type",
"TESCustomerLicense.Text":"Customer License",
"TESPasswordHistory.Text":"Password History",
"TESAlarmCustomPriority.Text":"Alarm Custom Priority",
"TESDiscoveryObjectLog.Text":"Discovery Object Log",
"TESRole.Text":"Role",
"TESDiscoveryQueue.Text":"Discovery Queue",
"TESSite.Text":"Site",
"TESUser.Text":"User",
"TESUserRole.Text":"User Role",
"ApplicationVersion.Text":"Application Version",
"TESAlarmMessageTemplate.Text":"Alarm Message Template",
"TESAttributeType.Text":"Attribute Type",
"TESGlobalSearch.Text":"Global Search",
"TESSiteDBSynchSchedules.Text":"Site DB Synch Schedules",
"TESAlarmComment.Text":"Alarm Comment",
"TESAlarmDistributionRule.Text":"Alarm Distribution Rule",
"TESAlarmDistributionRuleAlarmPriority.Text":"Alarm Distribution Rule Alarm Priority",
"TESAlarmDistributionRuleDayAndTime.Text":"Alarm Distribution Rule Day And Time",
"TESAlarmDistributionRuleEmailAddress.Text":"Alarm Distribution Rule Email Address",
"TESAlarmFilter.Text":"Alarm Filter",
"TESAlarmGroupView.Text":"Alarm Group View",
"TESAlarmNotificationClassRecipientRequest.Text":"Alarm Notification Class Recipient Request",
"TESAlarmNotificationClassRequest.Text":"Alarm Notification Class Request",
"TESAlarmReceivedQueue.Text":"Alarm Received Queue",
"TESAlarmTransaction.Text":"Alarm Transaction",
"TESAlarmTransactionDetail.Text":"Alarm Transaction Detail",
"TESAlarmUserPriority.Text":"Alarm User Priority",
"TESArtifactDefinition.Text":"Artifact Definition",
"TESBuildingGroup.Text":"Building Group",
"TESBuildingGroupAssociation.Text":"Building Group Association",
"TESBuildingGroupObject.Text":"Building Group Object",
"TESChildPreventativeMaintenance.Text":"Child Preventative Maintenance",
"TESChildPreventativeMaintenanceAttachment.Text":"Child Preventative Maintenance Attachment",
"TESChildPreventativeMaintenanceComment.Text":"Child Preventative Maintenance Comment",
"TESChildPreventativeMaintenanceLabor.Text":"Child Preventative Maintenance Labor",
"TESChildPreventativeMaintenancePart.Text":"Child Preventative Maintenance Part",
"TESChildPreventativeMaintenanceTask.Text":"Child Preventative Maintenance Task",
"TESCriticalPoint.Text":"Critical Point",
"TESCustomEquipmentGroup.Text":"Custom Equipment Group",
"TESCustomEquipmentProperty.Text":"Custom Equipment Property",
"TESCustomHomePageLink.Text":"Custom Home Page Link",
"TESCustomPageContextReference.Text":"Custom Page Context Reference",
"TESDataLogAttribute.Text":"Data Log Attribute",
"TESDataLogBufferReadyQueue.Text":"Data Log Buffer Ready Queue",
"TESDataLogTransaction.Text":"Data Log Transaction",
"TESDataLogTransactionDetail.Text":"Data Log Transaction Detail",
"TESDataLogUserAlarmPreference.Text":"Data Log User Alarm Preference",
"TESDocument.Text":"Document",
"TESEmailAddress.Text":"Email Address",
"TESEquipmentDocument.Text":"Equipment Document",
"TESEquipmentTypeDocument.Text":"Equipment Type Document",
"TESEventLogObjectTransaction.Text":"Event Log Object Transaction",
"TESEventMarker.Text":"Event Marker",
"TESEventMarkerDocument.Text":"Event Marker Document",
"TESEventMarkerTarget.Text":"Event Marker Target",
"TESEventMarkerType.Text":"Event Marker Type",
"TESEvoxNormalizationRuleFaultValues.Text":"Evox Normalization Rule Fault Values",
"TESEvoxNormalizationRuleReferences.Text":"Evox Normalization Rule References",
"TESFamilyTypeDocument.Text":"Family Type Document",
"TESGlobalChangeRequestDetail.Text":"Global Change Request Detail",
"TESGlobalChangeRequestQueue.Text":"Global Change Request Queue",
"TESGlobalChangeTransaction.Text":"Global Change Transaction",
"TESGlobalChangeTransactionDetail.Text":"Global Change Transaction Detail",
"TESGPCCommLossLog.Text":"GPC Comm Loss Log",
"TESGPCReference.Text":"GPC Reference",
"TESGPCTargetPoint.Text":"GPC Target Point",
"TESGPCTransaction.Text":"GPC Transaction",
"TESGPCTriggerPoint.Text":"GPC Trigger Point",
"TESGPCTransactionDetail.Text":"GPC Transaction Detail",
"TESGPCVirtualTrigger.Text":"GPC Virtual Trigger",
"TESGPCVirtualTriggerEnums.Text":"GPC Virtual Trigger Enums",
"TESLogicalBuilding.Text":"Logical Building",
"TESLogicalBuildingObject.Text":"Logical Building Object",
"TESLogicalBuildingSite.Text":"Logical Building Site",
"TESObjectConfiguration_Archive.Text":"Object Configuration Archive",
"TESObjectPropertyEnum_Archive.Text":"Object Property Enum Archive",
"TESOverrideTransaction.Text":"Override Transaction",
"TESOverrideTransactionDetail.Text":"Override Transaction Detail",
"TESPanel_Archive.Text":"Panel Archive",
"TESPivotAccount.Text":"Pivot Account",
"TESPivotAccountsite.Text":"Pivot Account site",
"TESPreventativeMaintenance.Text":"Preventative Maintenance",
"TESPreventativeMaintenanceAttachment.Text":"Preventative Maintenance Attachment",
"TESPreventativeMaintenanceComment.Text":"Preventative Maintenance Comment",
"TESPreventativeMaintenanceLabor.Text":"Preventative Maintenance Labor",
"TESPreventativeMaintenancePart.Text":"Preventative Maintenance Part",
"TESPreventativeMaintenanceSchedule.Text":"Preventative Maintenance Schedule",
"TESPreventativeMaintenanceStandardFieldSetup.Text":"Preventative Maintenance Standard Field Setup",
"TESPreventativeMaintenanceStatusValue.Text":"Preventative Maintenance Status Value",
"TESPreventativeMaintenanceTask.Text":"Preventative Maintenance Task",
"TESReportAnalyticalDetail.Text":"Report Analytical Detail",
"TESReportAssignedAttribute.Text":"Report Assigned Attribute",
"TESReportCalendar.Text":"Report Calendar",
"TESReportDefinition.Text":"Report Definition",
"TESReportEmailMapping.Text":"Report Email Mapping",
"TESReportEmailTemplates.Text":"Report Email Templates",
"TESReportFileRetention.Text":"Report File Retention",
"TESReportRecipientEmails.Text":"Report Recipient Emails",
"TESReportSchedule.Text":"Report Schedule",
"TESReportScheduleMapping.Text":"Report Schedule Mapping",
"TESScheduleAddedExceptionEvent.Text":"Schedule Added Exception Event",
"TESScheduleCustomAttribDefinition.Text":"Schedule Custom Attrib Definition",
"TESScheduleCustomAttribLink.Text":"Schedule Custom Attrib Link",
"TESScheduleDate.Text":"Schedule Date",
"TESScheduleEmergencyLink.Text":"Schedule Emergency Link",
"TESScheduleException.Text":"Schedule Exception",
"TESScheduleExceptionDay.Text":"Schedule Exception Day",
"TESScheduleExceptionEvent.Text":"Schedule Exception Event",
"TESScheduleExceptionLink.Text":"Schedule Exception Link",
"TESScheduleExceptionLinkTX.Text":"Schedule Exception Link TX",
"TESScheduleTemplate.Text":"Schedule Template",
"TESScheduleTemplateEvent.Text":"Schedule Template Event",
"TESScheduleTransactionDetail.Text":"Schedule Transaction Detail",
"TESSiteUserAccount.Text":"Site User Account",
"TESStandardReportDetails.Text":"Standard Report Details",
"TESStatusTransaction.Text":"Status Transaction",
"TESStatusTransactionDetail.Text":"Status Transaction Detail",
"TESStatusTransactionResetDiagnosticMsg.Text":"Status Transaction Reset Diagnostic Msg",
"TESSystemSetting.Text":"System Setting",
"TesTenant.Text":"Tenant",
"TESTenantAssignedBuildings.Text":"Tenant Assigned Buildings",
"TESTenantAssignedZones.Text":"Tenant Assigned Zones",
"TESTenantBilling.Text":"Tenant Billing",
"TESTenantChangeRequest.Text":"Tenant Change Request",
"TESTenantChangeRequestComments.Text":"Tenant Change Request Comments",
"TESTenantConsumption.Text":"Tenant Consumption",
"TESTenantConsumptionSetting.Text":"Tenant Consumption Setting",
"TESTenantEmailMapping.Text":"Tenant Email Mapping",
"TESTenantFacilitySetup.Text":"Tenant Facility Setup",
"TESTenantFixedCharges.Text":"Tenant Fixed Charges",
"TESTenantHolidayDetails.Text":"Tenant Holiday Details",
"TESTenantHolidayExceptions.Text":"TenantHolidayExceptions",
"TESTenantInvoices.Text":"Tenant Invoices",
"TESTenantInvoiceSetup.Text":"Tenant Invoice Setup",
"TESTenantNormalHours.Text":"Tenant Normal Hours",
"TESTenantSpace.Text":"Tenant Space",
"TesTenantSubgroup.Text":"Tenant Subgroup",
"TESTenantTemperatureAdjustment.Text":"Tenant Temperature Adjustment",
"TESTenantTransaction.Text":"Tenant Transaction",
"TESTenantTransactionDetail.Text":"Tenant Transaction Detail",
"TESTenantUser.Text":"Tenant User",
"TESTenantUserAssignedZones.Text":"Tenant User Assigned Zones",
"TESTenantUserSubgroup.Text":"Tenant User Subgroup",
"TESTenantZoneObject.Text":"Tenant Zone Object",
"TESTenantZones.Text":"Tenant Zones",
"TESTenantZoneTransactionDetail.Text":"Tenant Zone Transaction Detail",
"TESUserBuildingGroup.Text":"User Building Group",
"TESUserCustomPage.Text":"User Custom Page",
"TESUserSite.Text":"User Site",
"TESWorkOrder.Text":"Work Order",
"TESWorkOrderAttachment.Text":"Work Order Attachment",
"TESWorkOrderBuilding.Text":"Work Order Building",
"TESWorkOrderComment.Text":"Work Order Comment",
"TESWorkOrderDetail.Text":"Work Order Detail",
"TESWorkOrderFloor.Text":"Work Order Floor",
"TESWorkOrderLabor.Text":"Work Order Labor",
"TESWorkOrderPart.Text":"Work Order Part",
"TESWorkOrderProblemValue.Text":"Work Order Problem Value",
"TESWorkOrderSpace.Text":"Work Order Space",
"TESWorkOrderStandardFieldSetup.Text":"Work Order Standard Field Setup",
"TESWorkOrderStatusValue.Text":"Work Order Status Value",
"TESWorkOrderSuite.Text":"Work Order Suite",
"TESWorkOrderUrgencyValue.Text":"Work Order Urgency Value",
"ManageOverrideSearch.lblPageTitle.Text":"Manage Override Search",
"ManageOverrideSearch.lblContentHeading.Text":"Search for Overrides",
"ManageOverrideSearch.lblUserAsstMessage.Text":"View overrides that were found in a previous search or perform a new search.</br> You may start a search, navigate to another page, and return later to see the results.",
"ManageOverrideSearch.Columns.OverrideName.Text":"Search Name",
"ManageOverrideSearch.Columns.OverrideDesc.Text":"Description",
"ManageOverrideSearch.Columns.RecentSearch.Text":"Most Recent Search",
"ManageOverrideSearch.lblAction.Text":"Actions",
"ManageOverrideSearch.lblMultipleQueries.Text":"Multiple Queries",
"ManageOverrideSearch.btnRunQuery.Text":"Run",
"ManageOverrideSearch.btnEditQuery.Text":"Edit",
"ManageOverrideSearch.btnDeleteQuery.Text":"Delete",
"ManageOverrideSearch.lblSingleQuery.Text":"Single Query",
"ManageOverrideSearch.btnCreateQry.Text":"Create Search Query",
"ManageOverrideSearch.lblHeading.Text":"Search Query is Running",
"ManageOverrideSearch.lblSubHeading.Text":"Search results are not available because the search query </br> is currently running. Try again when the Most Recent </br> Search field indicates that the search has completed.",
"ManageOverrideSearch.btnCloseWindow.Text":"Close Window",
"ManageOverrideSearch.lblQueryNotRun.Text":"This Search has not been run",
"ManageOverrideSearch.lblQueryRunning.Text":"Running",
"ManageOverrideSearch.lblDeleteheading.Text":"Delete Query and Search Results",
"ManageOverrideSearch.lblDeleteSubheading.Text":"You are about to delete the selected search results and the </br> queries that created them. Do you want to continue?",
"ManageOverrideSearch.btnCancel.Text":"No",
"ManageOverrideSearch.btnConfirm.Text":"Yes, Delete",
"ManageOverrideSearch.lblNoSearchHeading.Text":"No Search Results Exist",
"ManageOverrideSearch.lbldisplaySubheading.Text":"There are no search results, because the search query has not been run yet. Do you want to run it now?",
"ManageOverrideSearch.btnCancelRun.Text":"Cancel",
"ManageOverrideSearch.btnRunQueryresults.Text":"Yes, Run Query",
"maxloglimit.AlarmLogMaxEntries.Text":"Alarm Log",
"maxloglimit.GPCLogMaxEntries.Text":"Global Point Control Log",
"maxloglimit.SystemLogMaxEntries.Text":"System Log",
"maxloglimit.UserChangeLogMaxEntries.Text":"User Change Log",
"Reports.UserAssistance.Text":"Click a link below to view and edit custom reports.",
"Reports.Title.Text":"Report Lists",
"Reports.lblStandardReports.Text":"Generate Standard reports for multiple buildings.",
"Reports.lnkStandardReports.Text":"Standard Reports",
"Reports.lblCompletedReports.Text":"View, e-mail, and delete reports that have been generated in the past.",
"Reports.lnkCompletedReports.Text":"Completed Reports",
"Reports.lnkCustomReports.Text":"Manage Reports",
"Reports.lblCustomReports.Text":"Design, modify and schedule custom and standard reports.",
"Reports.lblManageDashboards.Text":"Create, View and Delete Dashboards.",
"ContextHeaderText.Reports.Text":"Reports",
"ImportCustomGraphics.ImportGraphics.Text":"Import Custom Graphics",
"ImportCustomGraphics.ExportGraphics.Text":"Export Building Custom Graphics",
"ImportGraphics.UserAssistanceMessage.Text":"Complete this page to retrieve a Tracer™ Graphics Editor custom graphics \"ZIP\" file from your local file system to make the graphics available for use in Tracer™ Ensemble.",
"ImportGraphics.SubHeader.Text":"Import from Local Folder",
"ImportGraphics.Import.Text":"Import",
"ImportGraphics.InvalidFileError.Text":"Error: Invalid import file. Only ZIP files created with Tracer Graphics Editor are allowed.",
"ImportGraphics.FileMaxSizeError.Text":"Error: Import file exceeds the 300 Mb limit. Select fewer graphics to publish in Tracer Graphics Editor and try again.",
"ImportGraphics.FileAccessError.Text":"Error: Tracer Ensemble was unable to extract the graphics ZIP file. Verify that the Tracer Ensemble application has permission to write to system temp folders and the Program Files directory.",
"ImportGraphics.FileRemoteServiceError.Text":"Error: Tracer Ensemble was unable to extract the graphics ZIP file. Verify that the Internet Information Services (IIS) application has permission to access the Windows Communication Foundation (WCF) service.",
"ImportGraphics.LegacyNotSupportError.Text":"Error: Invalid graphics import file. This graphic file contains an ASPX graphics which are no longer supported by Tracer Ensemble.",
"ImportGraphics.UnknownError.Text":"Error: An unknown error occurred. More detail can be found in the Tracer Ensemble log files. Contact technical support for assistance.",
"ImportGraphics.FileUploading.Text":"File Uploading",
"ImportGraphics.FileExtracting.Text":"File Extracting",
"ImportGraphics.GraphicRefreshing.Text":"Refreshing graphics...",
"ImportGraphics.ImportSuccessMessage.Text":"Graphics imported successfully.",
"ImportGraphics.ImportCloseWarning.Text":"The graphics import is in progress. If you navigate from this page, you may lose the files you import.",
"ImportGraphics.ImportCancel.Text":"Cancel",
"ImportGraphics.ImportClose.Text":"Close",
"ExportGraphics.UserAssistanceMessage.Text":"The graphics in the directories you select below will be exported to a ZIP file using your browser's download feature.",
"ExportGraphics.GraphicsDirectory.Text":"Graphics Directory",
"ExportGraphics.BuildingName.Text":"Building Name",
"ExportGraphics.btnExport.Text":"Export",
"ExportGraphics.ProgressIndicator.Text":"Creating export file...",
"PanelResetDetails.PanelType.0.Text":"Unknown",
"PanelResetDetails.PanelType.100.Text":"Tracer BCU",
"PanelResetDetails.PanelType.101.Text":"BCU Bridge",
"PanelResetDetails.PanelType.200.Text":"Tracker",
"PanelResetDetails.PanelType.4.Text":"Generic BACnet Device",
"PanelResetDetails.PanelType.5.Text":"BMN Tracker",
"PanelResetDetails.PanelType.6.Text":"Generic BACnet Device",
"PanelResetDetails.PanelType.7.Text":"Trane Application",
"PanelResetDetails.PanelType.210.Text":"UC210",
"PanelResetDetails.PanelType.400.Text":"UC400",
"PanelResetDetails.PanelType.401.Text":"BCI-C",
"PanelResetDetails.PanelType.402.Text":"BCI-I",
"PanelResetDetails.PanelType.403.Text":"BCI-R",
"PanelResetDetails.PanelType.600.Text":"UC600",
"PanelResetDetails.PanelType.800.Text":"UC800",
"PanelResetDetails.PanelType.900.Text":"Tracer SC",
"EnumOverrides.SCPriority.1.Text":"1 - Life Safety - Manual",
"EnumOverrides.SCPriority.2.Text":"2 - Life Safety - Auto",
"EnumOverrides.SCPriority.3.Text":"3 - Miscellaneous",
"EnumOverrides.SCPriority.4.Text":"4 - Miscellaneous",
"EnumOverrides.SCPriority.5.Text":"5 - Critical Equipment",
"EnumOverrides.SCPriority.6.Text":"6 - Minimum On/Off",
"EnumOverrides.SCPriority.7.Text":"7 - Miscellaneous",
"EnumOverrides.SCPriority.8.Text":"8 - Manual Override High",
"EnumOverrides.SCPriority.9.Text":"9 - Programming High",
"EnumOverrides.SCPriority.10.Text":"10 - Application High",
"EnumOverrides.SCPriority.11.Text":"11 - Manual Override Medium",
"EnumOverrides.SCPriority.12.Text":"12 - Application Medium",
"EnumOverrides.SCPriority.13.Text":"13 - Manual Override Low",
"EnumOverrides.SCPriority.14.Text":"14 - Programming Low",
"EnumOverrides.SCPriority.15.Text":"15 - Application Low",
"EnumOverrides.SCPriority.16.Text":"16 - Miscellaneous",
"LocalControl.Enabled.Text":"Enabled",
"UserChangeLog.Filters.Text":"Filters",
"UserChangeLog.FilterHeaderDate.Text":"Date",
"UserChangeLog.FilterHeaderPriority.Text":"Transaction Type",
"UserChangeLog.FilterHeaderTextSearch.Text":"User",
"UserChangeLog.FilterHeaderAcknowledge.Text":"Affected",
"UserChangeLog.FilterHeaderStateChange.Text":"Text Match",
"UserChangeLog.cbkCustomDateRange.Text":"Custom Date Range",
"UserChangeLog.TextSearch.Match.Text":"Match",
"UserChangeLog.ListofDate.0.Text":"Today",
"UserChangeLog.ListofDate.1.Text":"Yesterday",
"UserChangeLog.ListofDate.2.Text":"This Week",
"UserChangeLog.ListofDate.3.Text":"Last Week",
"UserChangeLog.ListofDate.4.Text":"Older",
"UserChangeLog.Priority.afterhours.Text":"After-Hours Change",
"UserChangeLog.Priority.building.Text":"Building Change",
"UserChangeLog.Priority.chillerplant.Text":"Chiller Plant Change",
"UserChangeLog.Priority.point.Text":"Point Change",
"UserChangeLog.Priority.schedule.Text":"Schedule Change",
"UserChangeLog.Priority.useraccess.Text":"User Access",
"UserChangeLog.Priority.userManagement.Text":"User Management",
"UserChangeLog.Priority.dataLog.Text":"Data Log",
"UserChangeLog.Priority.criticalpoint.Text":"Critical Point Change",
"UserChangeLog.AdvancedSearch.lblDateFrom.Text":"From",
"UserChangeLog.AdvancedSearch.lblDateTo.Text":"To",
"UserChangeLog.Affected.Match.Text":"Match Text",
"UserChangeLog.Affected.Filter.Text":"Filter",
"UserChangeLog.Details.Match.Text":"Text to Match",
"UserChangeLog.Details.Filter.Text":"Filter",
"LocalControl.Disabled.Text":"Disabled",
"UserChangeLog.Schedulestate52.Text":"Created schedule",
"UserChangeLog.Schedulestate53.Text":"Changed Schedule",
"UserChangeLog.Schedulestate54.Text":"Deleted Schedule",
"UserChangeLog.ShowMoreAlarms.Text":"Show 100 more...",
"UserChangeLog.ChangedPresentValue.Text":"Changed Present Value",
"UserChangeLog.Action.69.Text":"Logged On",
"UserChangeLog.Action.70.Text":"Logged Off",
"UserChangeLog.Action.71.Text":"Logged Off",
"UserChangeLog.Action.90.Text":"Changed Present Value",
"UserChangeLog.Action.93.Text":"Panel Reset",
"UserChangeLog.PointService.1.Text":"Out Of Service",
"UserChangeLog.PointService.0.Text":"In Service",
"UserChangeLog.TimedOverrideActive.Text":"Active",
"UserChangeLog.TimedOverrideInActive.Text":"Inactive",
"UserChangeLog.ActionForLogOff.70.Text":"by: Inactivity Auto Log Off",
"UserChangeLog.ActionForLogOff.111.Text":"by: User Log Off",
"UserChangeLog.From.Text":"from:",
"UserChangeLog.To.Text":"to:",
"UserChangeLog.ToSequence.Text":"to: Sequence",
"UserChangeLog.For.Text":"for:",
"UserChangeLog.Hours.Text":"hours",
"UserChangeLog.Days.Text":"days",
"UserChangeLog.Minutes.Text":"mins",
"UserChangeLog.At.Text":"at: Priority",
"UserChangeLog.ScheduleName.Text":"Schedule Name:",
"UserChangeLog.ExceptionName.Text":"Exception Name:",
"UserChangeLog.LocationName.Text":"Location Name:",
"UserChangeLog.OutPointService.Text":"Out Of Service",
"UserChangeLog.InPointService.Text":"In Service",
"UserChangeLog.PointService.Text":"Out Of Service:",
"UserChangeLog.LocalSetPointChangeYes.Text":"Yes",
"UserChangeLog.LocalSetPointChangeNo.Text":"No",
"UserChangeLog.ChangedBy.Text":"Changed By:",
"UserChangeLog.Named.Text":"named:",
"UserChangeLog.PanelNamed.Text":"for Panel named:",
"UserChangeLog.Chiller.Text":"chiller:",
"UserChangeLog.ChillerNamed.Text":"chiller named:",
"TESUserChangeLog.lblArrangeBy.Text":"Arrange By:",
"TESUserChangeLog.lnkCollapseAll.Text":"Collapse All",
"EnumTESUserChangeLog.cboForColumn.Text":"Date,Affected,DateAffected,User,DateUser,Transaction,DateTransaction,NoGroups",
"EnumTESUserChangeLog.cboForColumn.Date.Text":"Date",
"EnumTESUserChangeLog.cboForColumn.Affected.Text":"Affected",
"EnumTESUserChangeLog.cboForColumn.DateAffected.Text":"Date and Affected",
"EnumTESUserChangeLog.cboForColumn.User.Text":"User",
"EnumTESUserChangeLog.cboForColumn.DateUser.Text":"Date and User",
"EnumTESUserChangeLog.cboForColumn.Transaction.Text":"Transaction Type",
"EnumTESUserChangeLog.cboForColumn.DateTransaction.Text":"Date and Transaction Type",
"EnumTESUserChangeLog.cboForColumn.NoGroups.Text":"No Groups - Sort Only",
"EnumTESUserChangeLog.SortOrder.Text":"ASC,DESC",
"EnumTESUserChangeLog.SortOrder.ASC.Text":"A on top",
"EnumTESUserChangeLog.SortOrder.DESC.Text":"Z on top",
"EnumTESUserChangeLog.SourceOrder.Text":"DESC,ASC",
"EnumTESUserChangeLog.SourceOrder.ASC.Text":"Oldest on top",
"EnumTESUserChangeLog.SourceOrder.DESC.Text":"Newest on top",
"EnumTESUserChangeLog.NoGroupSortOrder.Text":"DESC,ASC,NOGROUPS_ASC,NOGROUPS_DESC",
"EnumTESUserChangeLog.NoGroupSortOrder.ASC.Text":"Oldest on top",
"EnumTESUserChangeLog.NoGroupSortOrder.DESC.Text":"Newest on top",
"EnumTESUserChangeLog.NoGroupSortOrder.NOGROUPS_ASC.Text":"A on top",
"EnumTESUserChangeLog.NoGroupSortOrder.NOGROUPS_DESC.Text":"Z on top",
"Alarms.ProgressIndicator.Header.Text":"Loading",
"Buttons.Back.Text":"< Actions and Settings",
"UserChangeLog.Affected.label.Text":"Enter text to match in the link names if items affected by transactions in the User Change Log.",
"UserChangeLog.Transaction.label.Text":"Enter text to search for in all fields of the User Change Log. Use quotes to indicate an exact phrase.",
"CriticalPoints.Add.Text":"Add",
"CriticalBuildingName.Label.Text":"Building Name",
"CriticalFamilyName.Label.Text":"Family Type",
"CriticalPagePassword.Label.Text":"Password",
"CriticalPageComment.Label.Text":"Comment",
"CriticalPagePropertiesGridHeader.Columns.Name.Text":"Name",
"CriticalPageEquipmentGridHeader.Columns.Name.Text":"Type",
"CriticalPageConfirm.Label.Text":"Confirm Addition",
"CriticalPageConfirmAddition.SubHeader.Label.Text":"Adding points to Critical Control requires an electronic signature.  To sign, enter your login password.",
"CriticalPageComment.UA.Text":"You may optionally enter a comment that will appear in the User Change Log.",
"AddMoreCriticalPoints.CreateAddMoreCriticalPointsButton.Text":"Add additional items to Critical Control",
"RemoveCriticalPoints.RemoveCriticalPointsButton.Text":"Remove Selected from Critical Control",
"AddCriticalControlGridSubHeader.lblGridSubHeader.Text":"Objects and Points",
"AddCriticalControlGridSubHeader.lblGridSubHeaderPoints.Text":"Select Points",
"AddCriticalControlGridSubHeader.lblEquipmentObjects.Text":"Equipment/Objects",
"AddCriticalControlGridSubHeader.lblPoints.Text":"Points",
"RemoveCriticalControlUserControl.Header.Text":"Confirm Removal of Points from Critical Control",
"RemoveCriticalControlUserControl.SubHeader.Text":"You have selected to remove the points shown below from Critical Control. This action requires confirmation for each point by means of an electronic signature. To sign, enter your login password.  You may optionally enter a comment for each point.",
"RemoveCriticalControlUserControl.RepeaterHeaderPoint.Text":"Point",
"RemoveCriticalControlUserControl.ConfirmBtn.Text":"Confirm",
"CriticalControl.PwdValidation.Text":"Error: Incorrect password",
"CriticalPoints.Cancel.Text":"Cancel",
"ChangeCriticalControlUserControl.SubHeader.Text":"You have selected to change the value of the critically controlled points shown below. The changes require confirmation for each point by means of an electronic signature. To sign, enter your login password.  You may optionally enter a comment for each point.",
"ChangeCriticalControlUserControl.SimpleSubHeader.Text":"You have selected to change the value of the critically controlled point shown below. This change requires confirmation by means of an electronic signature. To sign, enter your login password.  You may optionally enter a comment.",
"ChangeCriticalControlUserControl.Header.Text":"Confirm Changes to Critical Points",
"ChangeCriticalControlUserControlSimpleOverride.Header.Text":"Confirm Change to Critical Point",
"ChangeCriticalControlAcknowledgement.Text":"I acknowledge I have read the statement below:",
"ChangeCriticalControl.Required.Text":"required",
"ManageCriticalPoints.GridHeaderSort.Text":"Sort:",
"ManageCriticalPoints.GridHeaderArrangeBy.Text":"Arrange By:",
"ManageCriticalPoints.ddlArrangeBy.0.Text":"No Groups - Sort Only",
"ManageCriticalPoints.ddlArrangeBy.1.Text":"Building",
"ManageCriticalPoints.FilterHeaderBuildings.Text":"Buildings",
"ManageCriticalPoints.FilterHeaderPoints.Text":"Points",
"ManageCriticalPoints.Buildings.label.Text":"Enter text to match in the Building links.",
"ManageCriticalPoints.Points.label.Text":"Enter text to match in the Point links.",
"ManageCriticalPoints.Points.Button.Back.Text":"< Back",
"AddCriticalPoints.ShowSel.Text":"Show Selected",
"AddCriticalPoints.ShowAll.Text":"Show All",
"AddCriticalPoints.ControlledObjectLink.Text":"Add Selections from a Controlled Object",
"AddCriticalPoints.ControlledObjectLink.Header.Text":"Add Point Selections",
"AddCriticalPoints.ControlledObjectLink.SubHeader.Text":"To add additional point selections to the Points table, select an Equipment/Object.",
"AddCriticalPoints.ControlledObjectLink.AddSelection.Text":"Add Selections",
"CriticalControl.RequireComment.Text":"Require Comment",
"CriticalControl.RequireComment.UA.Text":"Require users to enter a comment if changing this point.",
"CriticalControl.DisplayImpactStatement.Text":"Display the following impact statement to a user who is changing this point. The user will be required to acknowledge this message.",
"CriticalControl.OptionalRequirements.Text":"Optional User Requirements",
"CriticalControl.ControlSelection.Text":"Select Controls",
"CriticalControl.Statement.Text":"Statement",
"UserChangeLog.ExportHeader.Text":"Export  Transactions",
"UserChangeLog.ExportUAText.Text":"Select which transactions to export and the desired format.",
"UserChangeLog.ExportUATextWithoutFilter.Text":"Select the desired export format.",
"UserChangeLog.ExportTransactions.Text":"Transactions",
"UserChangeLog.ExportAll.Text":"Export All",
"UserChangeLog.ExportFiltered.Text":"Export as Filtered",
"UserChangeLog.ExportFormat.Text":"Format",
"UserChangeLog.ExportCSV.Text":"CSV",
"UserChangeLog.ExportExcel.Text":"Excel",
"UserChangeLog.ExportPDF.Text":"PDF",
"UserChangeLog.ExportClose.Text":"Cancel",
"UserChangeLog.ExportSave.Text":"Apply",
"UserChangeLog.Export.Text":"Export",
"UserChangeLog.ExportDateHeader.Text":"Date/Time of Change",
"UserChangeLog.ExportTransactionTypeHeader.Text":"Transaction Type",
"UserChangeLog.ExportUserIdHeader.Text":"User ID",
"UserChangeLog.ExportAffectedHeader.Text":"Affected",
"UserChangeLog.ExportDetailsHeader.Text":"Details",
"UserChangeLog.UAText.Text":"Use the filters and Arrange By fields to view User Change Log data.",
"UserChangeLog.CustomDateRangeError.Text":"Error: You left necessary fields blank or entered invalid values. Review and correct any fields with \"!\" next to them.",
"TechnicianLog.Label.MB.Text":"MB",
"ActionsAndSettings.LogsReports.TechnicianToolsLink.Text":"Technician Tools",
"TechnicianLog.TitleHeader.Text":"Technician Tools",
"TechnicianLog.ConfigureTechnicianLogSettingsTHN.Text":"ConfigureTechnician Log Settings",
"TechnicianLog.RetrieveTechnicianLogsTHN.Text":"Retrieve Technician Logs",
"TechnicianLog.BACnetCaptureLogSettingsTHN.Text":"TBACnetCapture Log Settings",
"TechnicianLog.TechnicianTools.HeaderTitle.Text":"Technician Tools",
"TechnicianLog.TechnicianTools.UAText.Text":"Click the links to perform technician tasks.",
"TechnicianLog.TechnicianTools.ExistingTechnicianLogsLink.Text":"Retrieve Existing Technician Logs",
"TechnicianLog.TechnicianTools.ExistingTechnicianLogsUAText.Text":"Retrieve the logs that are automatically collected for Tracer Ensemble components.",
"TechnicianLog.TechnicianTools.ConfigureTechnicianLogsLink.Text":"Configure Future Technician Log Collection",
"TechnicianLog.TechnicianTools.ConfigureTechnicianLogsUAText.Text":"Change the settings that control the amount of data that will be collected. The default settings are best for almost every situation.",
"TechnicianLog.Buttons.Cancel.Text":"Cancel",
"TechnicianLog.Buttons.Save.Text":"Save",
"TechnicianLog.ConfigureTechnicianLogSettings.HeaderTitle.Text":"Configure Technician Log Settings",
"TechnicianLog.ConfigureTechnicianLogSettings.Columns.ApplicationName.Text":"Tracer ES Component Log",
"TechnicianLog.ConfigureTechnicianLogSettings.Columns.LoggingLevel.Text":"Logging Level",
"TechnicianLog.ConfigureTechnicianLogSettings.lblTracerESsystemLog.Text":"Tracer Ensemble System Log Logging Level",
"TechnicianLog.ConfigureTechnicianLogSettings.rbtnLogBasic.Text":"Basic",
"TechnicianLog.ConfigureTechnicianLogSettings.rbtnLogDetailed.Text":"Detailed",
"TechnicianLog.ConfigureTechnicianLogSettings.lblMaxfileSize.Text":"Maximum File Size per Component Log",
"TechnicianLog.ConfigureTechnicianLogSettings.lblMaxNumberofFiles.Text":"Maximum Number of Log Files per Component",
"TechnicianLog.ConfigureTechnicianLogSettings.Buttons.RestoreToDefaultSettings.Text":"Restore Default Settings",
"TechnicianLog.ConfigureTechnicianLogSettings.Buttons.RestoreToBACnetSCSettings.Text":"BACnet/SC Settings",
"TechnicianLog.RetrieveTechnicianLogs.HeaderTitle.Text":"Retrieve Technician Logs",
"TechnicianLog.RetrieveTechnicianLogs.UAText.Text":"The following log files will be combined into a single .zip file for retrieval.",
"TechnicianLog.RetrieveTechnicianLogs.lblDetailedcomponentLogs.Text":"Detailed Component Logs",
"TechnicianLog.RetrieveTechnicianLogs.lblBasicComponentLogs.Text":"Basic Component Logs",
"TechnicianLog.RetrieveTechnicianLogs.lblTracerESSystemLog.Text":"Tracer Ensemble System Log",
"TechnicianLog.RetrieveTechnicianLogs.WhatIsThisLink.Text":"What is this?",
"TechnicianLog.RetrieveTechnicianLogs.lblIISLog.Text":"IIS Log",
"TechnicianLog.RetrieveTechnicianLogs.lblWindowsApplicationLog.Text":"Windows Application Log",
"TechnicianLog.RetrieveTechnicianLogs.lblUserInfoDefaultSettings.Text":"The default retrieval settings are correct for almost every situation.",
"TechnicianLog.RetrieveTechnicianLogs.lblIISLogPopup.Text":"Retrieve the IIS logs for the last",
"TechnicianLog.RetrieveTechnicianLogs.lblWindowsApplicationLogPopup.Text":"Retrieve the Windows Application Log",
"TechnicianLog.RetrieveTechnicianLogs.lblWeeks.Text":"Weeks",
"TechnicianLog.RetrieveTechnicianLogs.lblChangeRetrievalSettingsUAText.Text":"Change Retrieval Settings",
"TechnicianLog.RetrieveTechnicianLogs.lblExportFileUAText.Text":"Creating export file...",
"TechnicianLog.RetrieveTechnicianLogs.Button.RetrieveLogFiles.Text":"Retrieve Log Files",
"TechnicianLog.RetrieveTechnicianLogs.Button.ChangeRetrievalSettings.Text":"Change Retrieval Settings",
"TechnicianLog.RetrieveTechnicianLogs.Button.ReturnToTechnicianTools.Text":"< Technician Tools",
"TechnicianLog.RetrieveTechnicianLogs.RetrievalError.Text":"logs cannot be retrieved due to insufficient user permissions.",
"TechnicianLog.RetrieveTechnicianLogs.IISLOGsDescription.Text":"The IIS log contains information about HTTP transactions.  It is created by the Windows Internet Information Services.",
"TechnicianLog.RetrieveTechnicianLogs.WinLOGsDescription.Text":"The Windows Application Log is an event log for the Windows Server.",
"TechnicianLog.BACnetCaptureLogSettings.HeaderTitle.Text":"Configure the building name to capture the BACnet logs",
"TechnicianLog.ComponentDisplayName.Site.Text":"Site",
"TechnicianLog.ComponentDisplayName.Status.Text":"Status",
"TechnicianLog.ComponentDisplayName.Alarm.Text":"Alarming",
"TechnicianLog.ComponentDisplayName.DataLog.Text":"Data Log",
"TechnicianLog.ComponentDisplayName.ReportManagement.Text":"Report Management",
"TechnicianLog.ComponentDisplayName.DataVisualization.Text":"Data Visualization",
"TechnicianLog.ComponentDisplayName.Schedule.Text":"Scheduling",
"TechnicianLog.ComponentDisplayName.GlobalChange.Text":"Global Changes",
"TechnicianLog.ComponentDisplayName.GlobalPointControl.Text":"Global Point Control",
"TechnicianLog.ComponentDisplayName.Security.Text":"Security",
"TechnicianLog.ComponentDisplayName.Administration.Text":"Administration",
"TechnicianLog.ComponentDisplayName.Navigation.Text":"Navigation",
"TechnicianLog.ComponentDisplayName.ProcessTracker.Text":"Process Tracker",
"TechnicianLog.ComponentDisplayName.SystemHealth.Text":"System Health",
"TechnicianLog.ComponentDisplayName.BACnetServices.Text":"BACnet Services",
"TechnicianLog.ComponentDisplayName.WebLog.Text":"WebLog",
"TechnicianLog.ComponentDisplayName.BACnetSimulator.Text":"BACnet Simulator",
"TechnicianLog.ComponentDisplayName.EnterpriseWebServices.Text":"Enterprise WebServices",
"TechnicianLog.ComponentDisplayName.TestHarness.Text":"TestHarness",
"TechnicianLog.ComponentDisplayName.IntegrationTestHarness.Text":"Integration Test Harness",
"TechnicianLog.ComponentDisplayName.DomainModel.Text":"DomainModel",
"TechnicianLog.ComponentDisplayName.TenantServices.Text":"Tenant Services",
"TechnicianLog.ComponentDisplayName.HubManagement.Text":"Hub Management",
"TechnicianLog.ComponentDisplayName.Kernel.Text":"kernel",
"TechnicianLog.ComponentDisplayName.BACNetSC.Text":"BACNetSC",
"TechnicianLog.ComponentDisplayName.CommMessage.Text":"CommMessage",
"CustomizeSite.ContentHeader.Text":"Customize Site",
"CustomizeSite.lblUAText.Text":"Use the options below to customize your Tracer Ensemble site.",
"CustomizeSite.CustomGraphics.Text":"Custom Graphics",
"CustomizeSite.CustomGraphicsUA.Text":"View a list of the custom graphics in the system.",
"CustomizeSite.AssignGraphics.Text":"Assign Graphics",
"CustomizeSite.AssignGraphicsUA.Text":"Assign graphics for multiple equipment based on family type, object type and building.",
"CustomizeSite.Attributes.Text":"Attributes",
"CustomizeSite.AttributesUA.Text":"Add attributes for your buildings.  These can be used to group buildings on the home page.",
"CustomizeSite.VirtualBuildings.Text":"Virtual Buildings",
"CustomizeSite.VirtualBuildingsUA.Text":"Split discovered buildings into virtual buildings to suit the way that you want to see your site.",
"ManageAlarmSettings.lblContentHeading.Text":"Search for Alarming Properties",
"ManageAlarmProperties.lblUserAsstMessage.Text":"View properties that were found in a previous search or perform a new search.</br> You may start a search, navigate to another page, and return later to see the results.",
"btn.CreateAlarmLimits.Text":"Create Search Query",
"BuildingGroup.lblFirstlevelgrouping.Text":"1st Level <br /> Grouping",
"HomePage.AlarmNeedsAcknowledge.Text":"{0} alarms need to be acknowledged today",
"HomePage.NumberOfHotSpaces.Text":"{0} of {1} spaces are too hot",
"HomePage.NumberOfColdSpaces.Text":"{0} of {1} spaces are too cold",
"HomePage.ChillerPlants.Text":"{0}: Water supply temperature is {1}",
"HomePage.ChillerPlants.NoHealthIssue.Text":"All Water Supply Temperatures are in normal range",
"HomePage.AirHandlers.DischargeAirTemperature.Text":"{0}: Discharge air temperature is {1}",
"HomePage.AirHandlers.DuctStaticPressure.Text":"{0}: Duct static pressure is {1}",
"HomePage.AirHandlers.NoHealthIssue.Text":"All Discharge Air Temperatures and Duct Static Pressures are in normal range",
"HomePage.OfflineSpaces.Text":"{0} of {1} spaces are offline",
"HomePage.OfflineDevices.Text":"Device {0} is offline",
"HomePage.OfflineDevices.NoHealthIssue.Text":"All SC, SC+, BCU and bridge devices are communicating",
"BuildingGroup.lblSecondlevelgrouping.Text":"2nd Level <br /> Grouping",
"BuildingGroup.lblDisplay.Text":"Display",
"EnumDisplay.Text":"0,1",
"EnumDisplay.0.Text":"Full",
"EnumDisplay.1.Text":"Compact",
"btnApply.Group.Text":"Apply",
"lblSort.Group.Text":"Sort",
"BuildingTree.Filterbuilding.Text":"Buildings",
"lblBuildingName.MatchText.Text":"Match Text",
"btnMatch.Buildingname.Text":"Filter",
"BuildingTree.FilterBuildingHealth.Text":"Building Health",
"BuildingTree.CBUnAcknowledgedAlarm.Text":"Unacknowledged alarms",
"BuildingTree.CBOfflineDevices.Text":"Offline SC or BCU",
"BuildingTree.CBHotSpaces.Text":"Hot Spaces",
"BuildingTree.CBColdSpaces.Text":"Cold Spaces",
"BuildingTree.AirHandler.Text":"Air Handler Problems",
"BuildingTree.ChilledWater.Text":"Chilled Water Problems",
"BuildingGroup.ddlSort.Option1.Description.Text":"Building Health",
"BuildingGroup.ddlSort.Option1.Value.Text":"BuildingHealth",
"BuildingGroup.ddlSort.Option2.Description.Text":"Building Name",
"BuildingGroup.ddlSort.Option2.Value.Text":"BuildingName",
"NoBuildingSatisfy.Text":"No buildings satisfy the search criteria.",
"ConfigureBuildingHealthSettings.PageHeader.Text":"Configure Building Health Settings",
"ConfigureBuildingHealthSettings.lblUserAsstMessage.Text":"On the All Buildings page, buildings with Building Health Status Display disabled are indicated with a gray card header and are not included in Building Health filter results.",
"ConfigureBuildingHealthSettings.EnableButton.Text":"Enable Building Health",
"ConfigureBuildingHealthSettings.DisableButton.Text":"Disable Building Health",
"ConfigureBuildingHealthSettings.Column.BuildingName.Text":"Building Name",
"ConfigureBuildingHealthSettings.Column.City.Text":"City",
"ConfigureBuildingHealthSettings.Column.State.Text":"State",
"ConfigureBuildingHealthSettings.Column.Enabled.Text":"Enabled",
"ConfigureBuildingHealthSettings.Column.Disabled.Text":"Disabled",
"ConfigureBuildingHealthSettings.Column.BuildingHealthStatusDisplay.Text":"Building Health",
"ConfigureBuildingHealthSettings.Column.BuildingHealthConditionDisplay.Text":"Building Health Conditions",
"ConfigureBuildingHealthSettings.Column.AlertOnlyWhenOccupiedDisplay.Text":"Alert Only When Occupied",
"ConfigureBuildingHealthSettings.CancelButton.Text":"Cancel",
"ConfigureBuildingHealthSettings.SaveButton.Text":"Save",
"ConfigureBuildingHealthSettings.HealthConditionButton.Text":"Select Health Conditions",
"ConfigureBuildingHealthSettings.lblHeadingForHealthConditionPopup.Text":"Select Building Health Conditions",
"ConfigureBuildingHealthSettings.lblAsstMsgForHealthConditionPopup.Text":"Conditions selected here will be used to determine building health. Building health is indicated by the header color of the building card on the All Buildings page.",
"ConfigureBuildingHealthSettings.lblUnacknowledgedAlarms.Text":"Unacknowledged alarms from today",
"ConfigureBuildingHealthSettings.lblOfflineDevices.Text":"Non-communicating devices",
"ConfigureBuildingHealthSettings.lblHotSpaces.Text":"Hot spaces",
"ConfigureBuildingHealthSettings.lblColdSpaces.Text":"Cold spaces",
"ConfigureBuildingHealthSettings.lblChilledWater.Text":"Chilled Water",
"ConfigureBuildingHealthSettings.lblAirHandler.Text":"Air Handlers",
"ConfigureBuildingHealthSettings.HealthCondition.UnacknowledgedAlarms.Text":"Alarms",
"ConfigureBuildingHealthSettings.HealthCondition.OfflineDevices.Text":"Device Communication",
"ConfigureBuildingHealthSettings.HealthCondition.HotSpaces.Text":"Hot Spaces",
"ConfigureBuildingHealthSettings.HealthCondition.ColdSpaces.Text":"Cold Spaces",
"ConfigureBuildingHealthSettings.HealthCondition.ChilledWater.Text":"Chilled Water",
"ConfigureBuildingHealthSettings.HealthCondition.AirHandlers.Text":"Air Handlers",
"ConfigureBuildingHealthSettings.HealthCondition.Empty.Text":"None",
"ConfigureBuildingHealthSettings.lblUnoccupiedSpaces.Text":"Ignore space conditions when unoccupied",
"CustomizeEquipment.TitleHeader.Text":"Customize Equipment",
"CustomizeEquipment.TitleSubHeader.Equipment.Text":"Equiment",
"CustomizeEquipment.Columns.DefaultName.Text":"Name",
"CustomizeEquipment.Columns.Visiblity.Text":"Visibility",
"CustomizeEquipment.Columns.lblDisplayStatus.Text":"Display on Status Tab",
"CustomizeEquipment.ToggleHelp.Text":"To enable a toggle, select its row,<br/> then click the Show Everywhere button.",
"CustomizeEquipment.CancelButton.Text":"Cancel",
"CustomizeEquipment.NextButton.Text":"Next",
"CustomizeEquipment.Visiblity.Shown.Text":"Shown",
"CustomizeEquipment.Visiblity.Hidden.Text":"Hidden",
"CustomizeEquipment.HeaderButton.HideEveryWhere.Text":"Hide Everywhere",
"CustomizeEquipment.HeaderButton.ShowEveryWhere.Text":"Show Everywhere",
"CustomizeEquipment.HeaderButton.RestoreDefaults.Text":"Restore Defaults",
"CustomizeEquipment.Columns.lblDisplayStandardGraphic.Text":"Display on Standard Graphic",
"CustomizeBuildingEquipment.rbtnCurrentEquipment.Text":"Apply customization to current equipment only",
"CustomizeBuildingEquipment.rbtnSelectedEquipment.Text":"Apply customization to selected equipment",
"lbl.BuildingHeader.Text":"Buildings",
"CustomizeBuildingEquipment.BuildingHeader.Text":"Buildings",
"CustomizeBuildingEquipment.lbtnBuilding.Text":"Select Buildings...",
"CustomizeBuildingEquipment.btnCancel.Text":"Cancel",
"CustomizeBuildingEquipment.btnApply.Text":"Apply",
"ManageStandardReport.Add.Text":"Add >",
"ManageStandardReport.Remove.Text":"< Remove",
"CustomizeBuildingEquipment.lblAvailableHeader.Text":"Available Equipment",
"CustomizeBuildingEquipment.lblSelectedHeader.Text":"Selected Equipment",
"CustomizeBuildingEquipment.lnk_AvailSortBuilding.Text":"Building",
"CustomizeBuildingEquipment.lnk_AvailSortType.Text":"Family Type",
"CustomizeBuildingEquipment.lnk_AvailSortObject.Text":"Equipment",
"CustomizeBuildingEquipment.btnBack.Text":"Back",
"CustomizeBuildingEquipment.btnFinish.Text":"Finish",
"CustomizeBuildingEquipment.Message.NothingModified.Text":"Error: Modify the value before you click next.",
"ddlFirstlevel.nogroups.Text":"No Grouping - Sort Only",
"ddlFirstlevel.nogroup.value.Text":"nogroup",
"ddlSecondlevel.none.Text":"None",
"ddlSecondlevel.none.value.Text":"none",
"Btnsave.currentview.Text":"Save current view as default view for this page",
"Edit.Settings.Text":"Edit settings for this page",
"RemoteAccessClient.InValidRegistrationIdError.Text":"A valid license is required",
"RemoteAccessClient.TabName.Text":"Trane Connect Remote Access",
"RemoteAccessClient.TabHeader.Text":"Trane Connect Remote Access Utility",
"RemoteAccessClient.RegistrationId.Text":"Registration ID",
"RemoteAccessClient.PortNumber.Text":"Port Number",
"RemoteAccessClient.HeaderTitle.Text":"Interface For Trane Connect Remote Access",
"RemoteAccessClient.WebSocket.Text":"Tracer Ensemble (WebSocket)",
"RemoteAccessClient.Status.Text":"Status",
"RemoteAccessClient.ButtonDisable.Text":"Disable Trane Connect",
"RemoteAccessClient.ButtonEnable.Text":"Enable Trane Connect",
"RemoteAccessClient.ProgressIndicator.Header.Text":"Pending...",
"RemoteAccessClient.Region.Text":"Region",
"RemoteAccessClient.ModifyRegion.SaveToolTip.Text":"Save changes",
"RemoteAccessClient.ModifyRegion.CancelToolTip.Text":"Cancel changes",
"RemoteAccessClient.ModifyRegion.EditToolTip.Text":"Edit Region",
"RemoteAccessClient.ConnectState.EditToolTip.Text":"You must select the Disable Trane Connect button prior to editing the Region",
"ServerInformation.PageTitle.Text":"Server Information",
"ServerInformation.ServerInstanceDetails.Text":"Server Instance details",
"ServerInformation.WindowsServerEdition.Text":"Windows Server Edition",
"ServerInformation.WindowsServerOSVersion.Text":"Windows Server OS Version",
"ServerInformation.ProcessorDetails.Text":"Processor",
"ServerInformation.TotalMemory.Text":"Installed Total RAM Memory",
"ServerInformation.IISVersion.Text":"Web Server (IIS) Version",
"ServerInformation.RequireSSL.Text":"Web Server (IIS) - Require SSL",
"ServerInformation.RequireSSLTrue.Text":"Enabled",
"ServerInformation.RequireSSLFalse.Text":"Disabled",
"ServerInformation.SSLRedirect.Text":"SSL Redirect",
"ServerInformation.CPUUtilization.Text":"Total CPU Utilization",
"ServerInformation.ESCPUUtilization.Text":"Ensemble CPU Utilization",
"ServerInformation.RAMUtilization.Text":"Total RAM Utilization",
"ServerInformation.ESRAMUtilization.Text":"Ensemble RAM Utilization",
"ServerInformation.SQLInstanceDetails.Text":"SQL Server Instance details",
"ServerInformation.DBInstanceName.Text":"Database Instance Name",
"ServerInformation.DBEdition.Text":"Database Edition",
"ServerInformation.DBOriginalVersion.Text":"Database Original Version",
"ServerInformation.DBCurrentVersion.Text":"Database Current Version",
"ServerInformation.DBSize.Text":"Database Size",
"ServerInformation.SQLDriveMemory.Text":"Total SQL Server Hard drive Memory",
"ServerInformation.AvailSQLDriveMemory.Text":"Available SQL Server Hard drive Memory",
"ServerInformation.SQLRAMMemory.Text":"Total RAM Memory in SQL Server Machine",
"ServerInformation.AvailSQLRAMMemory.Text":"Available RAM Memory in SQL Server Machine",
"ServerInformation.DBRowCountDetails.Text":"Database Table Row Count details",
"ServerInformation.DBFragmentationDetails.Text":"Database Table Fragmentation Details",
"ServerInformation.DatalogFragmentationDetails.Text":"DataLog Fragmentation Details",
"ConfigureSAML.lblTitleHeader.Text":"Configuration for Single Sign-On using SAML 2.0",
"ConfigureSAML.lblIDPMetadataURL.Text":"Configure via Identity Provider Metadata URL",
"ConfigureSAML.lblMetadataURL.Text":"Metadata URL*",
"ConfigureSAML.lblIDPMetadata.Text":"Configure via Identity Provider Metadata XML File",
"ConfigureSAML.lblIDPEntityID.Text":"Identity Provider Entity ID or Issuer*",
"ConfigureSAML.lblLoginURL.Text":"SAML 2.0 Login URL*",
"ConfigureSAML.lblCertificate.Text":"X.509 Certificate*",
"ConfigureSAML.lblServiceProviderDetails.Text":"Service Provider Details",
"ConfigureSAML.lblServiceProviderNote.Text":"Use these details for integrating Tracer Ensemble with your Identity Provider.",
"ConfigureSAML.lblServiceProviderEntityID.Text":"Entity ID",
"ConfigureSAML.lblServiceProviderAssertionURL.Text":"Assertion Consumer URL",
"ConfigureSAML.lblServiceProviderDownloadMetadata.Text":"Download Service Provider Metadata File",
"ConfigureSAML.lblIdentityProviderDetails.Text":"Configure Identity Provider Details",
"ConfigureSAML.lblEnableSAML.Text":"Enable SSO/SAML 2.0",
"ConfigureSAML.lblDomain.Text":"Specify email domains to be allowed to authenticate via your SAML server. We need a list of all the email domains that your users will be using to access Ensemble.Public domains (e.g., gmail.com, outlook.com, etc.) are not permitted*",
"ConfigureSAML.lblConfirmUsers.Text":"Confirm Users for SAML",
"ConfigureSAML.lblReview.Text":"The following user accounts are ready to be converted to SAML. Uncheck any users that you would NOT like to convert to SAML for sign-on. Users with a checked box will be converted to SAML for sign-on. If a user does not appear on this page, please review their user account information on the previous page.",
"ConfigureSAML.lblConfigureUsers.Text":"Configure users to SAML",
"ConfigureSAML.labelUpdateUser.Text":"The following user accounts require action to be converted to SAML. Use the ‘Paper & Pencil’ icon in the  E-Mail Address column to add/update users that need to be converted to SAML. The email address entered must match the email domains that were added on the previous SAML Setup page. Users with a checked box will appear on the Confirm Users step. Users that already have email addresses that match the email domains on the SAML Setup page automatically appear on the Confirm Users step.",
"ConfigureSAML.chkForceAuthentication.Text":"Enable Force Authentication",
"ConfigureSAML.ForceAuthenticationHeader.Text":"Force Authentication",
"ConfigureSAML.ForceAuthenticationMsg.Text":"You are about to disable the Force Authentication from the system.",
"SecureNetwork.ManageSecureNetwork.Text":"Manage Secure Connect BACnet Network",
"SignCertificate.ManageSignCertificate.Text":"Manage Certificate Signing Requests",
"ManageSecureNetwork.hlnkbtnAction.Text":"Actions",
"ManageSecureNetwork.hlnkAddNewSecureNetwork":"Create",
"ActionsAndSettings.Buildings.BACnetSCSetup.Text":"BACnet Secure Connect",
"ActionsAndSettings.Buildings.SecureNetwork.Text":"Secure Network",
"ActionsAndSettings.Buildings.SignCertificate.Text":"Sign Certificate",
"SystemAdmin.BACnetSCSetup.HeaderTitle.Text":"BACnet Secure Connect",
"SystemAdmin.BACnetSCSetup.UAText.Text":"Click the links to configure BACnet Secure Connect",
"SystemAdmin.BACnetSCSetup.ManageNetworksLink.Text":"Manage Networks",
"SystemAdmin.BACnetSCSetup.ManageNetworksUAText.Text":"Create a BACnet Secure Connect network and view information for connected devices.",
"SystemAdmin.BACnetSCSetup.ManageCertificatesLink.Text":"Manage Settings",
"SystemAdmin.BACnetSCSetup.ManageCertificatesUAText.Text":"View and sign certificates for BACnet Secure Connect node devices.",
"RegisterTESSiteLicense.WorkOrder.Text":"Work Order",
"RegisterTESSiteLicense.WorkOrder.Licensed.Text":"Licensed",
"RegisterTESSiteLicense.DashBoard.Licensed.Text":"Licensed",
"EnumWindiws.SSL.Text":"0,1,2",
"EnumWindiws.SSL.0.Text":"None",
"EnumWindiws.SSL.1.Text":"Password",
"EnumWindiws.SSL.2.Text":"All",
"InstallBuilding.Status.Text":"Status",
"InstallBuilding.Status.Canceled.Text":"Canceled",
"InstallBuilding.Status.Failed.Text":"Failed",
"InstallBuilding.Status.Waiting.Text":"Waiting",
"InstallBuilding.Status.Discovering.Text":"Discovering",
"InstallBuilding.Status.SelectDevices.Text":"Select Devices",
"InstallBuilding.Status.Uploading.Text":"Uploading",
"InstallBuilding.Status.Complete.Text":"Complete",
"InstallBuilding.Status.Deleted.Text":"Deleting",
"InstallBuilding.Status.NotConnected.Text":"Not Connected",
"InstallBuilding.Status.LicenseVoilation.Text":"Panel license voilation",
"InstallBuilding.Status.AccessRight.Text":"User does not have a permission to add buildings",
"InstallBuilding.Status.ArgumentError.Text":"User does not give enough building information in order to add this building",
"SiteSync.Status.Synchronizing.Text":"Synchronization in Progress",
"ViewHubParameters.ViewHeaderTitle.Text":"View Hub Parameters",
"ViewHubParameters.EditHeaderTitle.Text":"Edit Hub Parameters",
"ViewHubParameters.ServerEnabledStatus.Text":"Ensemble Hub Server Enabled:",
"ViewHubParameters.ServerRunningStatus.Text":"Ensemble Hub Server Running:",
"ViewHubParameters.Yes.Text":"Yes",
"ViewHubParameters.No.Text":"No",
"ViewHubParameters.Back.Text":"Back",
"ViewHubParameters.Edit.Text":"Edit",
"ViewHubParameters.Mode.Text":"Mode",
"ViewHubParameters.Port.Text":"Port",
"ViewHubParameters.PrimaryHubURL.Text":"Primary Hub URL",
"ViewHubParameters.FailoverHubURL.Text":"Failover Hub URL",
"ViewHubParameters.VMAC.Text":"VMAC",
"ViewHubParameters.CACertificate.Text":"CA Certificate",
"ViewHubParameters.IssuerCertificate.Text":"Issuer Certificate",
"ViewHubParameters.OperationalCertificate.Text":"Operational Certificate",
"ViewHubParameters.TLSVersionAllowed.Text":"TLS Version Allowed",
"ViewHubParameters.ExpiresOnCamelCase.Text":"Expires On",
"ViewHubParameters.ExpiresOn.Text":"expires on",
"ViewHubParameters.IssuerSubjectName.Text":"Issuer Subject Name (CN)",
"ViewHubParameters.IssuerCertificateValidity.Text":"Issuer Certificate Validity",
"ViewHubParameters.HubOperationalCertificateValidity.Text":"Hub Operational Certificate Validity",
"ViewHubParameters.TLSVersion.Text":"TLS Version",
"ViewHubParameters.GenerateNewCSR.Text":"Generate New CSR",
"ViewHubParameters.ChooseFile.Text":"Choose File",
"ViewHubParameters.Apply.Text":"Apply",
"ViewHubParameters.Cancel.Text":"Cancel",
"ViewHubParameters.CertificateDetails.Text":"Certificate Details for",
"ViewHubParameters.DistinguishedName.Text":"Distinguished Name",
"ViewHubParameters.IssuedBy.Text":"Issued By",
"ViewHubParameters.NotBefore.Text":"Not Before",
"ViewHubParameters.NotAfter.Text":"Not After",
"ViewHubParameters.Thumbprint.Text":"Thumbprint",
"ViewHubParameters.Download.Text":"Download",
"ViewHubParameters.Close.Text":"Close",
"ViewHubParameters.Alert.Text":"Alert",
"ViewHubParameters.AlertMessageOnApply.Text":"Applying these changes would impact communication with buildings. Are you sure you want to apply these changes ?",
"ViewHubParameters.ErrorAlertTitle.Text":"Please correct all errors before continuing.",
"ViewHubParameters.ErrorsOnPage.Text":"error on this page",
"ViewHubParameters.SelectedCACertificate.Text":"Selected CA Certificate file to import",
"ViewHubParameters.SelectedOperationalCertificate.Text":"Selected Operational Certificate file to import",
"ViewHubParameters.Import.Text":"Import",
"ViewHubParameters.ImportCertificateError.Text":"Import Certificate Error",
"ViewHubParameters.ImportCertificateErrorMessage.Text":"The following error occurred while importing certificate...",
"ViewHubParameters.OK.Text":"OK",
"ViewHubParameters.ConfirmImport.Text":"Confirm Import",
"ViewHubParameters.ConfirmImportMessage.Text":"You are about to import a new CA Certificate This will replace the current CA Certificate for this link. Do you want to overwrite the existing certificate ?",
"ViewHubParameters.YesOverwrite.Text":"Yes - Overwrite",
"ViewHubParameters.NoCancel.Text":"No - Cancel",
"ViewHubParameters.ImportingCertificate.Text":"Importing Certificate...",
"ViewHubParameters.AutoGenerateCertificates.Text":"Auto Generate Certificates",
"ViewHubParameters.Error.portNumber.Text":"Invalid port number",
"ViewHubParameters.Error.primaryHubURI.Text":"Invalid URL",
"ViewHubParameters.Error.failoverHubURI.Text":"Invalid URL",
"ViewHubParameters.Error.rootCertificateRequest.Text":"No certificate imported",
"ViewHubParameters.Error.InvalidFile.Text":"Only .pem extension files are allowed",
"ViewHubParameters.Error.issuerCertFile.Text":"Invalid file",
"ViewHubParameters.Error.issuerCertificate.Text":"Invalid name",
"ViewHubParameters.Error.issuerCertValidityYear.Text":"Invalid number",
"ViewHubParameters.Error.oprCertValidityYear.Text":"Invalid number",
"ViewHubParameters.Error.operationalCertificateRequest.Text":"No certificate imported",
"ViewHubParameters.Error.ERRCE0000.Text":"Okay",
"ViewHubParameters.Error.ERRCE0001.Text":"Certificate was expired",
"ViewHubParameters.Error.ERRCE0002.Text":"Certificate was not signed by trusted CA authority",
"ViewHubParameters.Error.ERRCE0003.Text":"Certificate was not well formed or format not supported",
"ViewHubParameters.Error.ERRCE0004.Text":"Error while building certificate chain",
"ViewHubParameters.Error.ERRCE0005.Text":"Certificate was removed",
"ViewHubParameters.Error.ERRCE0006.Text":"Private key does not match with certificate public key",
"ViewHubParameters.Error.ERRCE0007.Text":"Certificate is not a CA authority",
"ViewHubParameters.Error.ERRCE0008.Text":"Internal server error",
"ViewHubParameters.Error.ERRCE0009.Text":"Unknown",
"ViewHubParameters.Error.ERRHE0000.Text":"Okay",
"ViewHubParameters.Error.ERRHE0001.Text":"Port number is already used by another process",
"ViewHubParameters.Error.ERRHE0002.Text":"Port number is not matching with the configured value",
"ViewHubParameters.Error.ERRHE0003.Text":"Internal server error",
"ViewHubParameters.Error.ERRHE0004.Text":"Unknown",
"ViewHubParameters.Error.ERRHE0005.Text":"Invalid Argument",
"ManageBACNetSecureNetworks.Action.Text":"Actions",
"ManageBACNetSecureNetworks.Name.Text":"Name",
"ManageBACNetSecureNetworks.Create.Text":"Create",
"ManageBACNetSecureNetworks.HubURL.Text":"Hub URL",
"ManageBACNetSecureNetworks.ConnectedHubURL.Text":"Connected Hub URL",
"ManageBACNetSecureNetworks.DublicateName.Text":"Name already exist",
"ManageBACNetSecureNetworks.EntryRequired.Text":"An entry is required",
"ManageBACNetSecureNetworks.NameValidationError.Text":"Network name should start with an alphabet, it can contain alphanumeric characters or -",
"ManageBACNetSecureNetworks.SpecialCharacterNotAllowed.Text":"Network name should not contain any special characters or space except -",
"ManageBACNetSecureNetworks.CorrectAllError.Text":"Please correct all errors before continuing.",
"ManageBACNetSecureNetworks.CreateSecureNetworkTitle.Text":"Create Secure Connect BACnet Network",
"ManageBACNetSecureNetworks.NoRecordsFound.Text":"No Records Found",
"ManageBACNetSecureNetworks.Save.Text":"Save",
"ManageBACNetSecureNetworks.Close.Text":"Close",
"ManageBACNetSecureNetworks.DeleteWarningMessage1.Text":"There are 1 or more devices connected to the BACnet Secure Network. If you delete the network, configuration changes will be required for the device.",
"ManageBACNetSecureNetworks.DeleteWarningMessage2.Text":"Are you sure you want to delete the BACnet Secure Network ?",
"ManageBACNetSecureNetworks.DeleteModalTitle.Text":"Delete BACnet Secure Network",
"ManageBACNetSecureNetworks.Cancel.Text":"Cancel",
"ManageBACNetSecureNetworks.Delete.Text":"Delete",
"ManageBACNetSecureNetworks.HeaderTitle.Text":"Manage Secure Connect BACnet Network",
"ManageBACNetSecureNetworks.BuildingName.Text":"Building Name",
"ManageBACNetSecureNetworks.NoRecords.Text":"No Records Found",
"ManageBACNetSecureNetworks.Back.Text":"Back",
"ManageBACNetSecureNetworks.NodeVMAC.Text":"Node VMAC",
"ManageBACNetSecureNetworks.DeviceId.Text":"Device Id",
"ManageBACNetSecureNetworks.DeviceName.Text":"Device Name",
"ManageBACNetSecureNetworks.LastConnectedDate.Text":"Last Connected Date",
"ManageBACNetSecureNetworks.Status.Text":"Status",
"ManageBACNetSecureNetworks.NodeUUID.Text":"Node UUID",
"ManageBACNetSecureNetworks.SecureNetwork.Text":"Secure Network:",
"ManageBACNetSecureNetworks.hubDisabledWarning.Text":"BACnet Secure Connect Hub capabilities are disabled or not configured. Please enable to create a BACnet Secure Connect network.",
"ManageBACNetSecureNetworks.Create.HeaderTitle.Text":"Create New BACnet Secure Connect Link",
"ManageBACNetSecureNetworks.Create.LinkMode.Text":"Link Mode",
"ManageBACNetSecureNetworks.Create.Name.Text":"Name*",
"ManageBACNetSecureNetworks.Create.GenerateCSRTitle.Text":"To begin, genertate a CSR",
"ManageBACNetSecureNetworks.Create.GenerateCALinkTitle.Text":"To begin, Create Link as CA",
"ManageBACNetSecureNetworks.Create.GenerateNewCSR.Text":"Generate New CSR...",
"ManageBACNetSecureNetworks.Create.GenerateLinkAsCA.Text":"Create Link as CA",
"ManageBACNetSecureNetworks.CreateNode.Text":"0,1,2",
"ManageBACNetSecureNetworks.CreateNode.0.Text":"Node",
"ManageBACNetSecureNetworks.CreateNode.1.Text":"Node + Hub",
"ManageBACNetSecureNetworks.CreateNode.2.Text":"Node + Hub + CA",
"ManageBACNetSecureNetworks.Create.Port.Text":"Port*",
"ManageBACNetSecureNetworks.InvalidPort.Text":"Invalid Port",
"ManageBACNetSecureNetworks.InValidRangePort.Text":"Valid Range of Port number is from 1 to 65534",
"ManageBACNetSecureNetworks.Create.Endpoint.Text":"Endpoint",
"ManageCertificateSigning.HeaderTitle.Text":"Manage Certificate Signing Requests",
"ManageCertificateSigning.SubmitCSR.Text":"Submit CSR",
"ManageCertificateSigning.SubjectName.Text":"Subject Name",
"ManageCertificateSigning.Status.Text":"Status",
"ManageCertificateSigning.ValidFrom.Text":"ValidFrom",
"ManageCertificateSigning.ValidTo.Text":"ValidTo",
"ManageCertificateSigning.Description.Text":"Description",
"ManageCertificateSigning.Certificate.Text":"Certificate",
"ManageCertificateSigning.Back.Text":"Back",
"ManageCertificateSigning.UploadModalTitle.Text":"Upload Certificate Signing Request",
"ManageCertificateSigning.CorrectAllError.Text":"Please correct all errors before continuing",
"ManageCertificateSigning.NeedChainCertificate.Text":"Include full certificate chain",
"ManageCertificateSigning.CSRFileName.Text":"CSR File Name:",
"ManageCertificateSigning.ChooseFile.Text":"Choose File",
"ManageCertificateSigning.Description:.Text":"Description:",
"ManageCertificateSigning.Close.Text":"Close",
"ManageCertificateSigning.Submit.Text":"Submit",
"ManageCertificateSigning.NoRecords.Text":"No Records Found",
"ManageCertificateSigning.DeleteModalTitle.Text":"Delete BACnet Secure Network",
"ManageCertificateSigning.DeleteWarning.Text":"Are you sure you want to delete the certificate ?",
"ManageCertificateSigning.Cancel.Text":"Cancel",
"ManageCertificateSigning.Delete.Text":"Delete",
"ManageCertificateSigning.OnlyCSRAllowed.Text":"Only .csr, .pem and .req extension files are allowed",
"ManageCertificateSigning.NoFile.Text":"No file selected",
"ManageCertificateSigning.HeaderTitle.Text":"Manage CSRs",
"ManageCertificateSinging.BodyTitle.Text":"Operational Certificate Validity",
"ManageCertificateSinging.DownloadTitle.Text":"Upload Certificate Signing Request (CSR)",
"ManageCertificateSinging.HintText.Text":"When a CSR is signed it becomes a Operational Certificate",
"ManageCertificateSigning.Port.Text":"Port",
"ManageCertificateSigning.IssuerSubjectName.Text":"Issuer Subject Name (CN)",
"ManageCertificateSigning.IssuerCertificateValidity.Text":"Issuer Certificate Validity",
"ManageCertificateSigning.Error.1.Text":"Hub settings are not configured properly. Please correct invalid settings and try again.",
"ManageCertificateSigning.Error.2.Text":"The file submitted was empty or null. Please select a valid file.",
"ManageCertificateSigning.Error.3.Text":"An internal server error has occurred while generating the signed certificate. Please try again.",
"ManageCertificateSigning.Error.4.Text":"The file submitted does not have valid certificate signing request content. Please choose a different file.",
"ManageCertificateSigning.Error.5.Text":"Unable to generate a signed certificate due to an invalid date range.",
"ManageCertificateSigning.Error.6.Text":"Unable to generate a signed certificate due to an invalid issuer certificate.",
"ManageCertificateSigning.Error.7.Text":"Unable to generate a signed certificate due to insufficient permissions.",
"ManageCertificateSigning.Error.8.Text":"An unknown error has occurred while generating the signed certificate. Please try again.",
"ManageCertificateSigning.Error.OPCERTERR0001.Text":"Hub settings are not configured properly. Please correct invalid settings and try again.",
"ManageCertificateSigning.Error.OPCERTERR0002.Text":"The file submitted was empty or null. Please select a valid file.",
"ManageCertificateSigning.Error.OPCERTERR0003.Text":"An internal server error has occurred while generating the signed certificate. Please try again.",
"ManageCertificateSigning.Error.OPCERTERR0004.Text":"The file submitted does not have valid certificate signing request content. Please choose a different file.",
"ManageCertificateSigning.Error.OPCERTERR0005.Text":"Unable to generate a signed certificate due to an invalid date range.",
"ManageCertificateSigning.Error.OPCERTERR0006.Text":"Unable to generate a signed certificate due to an invalid issuer certificate.",
"ManageCertificateSigning.Error.OPCERTERR0007.Text":"Unable to generate a signed certificate due to insufficient permissions.",
"ManageCertificateSigning.Error.OPCERTERR0008.Text":"An unknown error has occurred while generating the signed certificate. Please try agai",
"ManageCertificateSigning.Error.EntryRequired.Text":"An entry is required",
"AttemptedLogin.ReportTitle.Text":"Attempted Logins",
"AttemptedLogin.NoRecords.Text":"There are no attempted login records for this report.",
"AttemptedLogin.LastLoginAttempt.Text":"Last Login Attempt",
"AttemptedLogin.Username.Text":"Username",
"AttemptedLogin.PreviousAttempts.Text":"Previous Attempts",
"AttemptedLogin.LockedOutTime.Text":"Locked Out Time",
"AttemptedLogin.UserType.Text":"User Type",
"AttemptedLogin.DateGenerated.Text":"Date Generated",

};
export default class Dimensions {
	static Dimension(value) {
		return resourceData[value];
	}
};